/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import {
  z as zod
} from 'zod'


export const postCreateActionBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const postCreateActionBodyPriceMin = 0;


export const postCreateActionBody = zod.object({
  "name": zod.string().regex(postCreateActionBodyNameRegExp),
  "price": zod.number().min(postCreateActionBodyPriceMin),
  "type": zod.enum(['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service'])
})


export const postCreateRecipeBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const postCreateRecipeBodyPriceMin = 0;


export const postCreateRecipeBody = zod.object({
  "name": zod.string().regex(postCreateRecipeBodyNameRegExp),
  "price": zod.number().min(postCreateRecipeBodyPriceMin),
  "type": zod.enum(['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service'])
})


export const postAddActionToRecipeParams = zod.object({
  "id": zod.string()
})

export const postAddActionToRecipeBody = zod.object({
  "actions": zod.array(zod.string())
})


export const postAddArticleToActionParams = zod.object({
  "id": zod.string()
})

export const postAddArticleToActionBody = zod.object({
  "articles": zod.array(zod.string())
})


export const getFetchActionParams = zod.object({
  "id": zod.string()
})

export const getFetchActionResponseNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchActionResponsePriceMin = 0;
export const getFetchActionResponseArticlesItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const getFetchActionResponse = zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchActionResponseNameRegExp).optional(),
  "price": zod.number().min(getFetchActionResponsePriceMin).optional(),
  "type": zod.enum(['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service', 'inspection']).optional(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "created_at": zod.string().date().optional(),
  "articles": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchActionResponseArticlesItemNameRegExp).optional()
})).optional()
})


export const getFetchRecipeParams = zod.object({
  "id": zod.string()
})

export const getFetchRecipeResponseNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchRecipeResponsePriceMin = 0;
export const getFetchRecipeResponseArticlesItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchRecipeResponseActionsItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchRecipeResponseActionsItemPriceMin = 0;


export const getFetchRecipeResponse = zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchRecipeResponseNameRegExp).optional(),
  "price": zod.number().min(getFetchRecipeResponsePriceMin).optional(),
  "type": zod.enum(['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service', 'inspection']).optional(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "contract_eligible": zod.boolean().optional(),
  "created_at": zod.string().date().optional(),
  "articles": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchRecipeResponseArticlesItemNameRegExp).optional()
})).optional(),
  "actions": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchRecipeResponseActionsItemNameRegExp).optional(),
  "price": zod.number().min(getFetchRecipeResponseActionsItemPriceMin).optional(),
  "type": zod.enum(['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service', 'inspection']).optional(),
  "status": zod.enum(['active', 'inactive']).optional()
})).optional()
})


export const postFetchAllActionsQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllActionsBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const postFetchAllActionsBodyPriceMin = 0;


export const postFetchAllActionsBody = zod.object({
  "match_mode": zod.enum(['and', 'or']).optional(),
  "name": zod.string().regex(postFetchAllActionsBodyNameRegExp).nullish(),
  "price": zod.number().min(postFetchAllActionsBodyPriceMin).nullish(),
  "type": zod.enum(['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service']).nullish(),
  "contract_eligible": zod.boolean().nullish()
})

export const postFetchAllActionsResponseDataItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllActionsResponseDataItemPriceMin = 0;


export const postFetchAllActionsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllActionsResponseDataItemNameRegExp).optional(),
  "price": zod.number().min(postFetchAllActionsResponseDataItemPriceMin).optional(),
  "type": zod.enum(['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service', 'inspection']).optional(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "created_at": zod.string().date().optional(),
  "action_type": zod.enum(['recipe', 'action']).optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postFetchAllRecipesQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllRecipesBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const postFetchAllRecipesBodyPriceMin = 0;


export const postFetchAllRecipesBody = zod.object({
  "match_mode": zod.enum(['and', 'or']).optional(),
  "name": zod.string().regex(postFetchAllRecipesBodyNameRegExp).nullish(),
  "price": zod.number().min(postFetchAllRecipesBodyPriceMin).nullish(),
  "type": zod.enum(['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service']).nullish(),
  "contract_eligible": zod.boolean().nullish()
})

export const postFetchAllRecipesResponseDataItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllRecipesResponseDataItemPriceMin = 0;


export const postFetchAllRecipesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllRecipesResponseDataItemNameRegExp).optional(),
  "price": zod.number().min(postFetchAllRecipesResponseDataItemPriceMin).optional(),
  "type": zod.enum(['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service', 'inspection']).optional(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "contract_eligible": zod.boolean().optional(),
  "created_at": zod.string().date().optional(),
  "action_type": zod.enum(['recipe', 'action']).optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postFetchAllAbstractActionsQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllAbstractActionsBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const postFetchAllAbstractActionsBodyPriceMin = 0;


export const postFetchAllAbstractActionsBody = zod.object({
  "match_mode": zod.enum(['and', 'or']).optional(),
  "name": zod.string().regex(postFetchAllAbstractActionsBodyNameRegExp).nullish(),
  "price": zod.number().min(postFetchAllAbstractActionsBodyPriceMin).nullish(),
  "type": zod.enum(['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service']).nullish(),
  "contract_eligible": zod.boolean().nullish()
})

export const postFetchAllAbstractActionsResponseDataItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllAbstractActionsResponseDataItemPriceMin = 0;


export const postFetchAllAbstractActionsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllAbstractActionsResponseDataItemNameRegExp).optional(),
  "price": zod.number().min(postFetchAllAbstractActionsResponseDataItemPriceMin).optional(),
  "type": zod.enum(['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service', 'inspection']).optional(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "created_at": zod.string().date().optional(),
  "action_type": zod.enum(['recipe', 'action']).optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const putUpdateActionParams = zod.object({
  "id": zod.string()
})

export const putUpdateActionBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const putUpdateActionBodyPriceMin = 0;


export const putUpdateActionBody = zod.object({
  "name": zod.string().regex(putUpdateActionBodyNameRegExp),
  "price": zod.number().min(putUpdateActionBodyPriceMin),
  "type": zod.enum(['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service'])
})


export const patchPatchActionParams = zod.object({
  "id": zod.string()
})

export const patchPatchActionBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const patchPatchActionBodyPriceMin = 0;


export const patchPatchActionBody = zod.object({
  "name": zod.string().regex(patchPatchActionBodyNameRegExp).nullish(),
  "price": zod.number().min(patchPatchActionBodyPriceMin).nullish(),
  "type": zod.enum(['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service']).nullish()
})


export const postUpdateActionStatusParams = zod.object({
  "id": zod.string()
})

export const postUpdateActionStatusBody = zod.object({
  "status": zod.enum(['active', 'inactive'])
})


export const getFetchArticleParams = zod.object({
  "id": zod.string()
})

export const getFetchArticleResponseNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchArticleResponseMinimumMarginMin = 0;
export const getFetchArticleResponseSalePriceMin = 0;
export const getFetchArticleResponsePreferredArticleOptionExternalReferenceRegExp = new RegExp('[^a-zA-Z0-9\\s]');
export const getFetchArticleResponsePreferredArticleOptionBrandNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchArticleResponsePreferredArticleOptionCodeRegExp = new RegExp('^[a-zA-Z0-9\\-_+\\s]+$');
export const getFetchArticleResponsePreferredArticleOptionPurchaseGrossPriceMin = 0;
export const getFetchArticleResponsePreferredArticleOptionPurchaseNetPriceMin = 0;
export const getFetchArticleResponsePreferredArticleOptionPurchaseDiscountMin = 0;
export const getFetchArticleResponsePreferredArticleOptionLocationRegExp = new RegExp('^[a-zA-Z0-9\\s]+$');
export const getFetchArticleResponsePreferredArticleOptionSupplierExternalReferenceRegExp = new RegExp('[^a-zA-Z0-9\\s]');
export const getFetchArticleResponsePreferredArticleOptionSupplierNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchArticleResponseArticleOptionsItemExternalReferenceRegExp = new RegExp('[^a-zA-Z0-9\\s]');
export const getFetchArticleResponseArticleOptionsItemBrandNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchArticleResponseArticleOptionsItemCodeRegExp = new RegExp('^[a-zA-Z0-9\\-_+\\s]+$');
export const getFetchArticleResponseArticleOptionsItemPurchaseGrossPriceMin = 0;
export const getFetchArticleResponseArticleOptionsItemPurchaseNetPriceMin = 0;
export const getFetchArticleResponseArticleOptionsItemPurchaseDiscountMin = 0;
export const getFetchArticleResponseArticleOptionsItemLocationRegExp = new RegExp('^[a-zA-Z0-9\\s]+$');
export const getFetchArticleResponseArticleOptionsItemSupplierExternalReferenceRegExp = new RegExp('[^a-zA-Z0-9\\s]');
export const getFetchArticleResponseArticleOptionsItemSupplierNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const getFetchArticleResponse = zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchArticleResponseNameRegExp).optional(),
  "measurement": zod.enum(['liter', 'kilogram', 'piece']).optional(),
  "minimum_margin": zod.number().min(getFetchArticleResponseMinimumMarginMin).nullish(),
  "sale_price": zod.number().min(getFetchArticleResponseSalePriceMin).nullish(),
  "description": zod.string().nullish(),
  "preferred_article_option": zod.object({
  "id": zod.string().optional(),
  "external_reference": zod.string().regex(getFetchArticleResponsePreferredArticleOptionExternalReferenceRegExp).optional(),
  "brand_name": zod.string().regex(getFetchArticleResponsePreferredArticleOptionBrandNameRegExp).optional(),
  "code": zod.string().regex(getFetchArticleResponsePreferredArticleOptionCodeRegExp).optional(),
  "purchase_gross_price": zod.number().min(getFetchArticleResponsePreferredArticleOptionPurchaseGrossPriceMin).optional(),
  "purchase_net_price": zod.number().min(getFetchArticleResponsePreferredArticleOptionPurchaseNetPriceMin).optional(),
  "purchase_discount": zod.number().min(getFetchArticleResponsePreferredArticleOptionPurchaseDiscountMin).nullish(),
  "location": zod.string().regex(getFetchArticleResponsePreferredArticleOptionLocationRegExp).nullish(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "supplier": zod.object({
  "id": zod.string().optional(),
  "external_reference": zod.string().regex(getFetchArticleResponsePreferredArticleOptionSupplierExternalReferenceRegExp).optional(),
  "name": zod.string().regex(getFetchArticleResponsePreferredArticleOptionSupplierNameRegExp).optional()
}).optional()
}).nullish(),
  "article_options": zod.array(zod.object({
  "id": zod.string().optional(),
  "external_reference": zod.string().regex(getFetchArticleResponseArticleOptionsItemExternalReferenceRegExp).optional(),
  "brand_name": zod.string().regex(getFetchArticleResponseArticleOptionsItemBrandNameRegExp).optional(),
  "code": zod.string().regex(getFetchArticleResponseArticleOptionsItemCodeRegExp).optional(),
  "purchase_gross_price": zod.number().min(getFetchArticleResponseArticleOptionsItemPurchaseGrossPriceMin).optional(),
  "purchase_net_price": zod.number().min(getFetchArticleResponseArticleOptionsItemPurchaseNetPriceMin).optional(),
  "purchase_discount": zod.number().min(getFetchArticleResponseArticleOptionsItemPurchaseDiscountMin).nullish(),
  "location": zod.string().regex(getFetchArticleResponseArticleOptionsItemLocationRegExp).nullish(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "supplier": zod.object({
  "id": zod.string().optional(),
  "external_reference": zod.string().regex(getFetchArticleResponseArticleOptionsItemSupplierExternalReferenceRegExp).optional(),
  "name": zod.string().regex(getFetchArticleResponseArticleOptionsItemSupplierNameRegExp).optional()
}).optional()
})).optional()
})


export const patchPatchArticleParams = zod.object({
  "id": zod.string()
})

export const patchPatchArticleBodySalePriceMin = 0;
export const patchPatchArticleBodyMinimumMarginMin = 0;
export const patchPatchArticleBodyPurchaseDiscountMin = 0;


export const patchPatchArticleBody = zod.object({
  "name": zod.string().nullish(),
  "sale_price": zod.number().min(patchPatchArticleBodySalePriceMin).nullish(),
  "measurement": zod.enum(['liter', 'kilogram', 'piece']).nullish(),
  "minimum_margin": zod.number().min(patchPatchArticleBodyMinimumMarginMin).nullish(),
  "purchase_discount": zod.number().min(patchPatchArticleBodyPurchaseDiscountMin).nullish(),
  "preferred_article_option_id": zod.string().nullish(),
  "description": zod.string().nullish()
})


export const getFetchArticleByArticleOptionExternalIdParams = zod.object({
  "external_id": zod.string()
})

export const getFetchArticleByArticleOptionExternalIdResponseNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchArticleByArticleOptionExternalIdResponseMinimumMarginMin = 0;
export const getFetchArticleByArticleOptionExternalIdResponseSalePriceMin = 0;
export const getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionExternalReferenceRegExp = new RegExp('[^a-zA-Z0-9\\s]');
export const getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionBrandNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionCodeRegExp = new RegExp('^[a-zA-Z0-9\\-_+\\s]+$');
export const getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionPurchaseGrossPriceMin = 0;
export const getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionPurchaseNetPriceMin = 0;
export const getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionPurchaseDiscountMin = 0;
export const getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionLocationRegExp = new RegExp('^[a-zA-Z0-9\\s]+$');
export const getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionSupplierExternalReferenceRegExp = new RegExp('[^a-zA-Z0-9\\s]');
export const getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionSupplierNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemExternalReferenceRegExp = new RegExp('[^a-zA-Z0-9\\s]');
export const getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemBrandNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemCodeRegExp = new RegExp('^[a-zA-Z0-9\\-_+\\s]+$');
export const getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemPurchaseGrossPriceMin = 0;
export const getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemPurchaseNetPriceMin = 0;
export const getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemPurchaseDiscountMin = 0;
export const getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemLocationRegExp = new RegExp('^[a-zA-Z0-9\\s]+$');
export const getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemSupplierExternalReferenceRegExp = new RegExp('[^a-zA-Z0-9\\s]');
export const getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemSupplierNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const getFetchArticleByArticleOptionExternalIdResponse = zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchArticleByArticleOptionExternalIdResponseNameRegExp).optional(),
  "measurement": zod.enum(['liter', 'kilogram', 'piece']).optional(),
  "minimum_margin": zod.number().min(getFetchArticleByArticleOptionExternalIdResponseMinimumMarginMin).nullish(),
  "sale_price": zod.number().min(getFetchArticleByArticleOptionExternalIdResponseSalePriceMin).nullish(),
  "description": zod.string().nullish(),
  "preferred_article_option": zod.object({
  "id": zod.string().optional(),
  "external_reference": zod.string().regex(getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionExternalReferenceRegExp).optional(),
  "brand_name": zod.string().regex(getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionBrandNameRegExp).optional(),
  "code": zod.string().regex(getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionCodeRegExp).optional(),
  "purchase_gross_price": zod.number().min(getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionPurchaseGrossPriceMin).optional(),
  "purchase_net_price": zod.number().min(getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionPurchaseNetPriceMin).optional(),
  "purchase_discount": zod.number().min(getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionPurchaseDiscountMin).nullish(),
  "location": zod.string().regex(getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionLocationRegExp).nullish(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "supplier": zod.object({
  "id": zod.string().optional(),
  "external_reference": zod.string().regex(getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionSupplierExternalReferenceRegExp).optional(),
  "name": zod.string().regex(getFetchArticleByArticleOptionExternalIdResponsePreferredArticleOptionSupplierNameRegExp).optional()
}).optional()
}).nullish(),
  "article_options": zod.array(zod.object({
  "id": zod.string().optional(),
  "external_reference": zod.string().regex(getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemExternalReferenceRegExp).optional(),
  "brand_name": zod.string().regex(getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemBrandNameRegExp).optional(),
  "code": zod.string().regex(getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemCodeRegExp).optional(),
  "purchase_gross_price": zod.number().min(getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemPurchaseGrossPriceMin).optional(),
  "purchase_net_price": zod.number().min(getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemPurchaseNetPriceMin).optional(),
  "purchase_discount": zod.number().min(getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemPurchaseDiscountMin).nullish(),
  "location": zod.string().regex(getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemLocationRegExp).nullish(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "supplier": zod.object({
  "id": zod.string().optional(),
  "external_reference": zod.string().regex(getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemSupplierExternalReferenceRegExp).optional(),
  "name": zod.string().regex(getFetchArticleByArticleOptionExternalIdResponseArticleOptionsItemSupplierNameRegExp).optional()
}).optional()
})).optional()
})


export const postFetchAllArticlesQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllArticlesBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const postFetchAllArticlesBodySalePriceMin = 0;
export const postFetchAllArticlesBodyMinimumMarginMin = 0;


export const postFetchAllArticlesBody = zod.object({
  "match_mode": zod.enum(['and', 'or']).optional(),
  "name": zod.string().regex(postFetchAllArticlesBodyNameRegExp).nullish(),
  "sale_price": zod.number().min(postFetchAllArticlesBodySalePriceMin).nullish(),
  "measurement": zod.enum(['liter', 'kilogram', 'piece']).nullish(),
  "minimum_margin": zod.number().min(postFetchAllArticlesBodyMinimumMarginMin).nullish(),
  "description": zod.string().nullish(),
  "external_reference": zod.string().nullish()
})

export const postFetchAllArticlesResponseDataItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllArticlesResponseDataItemMinimumMarginMin = 0;
export const postFetchAllArticlesResponseDataItemSalePriceMin = 0;
export const postFetchAllArticlesResponseDataItemPreferredArticleOptionExternalReferenceRegExp = new RegExp('[^a-zA-Z0-9\\s]');
export const postFetchAllArticlesResponseDataItemPreferredArticleOptionBrandNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllArticlesResponseDataItemPreferredArticleOptionCodeRegExp = new RegExp('^[a-zA-Z0-9\\-_+\\s]+$');


export const postFetchAllArticlesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllArticlesResponseDataItemNameRegExp).optional(),
  "measurement": zod.enum(['liter', 'kilogram', 'piece']).optional(),
  "minimum_margin": zod.number().min(postFetchAllArticlesResponseDataItemMinimumMarginMin).nullish(),
  "sale_price": zod.number().min(postFetchAllArticlesResponseDataItemSalePriceMin).nullish(),
  "description": zod.string().nullish(),
  "preferred_article_option": zod.object({
  "id": zod.string().optional(),
  "external_reference": zod.string().regex(postFetchAllArticlesResponseDataItemPreferredArticleOptionExternalReferenceRegExp).optional(),
  "brand_name": zod.string().regex(postFetchAllArticlesResponseDataItemPreferredArticleOptionBrandNameRegExp).optional(),
  "code": zod.string().regex(postFetchAllArticlesResponseDataItemPreferredArticleOptionCodeRegExp).optional()
}).nullish()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postCreateArticleBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const postCreateArticleBodyMinimumMarginMin = 0;
export const postCreateArticleBodySalePriceMin = 0;


export const postCreateArticleBody = zod.object({
  "name": zod.string().regex(postCreateArticleBodyNameRegExp),
  "measurement": zod.enum(['liter', 'kilogram', 'piece']),
  "minimum_margin": zod.number().min(postCreateArticleBodyMinimumMarginMin).nullish(),
  "preferred_article_option_id": zod.string().nullish(),
  "sale_price": zod.number().min(postCreateArticleBodySalePriceMin).nullish(),
  "description": zod.string().nullish()
})


export const postCreateSupplierBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const postCreateSupplierBodyExternalReferenceRegExp = new RegExp('.*[a-zA-Z0-9\\s].*');


export const postCreateSupplierBody = zod.object({
  "name": zod.string().regex(postCreateSupplierBodyNameRegExp),
  "external_reference": zod.string().regex(postCreateSupplierBodyExternalReferenceRegExp)
})


export const getFetchSupplierParams = zod.object({
  "id": zod.string()
})

export const getFetchSupplierResponseNameRegExp = new RegExp('[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const getFetchSupplierResponse = zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchSupplierResponseNameRegExp).optional(),
  "external_reference": zod.string().optional(),
  "created_at": zod.string().date().optional()
})


export const putUpdateSupplierParams = zod.object({
  "id": zod.string()
})

export const putUpdateSupplierBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const putUpdateSupplierBodyExternalReferenceRegExp = new RegExp('.*[a-zA-Z0-9\\s].*');


export const putUpdateSupplierBody = zod.object({
  "name": zod.string().regex(putUpdateSupplierBodyNameRegExp),
  "external_reference": zod.string().regex(putUpdateSupplierBodyExternalReferenceRegExp)
})


export const postFetchAllSupplierQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllSupplierResponseDataItemNameRegExp = new RegExp('[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const postFetchAllSupplierResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllSupplierResponseDataItemNameRegExp).optional(),
  "external_reference": zod.string().optional(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postCreateSaleHistoryBodyPriceMin = 0;
export const postCreateSaleHistoryBodyQuantityMin = 0;


export const postCreateSaleHistoryBody = zod.object({
  "price": zod.number().min(postCreateSaleHistoryBodyPriceMin),
  "quantity": zod.number().min(postCreateSaleHistoryBodyQuantityMin),
  "sale_date": zod.string().date(),
  "ticket_id": zod.string(),
  "article_id": zod.string(),
  "description": zod.string().nullish()
})


export const postFetchAllSaleHistoriesQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllSaleHistoriesBody = zod.object({
  "article_id": zod.string()
})

export const postFetchAllSaleHistoriesResponseDataItemPriceMin = 0;
export const postFetchAllSaleHistoriesResponseDataItemQuantityMin = 0;
export const postFetchAllSaleHistoriesResponseDataItemArticleNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllSaleHistoriesResponseDataItemArticleMinimumMarginMin = 0;
export const postFetchAllSaleHistoriesResponseDataItemArticleSalePriceMin = 0;


export const postFetchAllSaleHistoriesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "price": zod.number().min(postFetchAllSaleHistoriesResponseDataItemPriceMin).optional(),
  "quantity": zod.number().min(postFetchAllSaleHistoriesResponseDataItemQuantityMin).optional(),
  "article": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllSaleHistoriesResponseDataItemArticleNameRegExp).optional(),
  "measurement": zod.enum(['liter', 'kilogram', 'piece']).optional(),
  "minimum_margin": zod.number().min(postFetchAllSaleHistoriesResponseDataItemArticleMinimumMarginMin).nullish(),
  "sale_price": zod.number().min(postFetchAllSaleHistoriesResponseDataItemArticleSalePriceMin).nullish()
}).optional(),
  "sale_date": zod.string().date().optional(),
  "ticket_id": zod.string().optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postFetchAllPurchaseHistoriesQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllPurchaseHistoriesBody = zod.object({
  "article_id": zod.string()
})

export const postFetchAllPurchaseHistoriesResponseDataItemArticleNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllPurchaseHistoriesResponseDataItemArticleMinimumMarginMin = 0;
export const postFetchAllPurchaseHistoriesResponseDataItemArticleSalePriceMin = 0;
export const postFetchAllPurchaseHistoriesResponseDataItemPriceMin = 0;
export const postFetchAllPurchaseHistoriesResponseDataItemPricePerUnitMin = 0;
export const postFetchAllPurchaseHistoriesResponseDataItemQuantityMin = 0;
export const postFetchAllPurchaseHistoriesResponseDataItemSupplierExternalReferenceRegExp = new RegExp('[^a-zA-Z0-9\\s]');
export const postFetchAllPurchaseHistoriesResponseDataItemSupplierNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const postFetchAllPurchaseHistoriesResponseItem = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "article": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllPurchaseHistoriesResponseDataItemArticleNameRegExp).optional(),
  "measurement": zod.enum(['liter', 'kilogram', 'piece']).optional(),
  "minimum_margin": zod.number().min(postFetchAllPurchaseHistoriesResponseDataItemArticleMinimumMarginMin).nullish(),
  "sale_price": zod.number().min(postFetchAllPurchaseHistoriesResponseDataItemArticleSalePriceMin).nullish()
}).optional(),
  "price": zod.number().min(postFetchAllPurchaseHistoriesResponseDataItemPriceMin).optional(),
  "price_per_unit": zod.number().min(postFetchAllPurchaseHistoriesResponseDataItemPricePerUnitMin).optional(),
  "quantity": zod.number().min(postFetchAllPurchaseHistoriesResponseDataItemQuantityMin).optional(),
  "purchase_date": zod.string().date().optional(),
  "supplier": zod.object({
  "id": zod.string().optional(),
  "external_reference": zod.string().regex(postFetchAllPurchaseHistoriesResponseDataItemSupplierExternalReferenceRegExp).optional(),
  "name": zod.string().regex(postFetchAllPurchaseHistoriesResponseDataItemSupplierNameRegExp).optional()
}).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})
export const postFetchAllPurchaseHistoriesResponse = zod.array(postFetchAllPurchaseHistoriesResponseItem)


export const postCreatePurchaseHistoryBodyPriceMin = 0;
export const postCreatePurchaseHistoryBodyPricePerUnitMin = 0;
export const postCreatePurchaseHistoryBodyQuantityMin = 0;


export const postCreatePurchaseHistoryBody = zod.object({
  "price": zod.number().min(postCreatePurchaseHistoryBodyPriceMin),
  "price_per_unit": zod.number().min(postCreatePurchaseHistoryBodyPricePerUnitMin),
  "quantity": zod.number().min(postCreatePurchaseHistoryBodyQuantityMin),
  "purchase_date": zod.string().date(),
  "supplier_id": zod.string(),
  "article_id": zod.string(),
  "description": zod.string().nullish()
})


export const postUpdateArticleOptionStatusParams = zod.object({
  "id": zod.string()
})

export const postUpdateArticleOptionStatusBody = zod.object({
  "status": zod.enum(['active', 'inactive'])
})


/**
 * @summary Create an article option
 */
export const postCreateArticleOptionBodyBrandNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const postCreateArticleOptionBodyExternalReferenceRegExp = new RegExp('.*[a-zA-Z0-9\\s].*');
export const postCreateArticleOptionBodyCodeRegExp = new RegExp('.*[a-zA-Z0-9\\-_+\\s]+');
export const postCreateArticleOptionBodyPurchaseGrossPriceMin = 0;
export const postCreateArticleOptionBodyPurchaseNetPriceMin = 0;
export const postCreateArticleOptionBodyLocationRegExp = new RegExp('.*[a-zA-Z0-9\\s]+');
export const postCreateArticleOptionBodyPurchaseDiscountMin = 0;


export const postCreateArticleOptionBody = zod.object({
  "brand_name": zod.string().regex(postCreateArticleOptionBodyBrandNameRegExp),
  "external_reference": zod.string().regex(postCreateArticleOptionBodyExternalReferenceRegExp),
  "code": zod.string().regex(postCreateArticleOptionBodyCodeRegExp),
  "purchase_gross_price": zod.number().min(postCreateArticleOptionBodyPurchaseGrossPriceMin),
  "purchase_net_price": zod.number().min(postCreateArticleOptionBodyPurchaseNetPriceMin),
  "supplier_id": zod.string().uuid(),
  "article_id": zod.string().uuid(),
  "location": zod.string().regex(postCreateArticleOptionBodyLocationRegExp).nullish(),
  "purchase_discount": zod.number().min(postCreateArticleOptionBodyPurchaseDiscountMin).nullish()
})


/**
 * @summary Fetch an article option by id
 */
export const getFetchArticleOptionParams = zod.object({
  "id": zod.string().uuid()
})

export const getFetchArticleOptionResponseNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchArticleOptionResponseSalePriceMin = 0;
export const getFetchArticleOptionResponseExternalReferenceRegExp = new RegExp('[^a-zA-Z0-9\\s]');
export const getFetchArticleOptionResponseBrandNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchArticleOptionResponseCodeRegExp = new RegExp('^[a-zA-Z0-9\\-_+\\s]+$');
export const getFetchArticleOptionResponsePurchaseGrossPriceMin = 0;
export const getFetchArticleOptionResponsePurchaseNetPriceMin = 0;
export const getFetchArticleOptionResponsePurchaseDiscountMin = 0;
export const getFetchArticleOptionResponseLocationRegExp = new RegExp('^[a-zA-Z0-9\\s]+$');
export const getFetchArticleOptionResponseSupplierExternalReferenceRegExp = new RegExp('[^a-zA-Z0-9\\s]');
export const getFetchArticleOptionResponseSupplierNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const getFetchArticleOptionResponse = zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchArticleOptionResponseNameRegExp).optional(),
  "sale_price": zod.number().min(getFetchArticleOptionResponseSalePriceMin).nullish(),
  "measurement": zod.enum(['liter', 'kilogram', 'piece']).optional(),
  "external_reference": zod.string().regex(getFetchArticleOptionResponseExternalReferenceRegExp).optional(),
  "brand_name": zod.string().regex(getFetchArticleOptionResponseBrandNameRegExp).optional(),
  "code": zod.string().regex(getFetchArticleOptionResponseCodeRegExp).optional(),
  "purchase_gross_price": zod.number().min(getFetchArticleOptionResponsePurchaseGrossPriceMin).optional(),
  "purchase_net_price": zod.number().min(getFetchArticleOptionResponsePurchaseNetPriceMin).optional(),
  "purchase_discount": zod.number().min(getFetchArticleOptionResponsePurchaseDiscountMin).nullish(),
  "location": zod.string().regex(getFetchArticleOptionResponseLocationRegExp).nullish(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "supplier": zod.object({
  "id": zod.string().optional(),
  "external_reference": zod.string().regex(getFetchArticleOptionResponseSupplierExternalReferenceRegExp).optional(),
  "name": zod.string().regex(getFetchArticleOptionResponseSupplierNameRegExp).optional()
}).optional()
})


/**
 * @summary Update an article option
 */
export const patchPatchArticleOptionParams = zod.object({
  "id": zod.string().uuid()
})

export const patchPatchArticleOptionBodyPurchaseGrossPriceMin = 0;
export const patchPatchArticleOptionBodyPurchaseNetPriceMin = 0;
export const patchPatchArticleOptionBodyPurchaseDiscountMin = 0;


export const patchPatchArticleOptionBody = zod.object({
  "external_reference": zod.string().nullish(),
  "brand_name": zod.string().nullish(),
  "code": zod.string().nullish(),
  "purchase_gross_price": zod.number().min(patchPatchArticleOptionBodyPurchaseGrossPriceMin).nullish(),
  "purchase_net_price": zod.number().min(patchPatchArticleOptionBodyPurchaseNetPriceMin).nullish(),
  "location": zod.string().nullish(),
  "purchase_discount": zod.number().min(patchPatchArticleOptionBodyPurchaseDiscountMin).nullish()
})


export const postAddArticleOptionToArticleParams = zod.object({
  "id": zod.string()
})

export const postAddArticleOptionToArticleBody = zod.object({
  "article_option_ids": zod.array(zod.string())
})


export const deleteRemoveArticleOptionFromArticleParams = zod.object({
  "id": zod.string(),
  "article_option_id": zod.string()
})


export const getFetchAddressParams = zod.object({
  "id": zod.string()
})

export const getFetchAddressResponseStreetRegExp = new RegExp('[a-zA-Z\\s\\-\\`\']');
export const getFetchAddressResponseHouseNumberMin = 0;
export const getFetchAddressResponsePostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');
export const getFetchAddressResponseCityRegExp = new RegExp('[a-zA-Z\\s\'\\-]');
export const getFetchAddressResponseCountryRegExp = new RegExp('[a-zA-Z\\s]');
export const getFetchAddressResponseContactDetailPhoneNumberMin = 5;

export const getFetchAddressResponseContactDetailPhoneNumberMax = 15;

export const getFetchAddressResponseContactDetailPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchAddressResponseContactDetailMobilePhoneNumberMin = 5;

export const getFetchAddressResponseContactDetailMobilePhoneNumberMax = 15;

export const getFetchAddressResponseContactDetailMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchAddressResponseHouseNumberExtensionRegExp = new RegExp('[a-zA-Z0-9\\s\\-]');


export const getFetchAddressResponse = zod.object({
  "id": zod.string().optional(),
  "street": zod.string().regex(getFetchAddressResponseStreetRegExp).optional(),
  "house_number": zod.number().min(getFetchAddressResponseHouseNumberMin).optional(),
  "post_code": zod.string().regex(getFetchAddressResponsePostCodeRegExp).optional(),
  "city": zod.string().regex(getFetchAddressResponseCityRegExp).optional(),
  "country": zod.string().regex(getFetchAddressResponseCountryRegExp).optional(),
  "contact_detail": zod.object({
  "id": zod.string().optional(),
  "phone_number": zod.string().min(getFetchAddressResponseContactDetailPhoneNumberMin).max(getFetchAddressResponseContactDetailPhoneNumberMax).regex(getFetchAddressResponseContactDetailPhoneNumberRegExp).optional(),
  "mobile_phone_number": zod.string().min(getFetchAddressResponseContactDetailMobilePhoneNumberMin).max(getFetchAddressResponseContactDetailMobilePhoneNumberMax).regex(getFetchAddressResponseContactDetailMobilePhoneNumberRegExp).optional(),
  "email": zod.string().optional()
}).optional(),
  "house_number_extension": zod.string().regex(getFetchAddressResponseHouseNumberExtensionRegExp).nullish(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})


export const postFetchAllAddressesQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllAddressesResponseDataItemStreetRegExp = new RegExp('[a-zA-Z\\s\\-\\`\']');
export const postFetchAllAddressesResponseDataItemHouseNumberMin = 0;
export const postFetchAllAddressesResponseDataItemPostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');
export const postFetchAllAddressesResponseDataItemCityRegExp = new RegExp('[a-zA-Z\\s\'\\-]');
export const postFetchAllAddressesResponseDataItemCountryRegExp = new RegExp('[a-zA-Z\\s]');
export const postFetchAllAddressesResponseDataItemContactDetailPhoneNumberMin = 5;

export const postFetchAllAddressesResponseDataItemContactDetailPhoneNumberMax = 15;

export const postFetchAllAddressesResponseDataItemContactDetailPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllAddressesResponseDataItemContactDetailMobilePhoneNumberMin = 5;

export const postFetchAllAddressesResponseDataItemContactDetailMobilePhoneNumberMax = 15;

export const postFetchAllAddressesResponseDataItemContactDetailMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllAddressesResponseDataItemHouseNumberExtensionRegExp = new RegExp('[a-zA-Z0-9\\s\\-]');


export const postFetchAllAddressesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "street": zod.string().regex(postFetchAllAddressesResponseDataItemStreetRegExp).optional(),
  "house_number": zod.number().min(postFetchAllAddressesResponseDataItemHouseNumberMin).optional(),
  "post_code": zod.string().regex(postFetchAllAddressesResponseDataItemPostCodeRegExp).optional(),
  "city": zod.string().regex(postFetchAllAddressesResponseDataItemCityRegExp).optional(),
  "country": zod.string().regex(postFetchAllAddressesResponseDataItemCountryRegExp).optional(),
  "contact_detail": zod.object({
  "id": zod.string().optional(),
  "phone_number": zod.string().min(postFetchAllAddressesResponseDataItemContactDetailPhoneNumberMin).max(postFetchAllAddressesResponseDataItemContactDetailPhoneNumberMax).regex(postFetchAllAddressesResponseDataItemContactDetailPhoneNumberRegExp).optional(),
  "mobile_phone_number": zod.string().min(postFetchAllAddressesResponseDataItemContactDetailMobilePhoneNumberMin).max(postFetchAllAddressesResponseDataItemContactDetailMobilePhoneNumberMax).regex(postFetchAllAddressesResponseDataItemContactDetailMobilePhoneNumberRegExp).optional(),
  "email": zod.string().optional()
}).optional(),
  "house_number_extension": zod.string().regex(postFetchAllAddressesResponseDataItemHouseNumberExtensionRegExp).nullish(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postCreateAddressBodyStreetRegExp = new RegExp('.*[a-zA-Z\\s\\-\\`\'].*');
export const postCreateAddressBodyHouseNumberMin = 0;
export const postCreateAddressBodyCityRegExp = new RegExp('.*[a-zA-Z\\s\'\\-].*');
export const postCreateAddressBodyCountryRegExp = new RegExp('.*[a-zA-Z\\s].*');
export const postCreateAddressBodyHouseNumberExtensionRegExp = new RegExp('.*[a-zA-Z0-9\\s\\-].*');


export const postCreateAddressBody = zod.object({
  "street": zod.string().regex(postCreateAddressBodyStreetRegExp),
  "house_number": zod.number().min(postCreateAddressBodyHouseNumberMin),
  "post_code": zod.string(),
  "city": zod.string().regex(postCreateAddressBodyCityRegExp),
  "country": zod.string().regex(postCreateAddressBodyCountryRegExp),
  "contact_detail_id": zod.string(),
  "house_number_extension": zod.string().regex(postCreateAddressBodyHouseNumberExtensionRegExp).nullish(),
  "description": zod.string().optional()
})


export const getFetchOrganisationParams = zod.object({
  "id": zod.string()
})

export const getFetchOrganisationResponseNumberMin = 0;
export const getFetchOrganisationResponseNameMin = 3;

export const getFetchOrganisationResponseNameMax = 127;

export const getFetchOrganisationResponseNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchOrganisationResponseVatNumberRegExp = new RegExp('[a-zA-Z0-9\\s]');
export const getFetchOrganisationResponseChamberOfCommerceNumberRegExp = new RegExp('^[0-9\\s]+$');
export const getFetchOrganisationResponseContactPersonsItemInitialRegExp = new RegExp('[^A-Z.]');
export const getFetchOrganisationResponseContactPersonsItemFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchOrganisationResponseContactPersonsItemMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const getFetchOrganisationResponseContactPersonsItemLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchOrganisationResponseContactPersonsItemPhoneNumberMin = 5;

export const getFetchOrganisationResponseContactPersonsItemPhoneNumberMax = 15;

export const getFetchOrganisationResponseContactPersonsItemPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchOrganisationResponseContactPersonsItemMobilePhoneNumberMin = 5;

export const getFetchOrganisationResponseContactPersonsItemMobilePhoneNumberMax = 15;

export const getFetchOrganisationResponseContactPersonsItemMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchOrganisationResponseBranchesItemStreetRegExp = new RegExp('[^a-zA-Z\\s\\-\\`\']');
export const getFetchOrganisationResponseBranchesItemHouseNumberMin = 0;
export const getFetchOrganisationResponseBranchesItemPostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');
export const getFetchOrganisationResponseBranchesItemCityRegExp = new RegExp('[^a-zA-Z\\s\'\\-]');
export const getFetchOrganisationResponseBranchesItemCountryRegExp = new RegExp('[^a-zA-Z\\s]');
export const getFetchOrganisationResponseBranchesItemHouseNumberExtensionRegExp = new RegExp('[^a-zA-Z0-9\\s\\-]');
export const getFetchOrganisationResponseTransportRideAmountMin = 0;
export const getFetchOrganisationResponseAddressStreetRegExp = new RegExp('[^a-zA-Z\\s\\-\\`\']');
export const getFetchOrganisationResponseAddressHouseNumberMin = 0;
export const getFetchOrganisationResponseAddressPostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');
export const getFetchOrganisationResponseAddressCityRegExp = new RegExp('[^a-zA-Z\\s\'\\-]');
export const getFetchOrganisationResponseAddressCountryRegExp = new RegExp('[^a-zA-Z\\s]');
export const getFetchOrganisationResponseAddressHouseNumberExtensionRegExp = new RegExp('[^a-zA-Z0-9\\s\\-]');
export const getFetchOrganisationResponseAddressContactDetailPhoneNumberMin = 5;

export const getFetchOrganisationResponseAddressContactDetailPhoneNumberMax = 15;

export const getFetchOrganisationResponseAddressContactDetailPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchOrganisationResponseAddressContactDetailMobilePhoneNumberMin = 5;

export const getFetchOrganisationResponseAddressContactDetailMobilePhoneNumberMax = 15;

export const getFetchOrganisationResponseAddressContactDetailMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchOrganisationResponseInvoiceAddressStreetRegExp = new RegExp('[^a-zA-Z\\s\\-\\`\']');
export const getFetchOrganisationResponseInvoiceAddressHouseNumberMin = 0;
export const getFetchOrganisationResponseInvoiceAddressPostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');
export const getFetchOrganisationResponseInvoiceAddressCityRegExp = new RegExp('[^a-zA-Z\\s\'\\-]');
export const getFetchOrganisationResponseInvoiceAddressCountryRegExp = new RegExp('[^a-zA-Z\\s]');
export const getFetchOrganisationResponseInvoiceAddressHouseNumberExtensionRegExp = new RegExp('[^a-zA-Z0-9\\s\\-]');
export const getFetchOrganisationResponseInvoiceAddressContactDetailPhoneNumberMin = 5;

export const getFetchOrganisationResponseInvoiceAddressContactDetailPhoneNumberMax = 15;

export const getFetchOrganisationResponseInvoiceAddressContactDetailPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchOrganisationResponseInvoiceAddressContactDetailMobilePhoneNumberMin = 5;

export const getFetchOrganisationResponseInvoiceAddressContactDetailMobilePhoneNumberMax = 15;

export const getFetchOrganisationResponseInvoiceAddressContactDetailMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');


export const getFetchOrganisationResponse = zod.object({
  "id": zod.string().optional(),
  "number": zod.number().min(getFetchOrganisationResponseNumberMin).optional(),
  "name": zod.string().min(getFetchOrganisationResponseNameMin).max(getFetchOrganisationResponseNameMax).regex(getFetchOrganisationResponseNameRegExp).optional(),
  "vat_number": zod.string().regex(getFetchOrganisationResponseVatNumberRegExp).optional(),
  "chamber_of_commerce_number": zod.string().regex(getFetchOrganisationResponseChamberOfCommerceNumberRegExp).optional(),
  "contact_persons": zod.array(zod.object({
  "id": zod.string().optional(),
  "salutation": zod.enum(['Mr', 'Ms', 'Mrs']).optional(),
  "initial": zod.string().regex(getFetchOrganisationResponseContactPersonsItemInitialRegExp).optional(),
  "first_name": zod.string().regex(getFetchOrganisationResponseContactPersonsItemFirstNameRegExp).optional(),
  "middle_name": zod.string().regex(getFetchOrganisationResponseContactPersonsItemMiddleNameRegExp).nullish(),
  "last_name": zod.string().regex(getFetchOrganisationResponseContactPersonsItemLastNameRegExp).optional(),
  "phone_number": zod.string().min(getFetchOrganisationResponseContactPersonsItemPhoneNumberMin).max(getFetchOrganisationResponseContactPersonsItemPhoneNumberMax).regex(getFetchOrganisationResponseContactPersonsItemPhoneNumberRegExp).nullish(),
  "mobile_phone_number": zod.string().min(getFetchOrganisationResponseContactPersonsItemMobilePhoneNumberMin).max(getFetchOrganisationResponseContactPersonsItemMobilePhoneNumberMax).regex(getFetchOrganisationResponseContactPersonsItemMobilePhoneNumberRegExp).nullish(),
  "email": zod.string().optional(),
  "active": zod.boolean().optional(),
  "description": zod.string().nullish()
})).optional(),
  "branches": zod.array(zod.object({
  "id": zod.string().optional(),
  "street": zod.string().regex(getFetchOrganisationResponseBranchesItemStreetRegExp).optional(),
  "house_number": zod.number().min(getFetchOrganisationResponseBranchesItemHouseNumberMin).optional(),
  "post_code": zod.string().regex(getFetchOrganisationResponseBranchesItemPostCodeRegExp).optional(),
  "city": zod.string().regex(getFetchOrganisationResponseBranchesItemCityRegExp).optional(),
  "country": zod.string().regex(getFetchOrganisationResponseBranchesItemCountryRegExp).optional(),
  "house_number_extension": zod.string().regex(getFetchOrganisationResponseBranchesItemHouseNumberExtensionRegExp).nullish(),
  "description": zod.string().nullish()
})).optional(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "type": zod.enum(['customer', 'prospect']).optional(),
  "payment_method": zod.enum(['cash', 'account', 'sepa']).optional(),
  "payment_term": zod.enum(['SEPA', '14 days', '30 days', '60 days']).optional(),
  "transport_type": zod.enum(['per hour', 'per ride', 'self transport']).optional(),
  "transport_ride_amount": zod.number().min(getFetchOrganisationResponseTransportRideAmountMin).optional(),
  "supplier": zod.boolean().optional(),
  "po_required": zod.boolean().optional(),
  "active": zod.boolean().optional(),
  "address": zod.object({
  "id": zod.string().optional(),
  "street": zod.string().regex(getFetchOrganisationResponseAddressStreetRegExp).optional(),
  "house_number": zod.number().min(getFetchOrganisationResponseAddressHouseNumberMin).optional(),
  "post_code": zod.string().regex(getFetchOrganisationResponseAddressPostCodeRegExp).optional(),
  "city": zod.string().regex(getFetchOrganisationResponseAddressCityRegExp).optional(),
  "country": zod.string().regex(getFetchOrganisationResponseAddressCountryRegExp).optional(),
  "house_number_extension": zod.string().regex(getFetchOrganisationResponseAddressHouseNumberExtensionRegExp).nullish(),
  "description": zod.string().nullish(),
  "contact_detail": zod.object({
  "id": zod.string().optional(),
  "phone_number": zod.string().min(getFetchOrganisationResponseAddressContactDetailPhoneNumberMin).max(getFetchOrganisationResponseAddressContactDetailPhoneNumberMax).regex(getFetchOrganisationResponseAddressContactDetailPhoneNumberRegExp).optional(),
  "mobile_phone_number": zod.string().min(getFetchOrganisationResponseAddressContactDetailMobilePhoneNumberMin).max(getFetchOrganisationResponseAddressContactDetailMobilePhoneNumberMax).regex(getFetchOrganisationResponseAddressContactDetailMobilePhoneNumberRegExp).optional(),
  "email": zod.string().optional()
}).optional()
}).optional(),
  "external_reference": zod.string().nullish(),
  "invoice_address": zod.object({
  "id": zod.string().optional(),
  "street": zod.string().regex(getFetchOrganisationResponseInvoiceAddressStreetRegExp).optional(),
  "house_number": zod.number().min(getFetchOrganisationResponseInvoiceAddressHouseNumberMin).optional(),
  "post_code": zod.string().regex(getFetchOrganisationResponseInvoiceAddressPostCodeRegExp).optional(),
  "city": zod.string().regex(getFetchOrganisationResponseInvoiceAddressCityRegExp).optional(),
  "country": zod.string().regex(getFetchOrganisationResponseInvoiceAddressCountryRegExp).optional(),
  "house_number_extension": zod.string().regex(getFetchOrganisationResponseInvoiceAddressHouseNumberExtensionRegExp).nullish(),
  "description": zod.string().nullish(),
  "contact_detail": zod.object({
  "id": zod.string().optional(),
  "phone_number": zod.string().min(getFetchOrganisationResponseInvoiceAddressContactDetailPhoneNumberMin).max(getFetchOrganisationResponseInvoiceAddressContactDetailPhoneNumberMax).regex(getFetchOrganisationResponseInvoiceAddressContactDetailPhoneNumberRegExp).optional(),
  "mobile_phone_number": zod.string().min(getFetchOrganisationResponseInvoiceAddressContactDetailMobilePhoneNumberMin).max(getFetchOrganisationResponseInvoiceAddressContactDetailMobilePhoneNumberMax).regex(getFetchOrganisationResponseInvoiceAddressContactDetailMobilePhoneNumberRegExp).optional(),
  "email": zod.string().optional()
}).optional()
}).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional(),
  "files": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "type": zod.enum(['logo']).optional()
})).optional()
})


export const putUpdateOrganisationParams = zod.object({
  "id": zod.string()
})

export const putUpdateOrganisationBodyNameMin = 3;

export const putUpdateOrganisationBodyNameMax = 127;

export const putUpdateOrganisationBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const putUpdateOrganisationBodyVatNumberRegExp = new RegExp('.*[a-zA-Z0-9\\s].*');
export const putUpdateOrganisationBodyChamberOfCommerceNumberRegExp = new RegExp('.*[0-9\\s]+');
export const putUpdateOrganisationBodyTransportRideAmountMin = 0;


export const putUpdateOrganisationBody = zod.object({
  "name": zod.string().min(putUpdateOrganisationBodyNameMin).max(putUpdateOrganisationBodyNameMax).regex(putUpdateOrganisationBodyNameRegExp),
  "vat_number": zod.string().regex(putUpdateOrganisationBodyVatNumberRegExp),
  "chamber_of_commerce_number": zod.string().regex(putUpdateOrganisationBodyChamberOfCommerceNumberRegExp),
  "status": zod.enum(['active', 'inactive']),
  "type": zod.enum(['customer', 'prospect']),
  "payment_method": zod.enum(['cash', 'account', 'sepa']),
  "payment_term": zod.enum(['SEPA', '14 days', '30 days', '60 days']),
  "transport_type": zod.enum(['per_hour', 'per_ride', 'self_transport']),
  "transport_ride_amount": zod.number().min(putUpdateOrganisationBodyTransportRideAmountMin),
  "supplier": zod.boolean().optional(),
  "po_required": zod.boolean().optional(),
  "active": zod.boolean().nullish(),
  "address_id": zod.string(),
  "invoice_address_id": zod.string(),
  "description": zod.string().nullish()
})


export const patchPatchOrganisationParams = zod.object({
  "id": zod.string()
})

export const patchPatchOrganisationBodyNameMin = 3;

export const patchPatchOrganisationBodyNameMax = 127;

export const patchPatchOrganisationBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const patchPatchOrganisationBodyVatNumberRegExp = new RegExp('.*[a-zA-Z0-9\\s].*');
export const patchPatchOrganisationBodyChamberOfCommerceNumberRegExp = new RegExp('.*[0-9\\s]+');
export const patchPatchOrganisationBodyTransportRideAmountMin = 0;


export const patchPatchOrganisationBody = zod.object({
  "name": zod.string().min(patchPatchOrganisationBodyNameMin).max(patchPatchOrganisationBodyNameMax).regex(patchPatchOrganisationBodyNameRegExp).nullish(),
  "vat_number": zod.string().regex(patchPatchOrganisationBodyVatNumberRegExp).nullish(),
  "chamber_of_commerce_number": zod.string().regex(patchPatchOrganisationBodyChamberOfCommerceNumberRegExp).nullish(),
  "status": zod.enum(['active', 'inactive']).nullish(),
  "type": zod.enum(['customer', 'prospect']).optional(),
  "payment_method": zod.enum(['cash', 'account', 'sepa']).nullish(),
  "payment_term": zod.enum(['SEPA', '14 days', '30 days', '60 days']).nullish(),
  "transport_type": zod.enum(['per_hour', 'per_ride', 'self_transport']).nullish(),
  "transport_ride_amount": zod.number().min(patchPatchOrganisationBodyTransportRideAmountMin).nullish(),
  "supplier": zod.boolean().nullish(),
  "po_required": zod.boolean().nullish(),
  "active": zod.boolean().nullish(),
  "description": zod.string().nullish()
})


export const postFetchAllOrganisationsQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllOrganisationsBodyNumberMin = 0;


export const postFetchAllOrganisationsBody = zod.object({
  "match_mode": zod.enum(['and', 'or']).optional(),
  "number": zod.number().min(postFetchAllOrganisationsBodyNumberMin).nullish(),
  "name": zod.string().nullish(),
  "vat_number": zod.string().nullish(),
  "chamber_of_commerce_number": zod.string().nullish(),
  "status": zod.enum(['active', 'inactive']).nullish(),
  "type": zod.enum(['customer', 'prospect']).nullish(),
  "supplier": zod.boolean().nullish(),
  "active": zod.boolean().nullish()
}).nullable()

export const postFetchAllOrganisationsResponseDataItemNumberMin = 0;
export const postFetchAllOrganisationsResponseDataItemNameMin = 3;

export const postFetchAllOrganisationsResponseDataItemNameMax = 127;

export const postFetchAllOrganisationsResponseDataItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllOrganisationsResponseDataItemVatNumberRegExp = new RegExp('[a-zA-Z0-9\\s]');
export const postFetchAllOrganisationsResponseDataItemChamberOfCommerceNumberRegExp = new RegExp('^[0-9\\s]+$');
export const postFetchAllOrganisationsResponseDataItemTransportRideAmountMin = 0;


export const postFetchAllOrganisationsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "number": zod.number().min(postFetchAllOrganisationsResponseDataItemNumberMin).optional(),
  "name": zod.string().min(postFetchAllOrganisationsResponseDataItemNameMin).max(postFetchAllOrganisationsResponseDataItemNameMax).regex(postFetchAllOrganisationsResponseDataItemNameRegExp).optional(),
  "vat_number": zod.string().regex(postFetchAllOrganisationsResponseDataItemVatNumberRegExp).optional(),
  "chamber_of_commerce_number": zod.string().regex(postFetchAllOrganisationsResponseDataItemChamberOfCommerceNumberRegExp).optional(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "type": zod.enum(['customer', 'prospect']).optional(),
  "payment_method": zod.enum(['cash', 'account', 'sepa']).optional(),
  "payment_term": zod.enum(['SEPA', '14 days', '30 days', '60 days']).optional(),
  "transport_type": zod.enum(['per hour', 'per ride', 'self transport']).optional(),
  "transport_ride_amount": zod.number().min(postFetchAllOrganisationsResponseDataItemTransportRideAmountMin).optional(),
  "supplier": zod.boolean().optional(),
  "po_required": zod.boolean().optional(),
  "active": zod.boolean().optional(),
  "external_reference": zod.string().nullish(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postAddContactPersonToOrganisationParams = zod.object({
  "id": zod.string()
})

export const postAddContactPersonToOrganisationBody = zod.object({
  "contact_persons": zod.array(zod.string())
})


export const postAddBranchToOrganisationParams = zod.object({
  "id": zod.string()
})

export const postAddBranchToOrganisationBody = zod.object({
  "branches": zod.array(zod.string())
})


export const postCreateOrganisationBodyNumberMin = 0;
export const postCreateOrganisationBodyNameMin = 3;

export const postCreateOrganisationBodyNameMax = 127;

export const postCreateOrganisationBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const postCreateOrganisationBodyVatNumberRegExp = new RegExp('.*[a-zA-Z0-9\\s].*');
export const postCreateOrganisationBodyChamberOfCommerceNumberRegExp = new RegExp('.*[0-9\\s]+');
export const postCreateOrganisationBodyTransportRideAmountMin = 0;


export const postCreateOrganisationBody = zod.object({
  "number": zod.number().min(postCreateOrganisationBodyNumberMin),
  "name": zod.string().min(postCreateOrganisationBodyNameMin).max(postCreateOrganisationBodyNameMax).regex(postCreateOrganisationBodyNameRegExp),
  "vat_number": zod.string().regex(postCreateOrganisationBodyVatNumberRegExp),
  "chamber_of_commerce_number": zod.string().regex(postCreateOrganisationBodyChamberOfCommerceNumberRegExp),
  "status": zod.enum(['active', 'inactive']),
  "type": zod.enum(['customer', 'prospect']),
  "payment_method": zod.enum(['cash', 'account', 'sepa']),
  "payment_term": zod.enum(['sepa', '14 days', '30 days', '60 days']),
  "transport_type": zod.enum(['per_hour', 'per_ride', 'self_transport']),
  "transport_ride_amount": zod.number().min(postCreateOrganisationBodyTransportRideAmountMin),
  "supplier": zod.boolean().optional(),
  "po_required": zod.boolean().optional(),
  "active": zod.boolean().optional(),
  "address_id": zod.string(),
  "external_reference": zod.string().nullish(),
  "invoice_address_id": zod.string().nullish(),
  "description": zod.string().nullish()
})


export const getFetchOrganisationContactPersonParams = zod.object({
  "id": zod.string()
})

export const getFetchOrganisationContactPersonResponseInitialRegExp = new RegExp('[^A-Z.]');
export const getFetchOrganisationContactPersonResponseFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchOrganisationContactPersonResponseMidletNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const getFetchOrganisationContactPersonResponseLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchOrganisationContactPersonResponsePhoneNumberMin = 5;

export const getFetchOrganisationContactPersonResponsePhoneNumberMax = 15;

export const getFetchOrganisationContactPersonResponsePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchOrganisationContactPersonResponseMobilePhoneNumberMin = 5;

export const getFetchOrganisationContactPersonResponseMobilePhoneNumberMax = 15;

export const getFetchOrganisationContactPersonResponseMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchOrganisationContactPersonResponseOrganisationNameMin = 3;

export const getFetchOrganisationContactPersonResponseOrganisationNameMax = 127;

export const getFetchOrganisationContactPersonResponseOrganisationNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const getFetchOrganisationContactPersonResponse = zod.object({
  "id": zod.string().optional(),
  "salutation": zod.enum(['Mr', 'Ms', 'Mrs']).optional(),
  "initial": zod.string().regex(getFetchOrganisationContactPersonResponseInitialRegExp).optional(),
  "first_name": zod.string().regex(getFetchOrganisationContactPersonResponseFirstNameRegExp).optional(),
  "midlet_name": zod.string().regex(getFetchOrganisationContactPersonResponseMidletNameRegExp).nullish(),
  "last_name": zod.string().regex(getFetchOrganisationContactPersonResponseLastNameRegExp).optional(),
  "phone_number": zod.string().min(getFetchOrganisationContactPersonResponsePhoneNumberMin).max(getFetchOrganisationContactPersonResponsePhoneNumberMax).regex(getFetchOrganisationContactPersonResponsePhoneNumberRegExp).nullish(),
  "mobile_phone_number": zod.string().min(getFetchOrganisationContactPersonResponseMobilePhoneNumberMin).max(getFetchOrganisationContactPersonResponseMobilePhoneNumberMax).regex(getFetchOrganisationContactPersonResponseMobilePhoneNumberRegExp).nullish(),
  "email": zod.string().optional(),
  "active": zod.boolean().optional(),
  "organisation": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().min(getFetchOrganisationContactPersonResponseOrganisationNameMin).max(getFetchOrganisationContactPersonResponseOrganisationNameMax).regex(getFetchOrganisationContactPersonResponseOrganisationNameRegExp).optional()
}).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})


export const postFetchAllOrganisationContactPersonsQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllOrganisationContactPersonsBodyPhoneNumberMin = 5;

export const postFetchAllOrganisationContactPersonsBodyPhoneNumberMax = 15;
export const postFetchAllOrganisationContactPersonsBodyMobilePhoneNumberMin = 5;

export const postFetchAllOrganisationContactPersonsBodyMobilePhoneNumberMax = 15;


export const postFetchAllOrganisationContactPersonsBody = zod.object({
  "match_mode": zod.enum(['and', 'or']).optional(),
  "name": zod.string().nullish(),
  "first_name": zod.string().nullish(),
  "last_name": zod.string().nullish(),
  "email": zod.string().nullish(),
  "active": zod.boolean().nullish(),
  "middle_name": zod.string().nullish(),
  "phone_number": zod.string().min(postFetchAllOrganisationContactPersonsBodyPhoneNumberMin).max(postFetchAllOrganisationContactPersonsBodyPhoneNumberMax).nullish(),
  "mobile_phone_number": zod.string().min(postFetchAllOrganisationContactPersonsBodyMobilePhoneNumberMin).max(postFetchAllOrganisationContactPersonsBodyMobilePhoneNumberMax).nullish()
})

export const postFetchAllOrganisationContactPersonsResponseDataItemInitialRegExp = new RegExp('[^A-Z.]');
export const postFetchAllOrganisationContactPersonsResponseDataItemFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllOrganisationContactPersonsResponseDataItemMidletNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const postFetchAllOrganisationContactPersonsResponseDataItemLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllOrganisationContactPersonsResponseDataItemPhoneNumberMin = 5;

export const postFetchAllOrganisationContactPersonsResponseDataItemPhoneNumberMax = 15;

export const postFetchAllOrganisationContactPersonsResponseDataItemPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllOrganisationContactPersonsResponseDataItemMobilePhoneNumberMin = 5;

export const postFetchAllOrganisationContactPersonsResponseDataItemMobilePhoneNumberMax = 15;

export const postFetchAllOrganisationContactPersonsResponseDataItemMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllOrganisationContactPersonsResponseDataItemOrganisationNameMin = 3;

export const postFetchAllOrganisationContactPersonsResponseDataItemOrganisationNameMax = 127;

export const postFetchAllOrganisationContactPersonsResponseDataItemOrganisationNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const postFetchAllOrganisationContactPersonsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "salutation": zod.enum(['Mr', 'Ms', 'Mrs']).optional(),
  "initial": zod.string().regex(postFetchAllOrganisationContactPersonsResponseDataItemInitialRegExp).optional(),
  "first_name": zod.string().regex(postFetchAllOrganisationContactPersonsResponseDataItemFirstNameRegExp).optional(),
  "midlet_name": zod.string().regex(postFetchAllOrganisationContactPersonsResponseDataItemMidletNameRegExp).nullish(),
  "last_name": zod.string().regex(postFetchAllOrganisationContactPersonsResponseDataItemLastNameRegExp).optional(),
  "phone_number": zod.string().min(postFetchAllOrganisationContactPersonsResponseDataItemPhoneNumberMin).max(postFetchAllOrganisationContactPersonsResponseDataItemPhoneNumberMax).regex(postFetchAllOrganisationContactPersonsResponseDataItemPhoneNumberRegExp).nullish(),
  "mobile_phone_number": zod.string().min(postFetchAllOrganisationContactPersonsResponseDataItemMobilePhoneNumberMin).max(postFetchAllOrganisationContactPersonsResponseDataItemMobilePhoneNumberMax).regex(postFetchAllOrganisationContactPersonsResponseDataItemMobilePhoneNumberRegExp).nullish(),
  "email": zod.string().optional(),
  "active": zod.boolean().optional(),
  "organisation": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().min(postFetchAllOrganisationContactPersonsResponseDataItemOrganisationNameMin).max(postFetchAllOrganisationContactPersonsResponseDataItemOrganisationNameMax).regex(postFetchAllOrganisationContactPersonsResponseDataItemOrganisationNameRegExp).optional()
}).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postCreateOrganisationContactPersonBodyInitialMax = 10;

export const postCreateOrganisationContactPersonBodyInitialRegExp = new RegExp('.*[A-Z.].*');
export const postCreateOrganisationContactPersonBodyFirstNameRegExp = new RegExp('.*[a-zA-Z\\s]+');
export const postCreateOrganisationContactPersonBodyLastNameRegExp = new RegExp('.*[a-zA-Z\\s]+');
export const postCreateOrganisationContactPersonBodyMiddleNameRegExp = new RegExp('.*[a-zA-Z\\s\\.]+');
export const postCreateOrganisationContactPersonBodyPhoneNumberMin = 5;

export const postCreateOrganisationContactPersonBodyPhoneNumberMax = 15;
export const postCreateOrganisationContactPersonBodyMobilePhoneNumberMin = 5;

export const postCreateOrganisationContactPersonBodyMobilePhoneNumberMax = 15;


export const postCreateOrganisationContactPersonBody = zod.object({
  "salutation": zod.enum(['Mr', 'Ms', 'Mrs']),
  "initial": zod.string().min(1).max(postCreateOrganisationContactPersonBodyInitialMax).regex(postCreateOrganisationContactPersonBodyInitialRegExp),
  "first_name": zod.string().regex(postCreateOrganisationContactPersonBodyFirstNameRegExp),
  "last_name": zod.string().regex(postCreateOrganisationContactPersonBodyLastNameRegExp),
  "email": zod.string(),
  "active": zod.boolean().optional(),
  "organisation_id": zod.string(),
  "middle_name": zod.string().regex(postCreateOrganisationContactPersonBodyMiddleNameRegExp).nullish(),
  "phone_number": zod.string().min(postCreateOrganisationContactPersonBodyPhoneNumberMin).max(postCreateOrganisationContactPersonBodyPhoneNumberMax).nullish(),
  "mobile_phone_number": zod.string().min(postCreateOrganisationContactPersonBodyMobilePhoneNumberMin).max(postCreateOrganisationContactPersonBodyMobilePhoneNumberMax).nullish(),
  "description": zod.string().nullish()
})


export const postCreateContactDetailBodyPhoneNumberMin = 5;

export const postCreateContactDetailBodyPhoneNumberMax = 15;

export const postCreateContactDetailBodyPhoneNumberRegExp = new RegExp('31[0-9]{9}');
export const postCreateContactDetailBodyMobilePhoneNumberMin = 5;

export const postCreateContactDetailBodyMobilePhoneNumberMax = 15;

export const postCreateContactDetailBodyMobilePhoneNumberRegExp = new RegExp('31[0-9]{9}');


export const postCreateContactDetailBody = zod.object({
  "phone_number": zod.string().min(postCreateContactDetailBodyPhoneNumberMin).max(postCreateContactDetailBodyPhoneNumberMax).regex(postCreateContactDetailBodyPhoneNumberRegExp),
  "mobile_phone_number": zod.string().min(postCreateContactDetailBodyMobilePhoneNumberMin).max(postCreateContactDetailBodyMobilePhoneNumberMax).regex(postCreateContactDetailBodyMobilePhoneNumberRegExp),
  "email": zod.string()
})


export const postGetAllOrganisationContactPersonsParams = zod.object({
  "id": zod.string()
})

export const postGetAllOrganisationContactPersonsResponseInitialRegExp = new RegExp('[^A-Z.]');
export const postGetAllOrganisationContactPersonsResponseFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postGetAllOrganisationContactPersonsResponseMidletNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const postGetAllOrganisationContactPersonsResponseLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postGetAllOrganisationContactPersonsResponsePhoneNumberMin = 5;

export const postGetAllOrganisationContactPersonsResponsePhoneNumberMax = 15;

export const postGetAllOrganisationContactPersonsResponsePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postGetAllOrganisationContactPersonsResponseMobilePhoneNumberMin = 5;

export const postGetAllOrganisationContactPersonsResponseMobilePhoneNumberMax = 15;

export const postGetAllOrganisationContactPersonsResponseMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postGetAllOrganisationContactPersonsResponseOrganisationNameMin = 3;

export const postGetAllOrganisationContactPersonsResponseOrganisationNameMax = 127;

export const postGetAllOrganisationContactPersonsResponseOrganisationNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const postGetAllOrganisationContactPersonsResponseItem = zod.object({
  "id": zod.string().optional(),
  "salutation": zod.enum(['Mr', 'Ms', 'Mrs']).optional(),
  "initial": zod.string().regex(postGetAllOrganisationContactPersonsResponseInitialRegExp).optional(),
  "first_name": zod.string().regex(postGetAllOrganisationContactPersonsResponseFirstNameRegExp).optional(),
  "midlet_name": zod.string().regex(postGetAllOrganisationContactPersonsResponseMidletNameRegExp).nullish(),
  "last_name": zod.string().regex(postGetAllOrganisationContactPersonsResponseLastNameRegExp).optional(),
  "phone_number": zod.string().min(postGetAllOrganisationContactPersonsResponsePhoneNumberMin).max(postGetAllOrganisationContactPersonsResponsePhoneNumberMax).regex(postGetAllOrganisationContactPersonsResponsePhoneNumberRegExp).nullish(),
  "mobile_phone_number": zod.string().min(postGetAllOrganisationContactPersonsResponseMobilePhoneNumberMin).max(postGetAllOrganisationContactPersonsResponseMobilePhoneNumberMax).regex(postGetAllOrganisationContactPersonsResponseMobilePhoneNumberRegExp).nullish(),
  "email": zod.string().optional(),
  "active": zod.boolean().optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional(),
  "organisation": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().min(postGetAllOrganisationContactPersonsResponseOrganisationNameMin).max(postGetAllOrganisationContactPersonsResponseOrganisationNameMax).regex(postGetAllOrganisationContactPersonsResponseOrganisationNameRegExp).optional()
}).optional()
})
export const postGetAllOrganisationContactPersonsResponse = zod.array(postGetAllOrganisationContactPersonsResponseItem)


export const postFetchAllOrganisationBranchesParams = zod.object({
  "id": zod.string()
})

export const postFetchAllOrganisationBranchesResponseDataItemStreetRegExp = new RegExp('[a-zA-Z\\s\\-\\`\']');
export const postFetchAllOrganisationBranchesResponseDataItemHouseNumberMin = 0;
export const postFetchAllOrganisationBranchesResponseDataItemPostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');
export const postFetchAllOrganisationBranchesResponseDataItemCityRegExp = new RegExp('[a-zA-Z\\s\'\\-]');
export const postFetchAllOrganisationBranchesResponseDataItemCountryRegExp = new RegExp('[a-zA-Z\\s]');
export const postFetchAllOrganisationBranchesResponseDataItemContactDetailPhoneNumberMin = 5;

export const postFetchAllOrganisationBranchesResponseDataItemContactDetailPhoneNumberMax = 15;

export const postFetchAllOrganisationBranchesResponseDataItemContactDetailPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllOrganisationBranchesResponseDataItemContactDetailMobilePhoneNumberMin = 5;

export const postFetchAllOrganisationBranchesResponseDataItemContactDetailMobilePhoneNumberMax = 15;

export const postFetchAllOrganisationBranchesResponseDataItemContactDetailMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllOrganisationBranchesResponseDataItemHouseNumberExtensionRegExp = new RegExp('[a-zA-Z0-9\\s\\-]');


export const postFetchAllOrganisationBranchesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "street": zod.string().regex(postFetchAllOrganisationBranchesResponseDataItemStreetRegExp).optional(),
  "house_number": zod.number().min(postFetchAllOrganisationBranchesResponseDataItemHouseNumberMin).optional(),
  "post_code": zod.string().regex(postFetchAllOrganisationBranchesResponseDataItemPostCodeRegExp).optional(),
  "city": zod.string().regex(postFetchAllOrganisationBranchesResponseDataItemCityRegExp).optional(),
  "country": zod.string().regex(postFetchAllOrganisationBranchesResponseDataItemCountryRegExp).optional(),
  "contact_detail": zod.object({
  "id": zod.string().optional(),
  "phone_number": zod.string().min(postFetchAllOrganisationBranchesResponseDataItemContactDetailPhoneNumberMin).max(postFetchAllOrganisationBranchesResponseDataItemContactDetailPhoneNumberMax).regex(postFetchAllOrganisationBranchesResponseDataItemContactDetailPhoneNumberRegExp).optional(),
  "mobile_phone_number": zod.string().min(postFetchAllOrganisationBranchesResponseDataItemContactDetailMobilePhoneNumberMin).max(postFetchAllOrganisationBranchesResponseDataItemContactDetailMobilePhoneNumberMax).regex(postFetchAllOrganisationBranchesResponseDataItemContactDetailMobilePhoneNumberRegExp).optional(),
  "email": zod.string().optional()
}).optional(),
  "house_number_extension": zod.string().regex(postFetchAllOrganisationBranchesResponseDataItemHouseNumberExtensionRegExp).nullish(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})).optional()
})


export const getFetchOrganisationFileParams = zod.object({
  "file_id": zod.string()
})


/**
 * Fetch file in base64 format
 * @summary Get file as base64 by ID
 */
export const getFetchOrganisationFileBase64Params = zod.object({
  "file_id": zod.string().uuid()
})


export const postAddFileToOrganisationParams = zod.object({
  "id": zod.string()
})

export const postAddFileToOrganisationBody = zod.object({
  "data": zod.string()
})


export const getFetchActionLabourParams = zod.object({
  "id": zod.string()
})

export const getFetchActionLabourResponseTotalHoursMin = 0;
export const getFetchActionLabourResponseAssigneeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchActionLabourResponseAssigneePricePerHourMin = 0;


export const getFetchActionLabourResponse = zod.object({
  "id": zod.string().optional(),
  "total_hours": zod.number().min(getFetchActionLabourResponseTotalHoursMin).optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "date": zod.date().optional(),
  "assignment": zod.object({
  "id": zod.string().optional()
}).optional(),
  "assignee": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchActionLabourResponseAssigneeNameRegExp).optional(),
  "function": zod.enum(['mechanic']).optional(),
  "price_per_hour": zod.number().min(getFetchActionLabourResponseAssigneePricePerHourMin).optional()
}).optional(),
  "created_at": zod.string().date().optional()
})


export const patchPatchActionLabourParams = zod.object({
  "id": zod.string()
})

export const patchPatchActionLabourBodyTotalHoursMin = 0;


export const patchPatchActionLabourBody = zod.object({
  "total_hours": zod.number().min(patchPatchActionLabourBodyTotalHoursMin).nullish(),
  "date": zod.string().date().nullish(),
  "type": zod.enum(['fixed', 'variable']).nullish()
})


export const postFetchAllActionLabourQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllActionLabourResponseDataItemTotalHoursMin = 0;
export const postFetchAllActionLabourResponseDataItemAssigneeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllActionLabourResponseDataItemAssigneePricePerHourMin = 0;


export const postFetchAllActionLabourResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "total_hours": zod.number().min(postFetchAllActionLabourResponseDataItemTotalHoursMin).optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "date": zod.date().optional(),
  "assignment": zod.object({
  "id": zod.string().optional()
}).optional(),
  "assignee": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllActionLabourResponseDataItemAssigneeNameRegExp).optional(),
  "function": zod.enum(['mechanic']).optional(),
  "price_per_hour": zod.number().min(postFetchAllActionLabourResponseDataItemAssigneePricePerHourMin).optional()
}).optional(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postCreateActionLabourBodyTotalHoursMin = 0;


export const postCreateActionLabourBody = zod.object({
  "total_hours": zod.number().min(postCreateActionLabourBodyTotalHoursMin),
  "type": zod.enum(['fixed', 'variable']),
  "assignment_id": zod.string(),
  "assignee_id": zod.string(),
  "date": zod.string().date().nullish()
})


export const postUpdateActionLabourTotalHoursParams = zod.object({
  "id": zod.string()
})

export const postUpdateActionLabourTotalHoursBody = zod.object({
  "total_hours": zod.number().optional()
})


export const getFetchAssigneeParams = zod.object({
  "id": zod.string()
})

export const getFetchAssigneeResponseNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchAssigneeResponsePricePerHourMin = 0;
export const getFetchAssigneeResponseUserFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchAssigneeResponseUserLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchAssigneeResponseUserMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');


export const getFetchAssigneeResponse = zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchAssigneeResponseNameRegExp).optional(),
  "function": zod.enum(['mechanic']).optional(),
  "price_per_hour": zod.number().min(getFetchAssigneeResponsePricePerHourMin).optional(),
  "created_at": zod.string().date().optional(),
  "user": zod.object({
  "id": zod.string().optional(),
  "first_name": zod.string().regex(getFetchAssigneeResponseUserFirstNameRegExp).optional(),
  "last_name": zod.string().regex(getFetchAssigneeResponseUserLastNameRegExp).optional(),
  "middle_name": zod.string().regex(getFetchAssigneeResponseUserMiddleNameRegExp).nullish()
}).optional()
})


export const putUpdateAssigneeParams = zod.object({
  "id": zod.string()
})

export const putUpdateAssigneeBody = zod.object({
  "name": zod.string().nullish(),
  "function": zod.enum(['mechanic', 'admin']).nullish(),
  "price_per_hour": zod.number().nullish(),
  "user_id": zod.string().uuid().nullish()
})


export const postFetchAllAssigneesQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllAssigneesBody = zod.object({
  "match_mode": zod.enum(['and', 'or']).optional(),
  "name": zod.string().nullish(),
  "function": zod.enum(['mechanic']).nullish(),
  "price_per_hour": zod.number().nullish()
})

export const postFetchAllAssigneesResponseDataItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllAssigneesResponseDataItemPricePerHourMin = 0;
export const postFetchAllAssigneesResponseDataItemUserFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllAssigneesResponseDataItemUserLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllAssigneesResponseDataItemUserMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');


export const postFetchAllAssigneesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllAssigneesResponseDataItemNameRegExp).optional(),
  "function": zod.enum(['mechanic']).optional(),
  "price_per_hour": zod.number().min(postFetchAllAssigneesResponseDataItemPricePerHourMin).optional(),
  "created_at": zod.string().date().optional(),
  "user": zod.object({
  "id": zod.string().optional(),
  "first_name": zod.string().regex(postFetchAllAssigneesResponseDataItemUserFirstNameRegExp).optional(),
  "last_name": zod.string().regex(postFetchAllAssigneesResponseDataItemUserLastNameRegExp).optional(),
  "middle_name": zod.string().regex(postFetchAllAssigneesResponseDataItemUserMiddleNameRegExp).nullish()
}).optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postCreateAssigneeBodyNameMin = 3;

export const postCreateAssigneeBodyNameMax = 127;

export const postCreateAssigneeBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const postCreateAssigneeBodyPricePerHourMin = 0;


export const postCreateAssigneeBody = zod.object({
  "name": zod.string().min(postCreateAssigneeBodyNameMin).max(postCreateAssigneeBodyNameMax).regex(postCreateAssigneeBodyNameRegExp),
  "function": zod.enum(['mechanic']),
  "price_per_hour": zod.number().min(postCreateAssigneeBodyPricePerHourMin),
  "user_id": zod.string().uuid().optional()
})


export const getFetchAssignmentParams = zod.object({
  "id": zod.string()
})

export const getFetchAssignmentResponseActionLaboursItemTotalHoursMin = 0;
export const getFetchAssignmentResponseActionLaboursItemAssigneePricePerHourMin = 0;
export const getFetchAssignmentResponseAssigneesItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchAssignmentResponseAssigneesItemPricePerHourMin = 0;
export const getFetchAssignmentResponseTicketTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');


export const getFetchAssignmentResponse = zod.object({
  "id": zod.string().optional(),
  "status": zod.enum(['open', 'closed']).optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "action": zod.object({
  "id": zod.string().optional()
}).optional(),
  "action_labours": zod.array(zod.object({
  "id": zod.string().optional(),
  "total_hours": zod.number().min(getFetchAssignmentResponseActionLaboursItemTotalHoursMin).optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "date": zod.date().optional(),
  "assignee": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "price_per_hour": zod.number().min(getFetchAssignmentResponseActionLaboursItemAssigneePricePerHourMin).optional()
}).optional()
})).optional(),
  "assignees": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchAssignmentResponseAssigneesItemNameRegExp).optional(),
  "function": zod.enum(['mechanic']).optional(),
  "price_per_hour": zod.number().min(getFetchAssignmentResponseAssigneesItemPricePerHourMin).optional()
})).optional(),
  "ticket": zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "title": zod.string().regex(getFetchAssignmentResponseTicketTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
}).optional(),
  "created_at": zod.string().date().optional()
})


export const deleteRemoveAssignmentParams = zod.object({
  "id": zod.string()
})


export const postFetchAllAssignmentsQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllAssignmentsBody = zod.object({
  "ticket_id": zod.string().optional(),
  "assignee_id": zod.string().optional()
})

export const postFetchAllAssignmentsResponseDataItemActionLaboursItemTotalHoursMin = 0;
export const postFetchAllAssignmentsResponseDataItemActionLaboursItemAssigneePricePerHourMin = 0;
export const postFetchAllAssignmentsResponseDataItemAssigneesItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllAssignmentsResponseDataItemAssigneesItemPricePerHourMin = 0;
export const postFetchAllAssignmentsResponseDataItemTicketTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');


export const postFetchAllAssignmentsResponseItem = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "status": zod.enum(['open', 'closed']).optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "action": zod.object({
  "id": zod.string().optional()
}).optional(),
  "action_labours": zod.array(zod.object({
  "id": zod.string().optional(),
  "total_hours": zod.number().min(postFetchAllAssignmentsResponseDataItemActionLaboursItemTotalHoursMin).optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "date": zod.date().optional(),
  "assignee": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "price_per_hour": zod.number().min(postFetchAllAssignmentsResponseDataItemActionLaboursItemAssigneePricePerHourMin).optional()
}).optional()
})).optional(),
  "assignees": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllAssignmentsResponseDataItemAssigneesItemNameRegExp).optional(),
  "function": zod.enum(['mechanic']).optional(),
  "price_per_hour": zod.number().min(postFetchAllAssignmentsResponseDataItemAssigneesItemPricePerHourMin).optional()
})).optional(),
  "ticket": zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "title": zod.string().regex(postFetchAllAssignmentsResponseDataItemTicketTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
}).optional(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})
export const postFetchAllAssignmentsResponse = zod.array(postFetchAllAssignmentsResponseItem)


export const postCreateAssignmentBody = zod.object({
  "action_id": zod.string(),
  "ticket_id": zod.string(),
  "type": zod.enum(['fixed', 'variable']).optional()
})


/**
 * This endpoint sets the status of a assignment to closed
 * @summary Close an assignment
 */
export const postCloseAssignmentParams = zod.object({
  "id": zod.string()
})


/**
 * This endpoint sets the status of a assignment to opened
 * @summary Open an assignment
 */
export const postOpenAssignmentParams = zod.object({
  "id": zod.string()
})


export const postAddAssigneeToAssignmentParams = zod.object({
  "id": zod.string()
})

export const postAddAssigneeToAssignmentBody = zod.object({
  "assignees": zod.array(zod.string())
})


export const postAddActionLabourToAssignmentParams = zod.object({
  "id": zod.string()
})

export const postAddActionLabourToAssignmentBody = zod.object({
  "action_labours": zod.array(zod.string())
})


export const postCreateCommentBody = zod.object({
  "access_level": zod.enum(['public', 'internal']),
  "content": zod.string(),
  "author_id": zod.string(),
  "ticket_id": zod.string(),
  "type": zod.enum(['user', 'case']).nullish()
})


export const postFetchAllCommentsQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllCommentsBody = zod.object({
  "ticket_id": zod.string(),
  "access_level": zod.enum(['public', 'internal', 'all']),
  "type": zod.enum(['case', 'user']).optional()
})

export const postFetchAllCommentsResponseDataItemAuthorFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllCommentsResponseDataItemAuthorLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllCommentsResponseDataItemAuthorMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const postFetchAllCommentsResponseDataItemTicketTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');


export const postFetchAllCommentsResponseItem = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "access_level": zod.enum(['public', 'internal']).optional(),
  "content": zod.string().optional(),
  "type": zod.enum(['user', 'case']).optional(),
  "author": zod.object({
  "id": zod.string().optional(),
  "first_name": zod.string().regex(postFetchAllCommentsResponseDataItemAuthorFirstNameRegExp).optional(),
  "last_name": zod.string().regex(postFetchAllCommentsResponseDataItemAuthorLastNameRegExp).optional(),
  "middle_name": zod.string().regex(postFetchAllCommentsResponseDataItemAuthorMiddleNameRegExp).nullish()
}).optional(),
  "ticket": zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "title": zod.string().regex(postFetchAllCommentsResponseDataItemTicketTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
}).optional(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})
export const postFetchAllCommentsResponse = zod.array(postFetchAllCommentsResponseItem)


export const postCreateContactPersonBodyFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$/, .*[a-zA-Z\\s]+');
export const postCreateContactPersonBodyMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$/, .*[a-zA-Z\\s\\.]+');
export const postCreateContactPersonBodyLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$/, .*[a-zA-Z\\s]+');
export const postCreateContactPersonBodyPhoneNumberMin = 5;

export const postCreateContactPersonBodyPhoneNumberMax = 15;

export const postCreateContactPersonBodyPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postCreateContactPersonBodyMobilePhoneNumberMin = 5;

export const postCreateContactPersonBodyMobilePhoneNumberMax = 15;

export const postCreateContactPersonBodyMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');


export const postCreateContactPersonBody = zod.object({
  "reference": zod.enum(['site', 'organisation']).optional(),
  "first_name": zod.string().regex(postCreateContactPersonBodyFirstNameRegExp).nullish(),
  "middle_name": zod.string().regex(postCreateContactPersonBodyMiddleNameRegExp).nullish(),
  "last_name": zod.string().regex(postCreateContactPersonBodyLastNameRegExp).nullish(),
  "phone_number": zod.string().min(postCreateContactPersonBodyPhoneNumberMin).max(postCreateContactPersonBodyPhoneNumberMax).regex(postCreateContactPersonBodyPhoneNumberRegExp).nullish(),
  "mobile_phone_number": zod.string().min(postCreateContactPersonBodyMobilePhoneNumberMin).max(postCreateContactPersonBodyMobilePhoneNumberMax).regex(postCreateContactPersonBodyMobilePhoneNumberRegExp).nullish(),
  "email": zod.string().nullish(),
  "description": zod.string().nullish()
})


export const getFetchTicketContactPersonParams = zod.object({
  "id": zod.string()
})

export const getFetchTicketContactPersonResponseFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchTicketContactPersonResponseMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const getFetchTicketContactPersonResponseLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchTicketContactPersonResponsePhoneNumberMin = 5;

export const getFetchTicketContactPersonResponsePhoneNumberMax = 15;

export const getFetchTicketContactPersonResponsePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchTicketContactPersonResponseMobilePhoneNumberMin = 5;

export const getFetchTicketContactPersonResponseMobilePhoneNumberMax = 15;

export const getFetchTicketContactPersonResponseMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');


export const getFetchTicketContactPersonResponse = zod.object({
  "id": zod.string().optional(),
  "reference": zod.enum(['site', 'organisation']).optional(),
  "first_name": zod.string().regex(getFetchTicketContactPersonResponseFirstNameRegExp).nullish(),
  "middle_name": zod.string().regex(getFetchTicketContactPersonResponseMiddleNameRegExp).nullish(),
  "last_name": zod.string().regex(getFetchTicketContactPersonResponseLastNameRegExp).nullish(),
  "phone_number": zod.string().min(getFetchTicketContactPersonResponsePhoneNumberMin).max(getFetchTicketContactPersonResponsePhoneNumberMax).regex(getFetchTicketContactPersonResponsePhoneNumberRegExp).nullish(),
  "mobile_phone_number": zod.string().min(getFetchTicketContactPersonResponseMobilePhoneNumberMin).max(getFetchTicketContactPersonResponseMobilePhoneNumberMax).regex(getFetchTicketContactPersonResponseMobilePhoneNumberRegExp).nullish(),
  "email": zod.string().nullish(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})


export const postFetchAllTicketContactPersonsQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllTicketContactPersonsBodyPhoneNumberMin = 5;

export const postFetchAllTicketContactPersonsBodyPhoneNumberMax = 15;
export const postFetchAllTicketContactPersonsBodyMobilePhoneNumberMin = 5;

export const postFetchAllTicketContactPersonsBodyMobilePhoneNumberMax = 15;


export const postFetchAllTicketContactPersonsBody = zod.object({
  "match_mode": zod.enum(['and', 'or']).optional(),
  "name": zod.string().nullish(),
  "first_name": zod.string().nullish(),
  "last_name": zod.string().nullish(),
  "email": zod.string().nullish(),
  "active": zod.boolean().nullish(),
  "middle_name": zod.string().nullish(),
  "phone_number": zod.string().min(postFetchAllTicketContactPersonsBodyPhoneNumberMin).max(postFetchAllTicketContactPersonsBodyPhoneNumberMax).nullish(),
  "mobile_phone_number": zod.string().min(postFetchAllTicketContactPersonsBodyMobilePhoneNumberMin).max(postFetchAllTicketContactPersonsBodyMobilePhoneNumberMax).nullish()
})

export const postFetchAllTicketContactPersonsResponseDataItemFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllTicketContactPersonsResponseDataItemMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const postFetchAllTicketContactPersonsResponseDataItemLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllTicketContactPersonsResponseDataItemPhoneNumberMin = 5;

export const postFetchAllTicketContactPersonsResponseDataItemPhoneNumberMax = 15;

export const postFetchAllTicketContactPersonsResponseDataItemPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllTicketContactPersonsResponseDataItemMobilePhoneNumberMin = 5;

export const postFetchAllTicketContactPersonsResponseDataItemMobilePhoneNumberMax = 15;

export const postFetchAllTicketContactPersonsResponseDataItemMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');


export const postFetchAllTicketContactPersonsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "reference": zod.enum(['site', 'organisation']).optional(),
  "first_name": zod.string().regex(postFetchAllTicketContactPersonsResponseDataItemFirstNameRegExp).nullish(),
  "middle_name": zod.string().regex(postFetchAllTicketContactPersonsResponseDataItemMiddleNameRegExp).nullish(),
  "last_name": zod.string().regex(postFetchAllTicketContactPersonsResponseDataItemLastNameRegExp).nullish(),
  "phone_number": zod.string().min(postFetchAllTicketContactPersonsResponseDataItemPhoneNumberMin).max(postFetchAllTicketContactPersonsResponseDataItemPhoneNumberMax).regex(postFetchAllTicketContactPersonsResponseDataItemPhoneNumberRegExp).nullish(),
  "mobile_phone_number": zod.string().min(postFetchAllTicketContactPersonsResponseDataItemMobilePhoneNumberMin).max(postFetchAllTicketContactPersonsResponseDataItemMobilePhoneNumberMax).regex(postFetchAllTicketContactPersonsResponseDataItemMobilePhoneNumberRegExp).nullish(),
  "email": zod.string().nullish(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const getFetchSiteParams = zod.object({
  "id": zod.string()
})

export const getFetchSiteResponseStreetRegExp = new RegExp('[^a-zA-Z\\s\\-\\`\']');
export const getFetchSiteResponseHouseNumberMin = 0;
export const getFetchSiteResponseHouseNumberExtensionRegExp = new RegExp('[^a-zA-Z0-9\\s\\-]');
export const getFetchSiteResponsePostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');
export const getFetchSiteResponseCityRegExp = new RegExp('[^a-zA-Z\\s\'\\-]');
export const getFetchSiteResponseCountryRegExp = new RegExp('[^a-zA-Z\\s]');


export const getFetchSiteResponse = zod.object({
  "id": zod.string().optional(),
  "name": zod.string().nullish(),
  "street": zod.string().regex(getFetchSiteResponseStreetRegExp).nullish(),
  "house_number": zod.number().min(getFetchSiteResponseHouseNumberMin).nullish(),
  "house_number_extension": zod.string().regex(getFetchSiteResponseHouseNumberExtensionRegExp).nullish(),
  "post_code": zod.string().regex(getFetchSiteResponsePostCodeRegExp).nullish(),
  "city": zod.string().regex(getFetchSiteResponseCityRegExp).optional(),
  "country": zod.string().regex(getFetchSiteResponseCountryRegExp).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})


export const postFetchAllSitesQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllSitesBodyCityRegExp = new RegExp('[^a-zA-Z\\s\'\\-]/, .*[a-zA-Z\\s\'\\-].*');
export const postFetchAllSitesBodyCountryRegExp = new RegExp('[^a-zA-Z\\s]/, .*[a-zA-Z\\s].*');
export const postFetchAllSitesBodyStreetRegExp = new RegExp('[^a-zA-Z\\s\\-\\`\']/, .*[a-zA-Z\\s\\-\\`\'].*');
export const postFetchAllSitesBodyHouseNumberMin = 0;
export const postFetchAllSitesBodyHouseNumberExtensionRegExp = new RegExp('[^a-zA-Z0-9\\s\\-]/, .*[a-zA-Z0-9\\s\\-\\.\\_\\,]+');
export const postFetchAllSitesBodyPostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');


export const postFetchAllSitesBody = zod.object({
  "match_mode": zod.enum(['and', 'or']).optional(),
  "name": zod.string().nullish(),
  "city": zod.string().regex(postFetchAllSitesBodyCityRegExp).nullish(),
  "country": zod.string().regex(postFetchAllSitesBodyCountryRegExp).nullish(),
  "street": zod.string().regex(postFetchAllSitesBodyStreetRegExp).nullish(),
  "house_number": zod.number().min(postFetchAllSitesBodyHouseNumberMin).nullish(),
  "house_number_extension": zod.string().regex(postFetchAllSitesBodyHouseNumberExtensionRegExp).nullish(),
  "post_code": zod.string().regex(postFetchAllSitesBodyPostCodeRegExp).nullish(),
  "description": zod.string().nullish()
})

export const postFetchAllSitesResponseDataItemStreetRegExp = new RegExp('[^a-zA-Z\\s\\-\\`\']');
export const postFetchAllSitesResponseDataItemHouseNumberMin = 0;
export const postFetchAllSitesResponseDataItemHouseNumberExtensionRegExp = new RegExp('[^a-zA-Z0-9\\s\\-]');
export const postFetchAllSitesResponseDataItemPostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');
export const postFetchAllSitesResponseDataItemCityRegExp = new RegExp('[^a-zA-Z\\s\'\\-]');
export const postFetchAllSitesResponseDataItemCountryRegExp = new RegExp('[^a-zA-Z\\s]');


export const postFetchAllSitesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().nullish(),
  "street": zod.string().regex(postFetchAllSitesResponseDataItemStreetRegExp).nullish(),
  "house_number": zod.number().min(postFetchAllSitesResponseDataItemHouseNumberMin).nullish(),
  "house_number_extension": zod.string().regex(postFetchAllSitesResponseDataItemHouseNumberExtensionRegExp).nullish(),
  "post_code": zod.string().regex(postFetchAllSitesResponseDataItemPostCodeRegExp).nullish(),
  "city": zod.string().regex(postFetchAllSitesResponseDataItemCityRegExp).optional(),
  "country": zod.string().regex(postFetchAllSitesResponseDataItemCountryRegExp).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postCreateSiteBodyCityRegExp = new RegExp('[^a-zA-Z\\s\'\\-]/, .*[a-zA-Z\\s\'\\-].*');
export const postCreateSiteBodyCountryRegExp = new RegExp('[^a-zA-Z\\s]/, .*[a-zA-Z\\s].*');
export const postCreateSiteBodyStreetRegExp = new RegExp('[^a-zA-Z\\s\\-\\`\']/, .*[a-zA-Z\\s\\-\\`\'].*');
export const postCreateSiteBodyHouseNumberMin = 0;
export const postCreateSiteBodyHouseNumberExtensionRegExp = new RegExp('[^a-zA-Z0-9\\s\\-]/, .*[a-zA-Z0-9\\s\\-\\.\\_\\,]+');
export const postCreateSiteBodyPostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');


export const postCreateSiteBody = zod.object({
  "name": zod.string().nullish(),
  "city": zod.string().regex(postCreateSiteBodyCityRegExp),
  "country": zod.string().regex(postCreateSiteBodyCountryRegExp),
  "street": zod.string().regex(postCreateSiteBodyStreetRegExp).nullish(),
  "house_number": zod.number().min(postCreateSiteBodyHouseNumberMin).nullish(),
  "house_number_extension": zod.string().regex(postCreateSiteBodyHouseNumberExtensionRegExp).nullish(),
  "post_code": zod.string().regex(postCreateSiteBodyPostCodeRegExp).nullish(),
  "description": zod.string().nullish()
})


export const getFetchTicketParams = zod.object({
  "id": zod.string()
})

export const getFetchTicketResponseTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchTicketResponseAssigneeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchTicketResponseAssigneePricePerHourMin = 0;
export const getFetchTicketResponseSiteStreetRegExp = new RegExp('[^a-zA-Z\\s\\-\\`\']');
export const getFetchTicketResponseSiteHouseNumberMin = 0;
export const getFetchTicketResponseSiteHouseNumberExtensionRegExp = new RegExp('[^a-zA-Z0-9\\s\\-]');
export const getFetchTicketResponseSitePostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');
export const getFetchTicketResponseSiteCityRegExp = new RegExp('[^a-zA-Z\\s\'\\-]');
export const getFetchTicketResponseSiteCountryRegExp = new RegExp('[^a-zA-Z\\s]');
export const getFetchTicketResponseOrganisationNameMin = 3;

export const getFetchTicketResponseOrganisationNameMax = 127;

export const getFetchTicketResponseOrganisationNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchTicketResponseChildrenItemTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchTicketResponseParentTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchTicketResponseCommentsItemAuthorFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchTicketResponseCommentsItemAuthorLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchTicketResponseCommentsItemAuthorMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const getFetchTicketResponseArticlesItemExternalReferenceRegExp = new RegExp('[^a-zA-Z0-9\\s]');
export const getFetchTicketResponseArticlesItemBrandNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchTicketResponseArticlesItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchTicketResponseArticlesItemCodeRegExp = new RegExp('^[a-zA-Z0-9\\-_+\\s]+$');
export const getFetchTicketResponseArticlesItemSalePriceMin = 0;
export const getFetchTicketResponseArticlesItemPurchaseGrossPriceMin = 0;
export const getFetchTicketResponseArticlesItemPurchaseNetPriceMin = 0;
export const getFetchTicketResponseSiteContactPersonsItemFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchTicketResponseSiteContactPersonsItemMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const getFetchTicketResponseSiteContactPersonsItemLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchTicketResponseSiteContactPersonsItemPhoneNumberMin = 5;

export const getFetchTicketResponseSiteContactPersonsItemPhoneNumberMax = 15;

export const getFetchTicketResponseSiteContactPersonsItemPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchTicketResponseSiteContactPersonsItemMobilePhoneNumberMin = 5;

export const getFetchTicketResponseSiteContactPersonsItemMobilePhoneNumberMax = 15;

export const getFetchTicketResponseSiteContactPersonsItemMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchTicketResponseOrganisationContactPersonsItemFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchTicketResponseOrganisationContactPersonsItemMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const getFetchTicketResponseOrganisationContactPersonsItemLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchTicketResponseOrganisationContactPersonsItemPhoneNumberMin = 5;

export const getFetchTicketResponseOrganisationContactPersonsItemPhoneNumberMax = 15;

export const getFetchTicketResponseOrganisationContactPersonsItemPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchTicketResponseOrganisationContactPersonsItemMobilePhoneNumberMin = 5;

export const getFetchTicketResponseOrganisationContactPersonsItemMobilePhoneNumberMax = 15;

export const getFetchTicketResponseOrganisationContactPersonsItemMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');


export const getFetchTicketResponse = zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "title": zod.string().regex(getFetchTicketResponseTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional(),
  "status_detail": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional(),
  "priority": zod.enum(['high', 'medium', 'lows']).nullish(),
  "expected_complete_date": zod.string().date().nullish(),
  "expected_duration": zod.object({
  "hours": zod.number().optional(),
  "minutes": zod.number().optional()
}).nullish(),
  "pinned": zod.boolean().optional(),
  "scheduled_date": zod.string().nullish(),
  "unit": zod.object({
  "id": zod.string().optional()
}).nullish(),
  "assignee": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchTicketResponseAssigneeNameRegExp).optional(),
  "function": zod.enum(['mechanic']).optional(),
  "price_per_hour": zod.number().min(getFetchTicketResponseAssigneePricePerHourMin).optional()
}).nullish(),
  "site": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().nullish(),
  "street": zod.string().regex(getFetchTicketResponseSiteStreetRegExp).nullish(),
  "house_number": zod.number().min(getFetchTicketResponseSiteHouseNumberMin).nullish(),
  "house_number_extension": zod.string().regex(getFetchTicketResponseSiteHouseNumberExtensionRegExp).nullish(),
  "post_code": zod.string().regex(getFetchTicketResponseSitePostCodeRegExp).nullish(),
  "city": zod.string().regex(getFetchTicketResponseSiteCityRegExp).optional(),
  "country": zod.string().regex(getFetchTicketResponseSiteCountryRegExp).optional(),
  "description": zod.string().nullish()
}).nullish(),
  "organisation": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().min(getFetchTicketResponseOrganisationNameMin).max(getFetchTicketResponseOrganisationNameMax).regex(getFetchTicketResponseOrganisationNameRegExp).optional()
}).optional(),
  "description": zod.string().nullish(),
  "assignments": zod.array(zod.object({
  "id": zod.string().optional(),
  "status": zod.enum(['open', 'closed']).optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "action": zod.string().optional(),
  "action_type": zod.enum(['action', 'recipe']).optional()
})).optional(),
  "children": zod.array(zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "title": zod.string().regex(getFetchTicketResponseChildrenItemTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
})).optional(),
  "parent": zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "title": zod.string().regex(getFetchTicketResponseParentTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
}).nullish(),
  "comments": zod.array(zod.object({
  "id": zod.string().optional(),
  "access_level": zod.enum(['public', 'internal']).optional(),
  "content": zod.string().optional(),
  "type": zod.enum(['user', 'case']).optional(),
  "created_at": zod.string().date().optional(),
  "author": zod.object({
  "id": zod.string().optional(),
  "first_name": zod.string().regex(getFetchTicketResponseCommentsItemAuthorFirstNameRegExp).optional(),
  "last_name": zod.string().regex(getFetchTicketResponseCommentsItemAuthorLastNameRegExp).optional(),
  "middle_name": zod.string().regex(getFetchTicketResponseCommentsItemAuthorMiddleNameRegExp).nullish()
}).optional()
})).optional(),
  "created_at": zod.string().date().optional(),
  "articles": zod.array(zod.object({
  "id": zod.string().optional(),
  "association_id": zod.string().optional(),
  "external_reference": zod.string().regex(getFetchTicketResponseArticlesItemExternalReferenceRegExp).optional(),
  "brand_name": zod.string().regex(getFetchTicketResponseArticlesItemBrandNameRegExp).optional(),
  "name": zod.string().regex(getFetchTicketResponseArticlesItemNameRegExp).optional(),
  "code": zod.string().regex(getFetchTicketResponseArticlesItemCodeRegExp).optional(),
  "sale_price": zod.number().min(getFetchTicketResponseArticlesItemSalePriceMin).optional(),
  "purchase_gross_price": zod.number().min(getFetchTicketResponseArticlesItemPurchaseGrossPriceMin).optional(),
  "purchase_net_price": zod.number().min(getFetchTicketResponseArticlesItemPurchaseNetPriceMin).optional(),
  "measurement": zod.enum(['liter', 'kilogram', 'piece']).optional(),
  "quantity": zod.number().optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "location": zod.string().nullish()
})).optional(),
  "site_contact_persons": zod.array(zod.object({
  "id": zod.string().optional(),
  "reference": zod.enum(['site', 'organisation']).optional(),
  "first_name": zod.string().regex(getFetchTicketResponseSiteContactPersonsItemFirstNameRegExp).nullish(),
  "middle_name": zod.string().regex(getFetchTicketResponseSiteContactPersonsItemMiddleNameRegExp).nullish(),
  "last_name": zod.string().regex(getFetchTicketResponseSiteContactPersonsItemLastNameRegExp).nullish(),
  "phone_number": zod.string().min(getFetchTicketResponseSiteContactPersonsItemPhoneNumberMin).max(getFetchTicketResponseSiteContactPersonsItemPhoneNumberMax).regex(getFetchTicketResponseSiteContactPersonsItemPhoneNumberRegExp).nullish(),
  "mobile_phone_number": zod.string().min(getFetchTicketResponseSiteContactPersonsItemMobilePhoneNumberMin).max(getFetchTicketResponseSiteContactPersonsItemMobilePhoneNumberMax).regex(getFetchTicketResponseSiteContactPersonsItemMobilePhoneNumberRegExp).nullish(),
  "email": zod.string().nullish()
})).optional(),
  "organisation_contact_persons": zod.array(zod.object({
  "id": zod.string().optional(),
  "reference": zod.enum(['site', 'organisation']).optional(),
  "first_name": zod.string().regex(getFetchTicketResponseOrganisationContactPersonsItemFirstNameRegExp).nullish(),
  "middle_name": zod.string().regex(getFetchTicketResponseOrganisationContactPersonsItemMiddleNameRegExp).nullish(),
  "last_name": zod.string().regex(getFetchTicketResponseOrganisationContactPersonsItemLastNameRegExp).nullish(),
  "phone_number": zod.string().min(getFetchTicketResponseOrganisationContactPersonsItemPhoneNumberMin).max(getFetchTicketResponseOrganisationContactPersonsItemPhoneNumberMax).regex(getFetchTicketResponseOrganisationContactPersonsItemPhoneNumberRegExp).nullish(),
  "mobile_phone_number": zod.string().min(getFetchTicketResponseOrganisationContactPersonsItemMobilePhoneNumberMin).max(getFetchTicketResponseOrganisationContactPersonsItemMobilePhoneNumberMax).regex(getFetchTicketResponseOrganisationContactPersonsItemMobilePhoneNumberRegExp).nullish(),
  "email": zod.string().nullish()
})).optional(),
  "files": zod.array(zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['image', 'signature']).optional()
})).optional(),
  "acknowledgement": zod.object({
  "id": zod.string().optional(),
  "first_name": zod.string().optional(),
  "last_name": zod.string().optional(),
  "phone_number": zod.string().optional(),
  "email": zod.string().optional(),
  "signature": zod.object({
  "id": zod.string().optional()
}).optional(),
  "ip_address": zod.string().optional(),
  "device_information": zod.string().optional(),
  "consent": zod.boolean().optional(),
  "created_at": zod.string().date().optional()
}).nullish(),
  "case": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).nullish(),
  "case_detail": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
})


export const patchPatchTicketParams = zod.object({
  "id": zod.string()
})

export const patchPatchTicketBodyTitleRegExp = new RegExp('.*[a-zA-Z\\s]+');


export const patchPatchTicketBody = zod.object({
  "type": zod.enum(['fixed']).nullish(),
  "title": zod.string().regex(patchPatchTicketBodyTitleRegExp).nullish(),
  "priority": zod.enum(['high', 'medium', 'lows']).nullish(),
  "expected_complete_date": zod.string().date().nullish(),
  "expected_duration": zod.array(zod.number()).optional(),
  "scheduled_date": zod.string().date().nullish(),
  "description": zod.string().nullish()
})


/**
 * Fetch PDF from ticket service
 * @summary Get ticket PDF by ID
 */
export const getFetchTicketPdfParams = zod.object({
  "id": zod.string().uuid()
})


export const postFetchAllTicketsQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllTicketsBody = zod.object({
  "match_mode": zod.enum(['and', 'or']).optional(),
  "number": zod.number().nullish(),
  "start_date": zod.string().date().nullish(),
  "end_date": zod.string().date().nullish(),
  "type": zod.string().nullish(),
  "title": zod.string().nullish(),
  "status_id": zod.string().uuid().nullish(),
  "priority": zod.enum(['high', 'medium', 'low']).nullish(),
  "description": zod.string().nullish(),
  "unit_id": zod.string().nullish(),
  "assignee_id": zod.string().nullish()
})

export const postFetchAllTicketsResponseDataItemTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllTicketsResponseDataItemUnitNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllTicketsResponseDataItemUnitFleetNumberMin = 0;
export const postFetchAllTicketsResponseDataItemUnitSerialNumberRegExp = new RegExp('^[a-zA-Z0-9]+$');
export const postFetchAllTicketsResponseDataItemUnitLicensePlateNumberRegExp = new RegExp('^[A-Z0-9\\s\\-]');
export const postFetchAllTicketsResponseDataItemUnitManufactureNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllTicketsResponseDataItemUnitCategoryNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllTicketsResponseDataItemAssigneeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllTicketsResponseDataItemAssigneePricePerHourMin = 0;
export const postFetchAllTicketsResponseDataItemSiteStreetRegExp = new RegExp('[^a-zA-Z\\s\\-\\`\']');
export const postFetchAllTicketsResponseDataItemSiteHouseNumberMin = 0;
export const postFetchAllTicketsResponseDataItemSiteHouseNumberExtensionRegExp = new RegExp('[^a-zA-Z0-9\\s\\-]');
export const postFetchAllTicketsResponseDataItemSitePostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');
export const postFetchAllTicketsResponseDataItemSiteCityRegExp = new RegExp('[^a-zA-Z\\s\'\\-]');
export const postFetchAllTicketsResponseDataItemSiteCountryRegExp = new RegExp('[^a-zA-Z\\s]');
export const postFetchAllTicketsResponseDataItemOrganisationNameMin = 3;

export const postFetchAllTicketsResponseDataItemOrganisationNameMax = 127;

export const postFetchAllTicketsResponseDataItemOrganisationNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllTicketsResponseDataItemChildrenItemTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllTicketsResponseDataItemParentTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllTicketsResponseDataItemArticleAssociationsItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllTicketsResponseDataItemSiteContactPersonsItemFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllTicketsResponseDataItemSiteContactPersonsItemMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const postFetchAllTicketsResponseDataItemSiteContactPersonsItemLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllTicketsResponseDataItemSiteContactPersonsItemPhoneNumberMin = 5;

export const postFetchAllTicketsResponseDataItemSiteContactPersonsItemPhoneNumberMax = 15;

export const postFetchAllTicketsResponseDataItemSiteContactPersonsItemPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberMin = 5;

export const postFetchAllTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberMax = 15;

export const postFetchAllTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberMin = 5;

export const postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberMax = 15;

export const postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberMin = 5;

export const postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberMax = 15;

export const postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');


export const postFetchAllTicketsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'dynamic']).optional(),
  "title": zod.string().regex(postFetchAllTicketsResponseDataItemTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional(),
  "status_detail": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional(),
  "priority": zod.enum(['high', 'medium', 'lows']).nullish(),
  "expected_complete_date": zod.string().date().nullish(),
  "expected_duration": zod.object({
  "hours": zod.number().optional(),
  "minutes": zod.number().optional()
}).nullish(),
  "pinned": zod.boolean().optional(),
  "scheduled_date": zod.string().nullish(),
  "unit": zod.object({
  "name": zod.string().regex(postFetchAllTicketsResponseDataItemUnitNameRegExp).optional(),
  "fleet_number": zod.number().min(postFetchAllTicketsResponseDataItemUnitFleetNumberMin).optional(),
  "serial_number": zod.string().regex(postFetchAllTicketsResponseDataItemUnitSerialNumberRegExp).optional(),
  "license_plate_number": zod.string().regex(postFetchAllTicketsResponseDataItemUnitLicensePlateNumberRegExp).nullish(),
  "manufacture_name": zod.string().regex(postFetchAllTicketsResponseDataItemUnitManufactureNameRegExp).optional(),
  "category_name": zod.string().regex(postFetchAllTicketsResponseDataItemUnitCategoryNameRegExp).optional()
}).nullish(),
  "assignee": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllTicketsResponseDataItemAssigneeNameRegExp).optional(),
  "function": zod.enum(['mechanic']).optional(),
  "price_per_hour": zod.number().min(postFetchAllTicketsResponseDataItemAssigneePricePerHourMin).optional()
}).nullish(),
  "site": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().nullish(),
  "street": zod.string().regex(postFetchAllTicketsResponseDataItemSiteStreetRegExp).nullish(),
  "house_number": zod.number().min(postFetchAllTicketsResponseDataItemSiteHouseNumberMin).nullish(),
  "house_number_extension": zod.string().regex(postFetchAllTicketsResponseDataItemSiteHouseNumberExtensionRegExp).nullish(),
  "post_code": zod.string().regex(postFetchAllTicketsResponseDataItemSitePostCodeRegExp).nullish(),
  "city": zod.string().regex(postFetchAllTicketsResponseDataItemSiteCityRegExp).optional(),
  "country": zod.string().regex(postFetchAllTicketsResponseDataItemSiteCountryRegExp).optional(),
  "description": zod.string().nullish()
}).nullish(),
  "organisation": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().min(postFetchAllTicketsResponseDataItemOrganisationNameMin).max(postFetchAllTicketsResponseDataItemOrganisationNameMax).regex(postFetchAllTicketsResponseDataItemOrganisationNameRegExp).optional()
}).optional(),
  "description": zod.string().nullish(),
  "assignments": zod.array(zod.object({
  "id": zod.string().optional(),
  "status": zod.enum(['open', 'closed']).optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "action": zod.string().optional(),
  "action_type": zod.enum(['action', 'recipe']).optional()
})).optional(),
  "children": zod.array(zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "title": zod.string().regex(postFetchAllTicketsResponseDataItemChildrenItemTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
})).optional(),
  "parent": zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "title": zod.string().regex(postFetchAllTicketsResponseDataItemParentTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
}).nullish(),
  "comments": zod.array(zod.object({
  "id": zod.string().optional(),
  "access_level": zod.enum(['public', 'internal']).optional(),
  "content": zod.string().optional()
})).optional(),
  "created_at": zod.string().date().optional(),
  "article_associations": zod.array(zod.object({
  "id": zod.string().optional(),
  "article_id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllTicketsResponseDataItemArticleAssociationsItemNameRegExp).optional(),
  "quantity": zod.number().optional(),
  "ticket_id": zod.string().optional(),
  "price": zod.number().nullish(),
  "type": zod.enum(['fixed', 'variable']).optional()
})).optional(),
  "site_contact_persons": zod.array(zod.object({
  "id": zod.string().optional(),
  "reference": zod.enum(['site', 'organisation']).optional(),
  "first_name": zod.string().regex(postFetchAllTicketsResponseDataItemSiteContactPersonsItemFirstNameRegExp).nullish(),
  "middle_name": zod.string().regex(postFetchAllTicketsResponseDataItemSiteContactPersonsItemMiddleNameRegExp).nullish(),
  "last_name": zod.string().regex(postFetchAllTicketsResponseDataItemSiteContactPersonsItemLastNameRegExp).nullish(),
  "phone_number": zod.string().min(postFetchAllTicketsResponseDataItemSiteContactPersonsItemPhoneNumberMin).max(postFetchAllTicketsResponseDataItemSiteContactPersonsItemPhoneNumberMax).regex(postFetchAllTicketsResponseDataItemSiteContactPersonsItemPhoneNumberRegExp).nullish(),
  "mobile_phone_number": zod.string().min(postFetchAllTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberMin).max(postFetchAllTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberMax).regex(postFetchAllTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberRegExp).nullish(),
  "email": zod.string().nullish()
})).optional(),
  "organisation_contact_persons": zod.array(zod.object({
  "id": zod.string().optional(),
  "reference": zod.enum(['site', 'organisation']).optional(),
  "first_name": zod.string().regex(postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemFirstNameRegExp).nullish(),
  "middle_name": zod.string().regex(postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemMiddleNameRegExp).nullish(),
  "last_name": zod.string().regex(postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemLastNameRegExp).nullish(),
  "phone_number": zod.string().min(postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberMin).max(postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberMax).regex(postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberRegExp).nullish(),
  "mobile_phone_number": zod.string().min(postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberMin).max(postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberMax).regex(postFetchAllTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberRegExp).nullish(),
  "email": zod.string().nullish()
})).optional(),
  "files": zod.array(zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['image', 'signature']).optional()
})).optional(),
  "case": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).nullish(),
  "case_detail": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


/**
 * The array of the scheduled tickets for the current and next day
 */
export const postFetchAllScheduledTicketsResponseDataItemTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllScheduledTicketsResponseDataItemUnitNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllScheduledTicketsResponseDataItemUnitFleetNumberMin = 0;
export const postFetchAllScheduledTicketsResponseDataItemUnitSerialNumberRegExp = new RegExp('^[a-zA-Z0-9]+$');
export const postFetchAllScheduledTicketsResponseDataItemUnitLicensePlateNumberRegExp = new RegExp('^[A-Z0-9\\s\\-]');
export const postFetchAllScheduledTicketsResponseDataItemUnitManufactureNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllScheduledTicketsResponseDataItemUnitCategoryNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllScheduledTicketsResponseDataItemAssigneeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllScheduledTicketsResponseDataItemAssigneePricePerHourMin = 0;
export const postFetchAllScheduledTicketsResponseDataItemSiteStreetRegExp = new RegExp('[^a-zA-Z\\s\\-\\`\']');
export const postFetchAllScheduledTicketsResponseDataItemSiteHouseNumberMin = 0;
export const postFetchAllScheduledTicketsResponseDataItemSiteHouseNumberExtensionRegExp = new RegExp('[^a-zA-Z0-9\\s\\-]');
export const postFetchAllScheduledTicketsResponseDataItemSitePostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');
export const postFetchAllScheduledTicketsResponseDataItemSiteCityRegExp = new RegExp('[^a-zA-Z\\s\'\\-]');
export const postFetchAllScheduledTicketsResponseDataItemSiteCountryRegExp = new RegExp('[^a-zA-Z\\s]');
export const postFetchAllScheduledTicketsResponseDataItemOrganisationNameMin = 3;

export const postFetchAllScheduledTicketsResponseDataItemOrganisationNameMax = 127;

export const postFetchAllScheduledTicketsResponseDataItemOrganisationNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllScheduledTicketsResponseDataItemChildrenItemTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllScheduledTicketsResponseDataItemParentTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllScheduledTicketsResponseDataItemArticleAssociationsItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberMin = 5;

export const postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberMax = 15;

export const postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberMin = 5;

export const postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberMax = 15;

export const postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberMin = 5;

export const postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberMax = 15;

export const postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberMin = 5;

export const postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberMax = 15;

export const postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');


export const postFetchAllScheduledTicketsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'dynamic']).optional(),
  "title": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional(),
  "status_detail": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional(),
  "priority": zod.enum(['high', 'medium', 'lows']).nullish(),
  "expected_complete_date": zod.string().date().nullish(),
  "expected_duration": zod.object({
  "hours": zod.number().optional(),
  "minutes": zod.number().optional()
}).nullish(),
  "pinned": zod.boolean().optional(),
  "scheduled_date": zod.string().nullish(),
  "unit": zod.object({
  "name": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemUnitNameRegExp).optional(),
  "fleet_number": zod.number().min(postFetchAllScheduledTicketsResponseDataItemUnitFleetNumberMin).optional(),
  "serial_number": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemUnitSerialNumberRegExp).optional(),
  "license_plate_number": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemUnitLicensePlateNumberRegExp).nullish(),
  "manufacture_name": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemUnitManufactureNameRegExp).optional(),
  "category_name": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemUnitCategoryNameRegExp).optional()
}).nullish(),
  "assignee": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemAssigneeNameRegExp).optional(),
  "function": zod.enum(['mechanic']).optional(),
  "price_per_hour": zod.number().min(postFetchAllScheduledTicketsResponseDataItemAssigneePricePerHourMin).optional()
}).nullish(),
  "site": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().nullish(),
  "street": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemSiteStreetRegExp).nullish(),
  "house_number": zod.number().min(postFetchAllScheduledTicketsResponseDataItemSiteHouseNumberMin).nullish(),
  "house_number_extension": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemSiteHouseNumberExtensionRegExp).nullish(),
  "post_code": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemSitePostCodeRegExp).nullish(),
  "city": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemSiteCityRegExp).optional(),
  "country": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemSiteCountryRegExp).optional(),
  "description": zod.string().nullish()
}).nullish(),
  "organisation": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().min(postFetchAllScheduledTicketsResponseDataItemOrganisationNameMin).max(postFetchAllScheduledTicketsResponseDataItemOrganisationNameMax).regex(postFetchAllScheduledTicketsResponseDataItemOrganisationNameRegExp).optional()
}).optional(),
  "description": zod.string().nullish(),
  "assignments": zod.array(zod.object({
  "id": zod.string().optional(),
  "status": zod.enum(['open', 'closed']).optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "action": zod.string().optional(),
  "action_type": zod.enum(['action', 'recipe']).optional()
})).optional(),
  "children": zod.array(zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "title": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemChildrenItemTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
})).optional(),
  "parent": zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "title": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemParentTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
}).nullish(),
  "comments": zod.array(zod.object({
  "id": zod.string().optional(),
  "access_level": zod.enum(['public', 'internal']).optional(),
  "content": zod.string().optional()
})).optional(),
  "created_at": zod.string().date().optional(),
  "article_associations": zod.array(zod.object({
  "id": zod.string().optional(),
  "article_id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemArticleAssociationsItemNameRegExp).optional(),
  "quantity": zod.number().optional(),
  "ticket_id": zod.string().optional(),
  "price": zod.number().nullish(),
  "type": zod.enum(['fixed', 'variable']).optional()
})).optional(),
  "site_contact_persons": zod.array(zod.object({
  "id": zod.string().optional(),
  "reference": zod.enum(['site', 'organisation']).optional(),
  "first_name": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemFirstNameRegExp).nullish(),
  "middle_name": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemMiddleNameRegExp).nullish(),
  "last_name": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemLastNameRegExp).nullish(),
  "phone_number": zod.string().min(postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberMin).max(postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberMax).regex(postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberRegExp).nullish(),
  "mobile_phone_number": zod.string().min(postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberMin).max(postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberMax).regex(postFetchAllScheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberRegExp).nullish(),
  "email": zod.string().nullish()
})).optional(),
  "organisation_contact_persons": zod.array(zod.object({
  "id": zod.string().optional(),
  "reference": zod.enum(['site', 'organisation']).optional(),
  "first_name": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemFirstNameRegExp).nullish(),
  "middle_name": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemMiddleNameRegExp).nullish(),
  "last_name": zod.string().regex(postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemLastNameRegExp).nullish(),
  "phone_number": zod.string().min(postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberMin).max(postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberMax).regex(postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberRegExp).nullish(),
  "mobile_phone_number": zod.string().min(postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberMin).max(postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberMax).regex(postFetchAllScheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberRegExp).nullish(),
  "email": zod.string().nullish()
})).optional(),
  "files": zod.array(zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['image', 'signature']).optional()
})).optional(),
  "case": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).nullish(),
  "case_detail": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
})).optional()
})


/**
 * The array of the tickets with nullable scheduled date
 */
export const postFetchAllUnscheduledTicketsQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllUnscheduledTicketsResponseDataItemTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllUnscheduledTicketsResponseDataItemUnitNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllUnscheduledTicketsResponseDataItemUnitFleetNumberMin = 0;
export const postFetchAllUnscheduledTicketsResponseDataItemUnitSerialNumberRegExp = new RegExp('^[a-zA-Z0-9]+$');
export const postFetchAllUnscheduledTicketsResponseDataItemUnitLicensePlateNumberRegExp = new RegExp('^[A-Z0-9\\s\\-]');
export const postFetchAllUnscheduledTicketsResponseDataItemUnitManufactureNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllUnscheduledTicketsResponseDataItemUnitCategoryNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllUnscheduledTicketsResponseDataItemAssigneeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllUnscheduledTicketsResponseDataItemAssigneePricePerHourMin = 0;
export const postFetchAllUnscheduledTicketsResponseDataItemSiteStreetRegExp = new RegExp('[^a-zA-Z\\s\\-\\`\']');
export const postFetchAllUnscheduledTicketsResponseDataItemSiteHouseNumberMin = 0;
export const postFetchAllUnscheduledTicketsResponseDataItemSiteHouseNumberExtensionRegExp = new RegExp('[^a-zA-Z0-9\\s\\-]');
export const postFetchAllUnscheduledTicketsResponseDataItemSitePostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');
export const postFetchAllUnscheduledTicketsResponseDataItemSiteCityRegExp = new RegExp('[^a-zA-Z\\s\'\\-]');
export const postFetchAllUnscheduledTicketsResponseDataItemSiteCountryRegExp = new RegExp('[^a-zA-Z\\s]');
export const postFetchAllUnscheduledTicketsResponseDataItemOrganisationNameMin = 3;

export const postFetchAllUnscheduledTicketsResponseDataItemOrganisationNameMax = 127;

export const postFetchAllUnscheduledTicketsResponseDataItemOrganisationNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllUnscheduledTicketsResponseDataItemChildrenItemTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllUnscheduledTicketsResponseDataItemParentTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllUnscheduledTicketsResponseDataItemArticleAssociationsItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberMin = 5;

export const postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberMax = 15;

export const postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberMin = 5;

export const postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberMax = 15;

export const postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberMin = 5;

export const postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberMax = 15;

export const postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberMin = 5;

export const postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberMax = 15;

export const postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');


export const postFetchAllUnscheduledTicketsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'dynamic']).optional(),
  "title": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional(),
  "status_detail": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional(),
  "priority": zod.enum(['high', 'medium', 'lows']).nullish(),
  "expected_complete_date": zod.string().date().nullish(),
  "expected_duration": zod.object({
  "hours": zod.number().optional(),
  "minutes": zod.number().optional()
}).nullish(),
  "pinned": zod.boolean().optional(),
  "scheduled_date": zod.string().nullish(),
  "unit": zod.object({
  "name": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemUnitNameRegExp).optional(),
  "fleet_number": zod.number().min(postFetchAllUnscheduledTicketsResponseDataItemUnitFleetNumberMin).optional(),
  "serial_number": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemUnitSerialNumberRegExp).optional(),
  "license_plate_number": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemUnitLicensePlateNumberRegExp).nullish(),
  "manufacture_name": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemUnitManufactureNameRegExp).optional(),
  "category_name": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemUnitCategoryNameRegExp).optional()
}).nullish(),
  "assignee": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemAssigneeNameRegExp).optional(),
  "function": zod.enum(['mechanic']).optional(),
  "price_per_hour": zod.number().min(postFetchAllUnscheduledTicketsResponseDataItemAssigneePricePerHourMin).optional()
}).nullish(),
  "site": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().nullish(),
  "street": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemSiteStreetRegExp).nullish(),
  "house_number": zod.number().min(postFetchAllUnscheduledTicketsResponseDataItemSiteHouseNumberMin).nullish(),
  "house_number_extension": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemSiteHouseNumberExtensionRegExp).nullish(),
  "post_code": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemSitePostCodeRegExp).nullish(),
  "city": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemSiteCityRegExp).optional(),
  "country": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemSiteCountryRegExp).optional(),
  "description": zod.string().nullish()
}).nullish(),
  "organisation": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().min(postFetchAllUnscheduledTicketsResponseDataItemOrganisationNameMin).max(postFetchAllUnscheduledTicketsResponseDataItemOrganisationNameMax).regex(postFetchAllUnscheduledTicketsResponseDataItemOrganisationNameRegExp).optional()
}).optional(),
  "description": zod.string().nullish(),
  "assignments": zod.array(zod.object({
  "id": zod.string().optional(),
  "status": zod.enum(['open', 'closed']).optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "action": zod.string().optional(),
  "action_type": zod.enum(['action', 'recipe']).optional()
})).optional(),
  "children": zod.array(zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "title": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemChildrenItemTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
})).optional(),
  "parent": zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "title": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemParentTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
}).nullish(),
  "comments": zod.array(zod.object({
  "id": zod.string().optional(),
  "access_level": zod.enum(['public', 'internal']).optional(),
  "content": zod.string().optional()
})).optional(),
  "created_at": zod.string().date().optional(),
  "article_associations": zod.array(zod.object({
  "id": zod.string().optional(),
  "article_id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemArticleAssociationsItemNameRegExp).optional(),
  "quantity": zod.number().optional(),
  "ticket_id": zod.string().optional(),
  "price": zod.number().nullish(),
  "type": zod.enum(['fixed', 'variable']).optional()
})).optional(),
  "site_contact_persons": zod.array(zod.object({
  "id": zod.string().optional(),
  "reference": zod.enum(['site', 'organisation']).optional(),
  "first_name": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemFirstNameRegExp).nullish(),
  "middle_name": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemMiddleNameRegExp).nullish(),
  "last_name": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemLastNameRegExp).nullish(),
  "phone_number": zod.string().min(postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberMin).max(postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberMax).regex(postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberRegExp).nullish(),
  "mobile_phone_number": zod.string().min(postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberMin).max(postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberMax).regex(postFetchAllUnscheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberRegExp).nullish(),
  "email": zod.string().nullish()
})).optional(),
  "organisation_contact_persons": zod.array(zod.object({
  "id": zod.string().optional(),
  "reference": zod.enum(['site', 'organisation']).optional(),
  "first_name": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemFirstNameRegExp).nullish(),
  "middle_name": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemMiddleNameRegExp).nullish(),
  "last_name": zod.string().regex(postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemLastNameRegExp).nullish(),
  "phone_number": zod.string().min(postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberMin).max(postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberMax).regex(postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberRegExp).nullish(),
  "mobile_phone_number": zod.string().min(postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberMin).max(postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberMax).regex(postFetchAllUnscheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberRegExp).nullish(),
  "email": zod.string().nullish()
})).optional(),
  "files": zod.array(zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['image', 'signature']).optional()
})).optional(),
  "case": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).nullish(),
  "case_detail": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


/**
 * The array of the not done scheduled tickets to the current day
 */
export const postFetchOverdueScheduledTicketsResponseDataItemTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchOverdueScheduledTicketsResponseDataItemUnitNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchOverdueScheduledTicketsResponseDataItemUnitFleetNumberMin = 0;
export const postFetchOverdueScheduledTicketsResponseDataItemUnitSerialNumberRegExp = new RegExp('^[a-zA-Z0-9]+$');
export const postFetchOverdueScheduledTicketsResponseDataItemUnitLicensePlateNumberRegExp = new RegExp('^[A-Z0-9\\s\\-]');
export const postFetchOverdueScheduledTicketsResponseDataItemUnitManufactureNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchOverdueScheduledTicketsResponseDataItemUnitCategoryNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchOverdueScheduledTicketsResponseDataItemAssigneeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchOverdueScheduledTicketsResponseDataItemAssigneePricePerHourMin = 0;
export const postFetchOverdueScheduledTicketsResponseDataItemSiteStreetRegExp = new RegExp('[^a-zA-Z\\s\\-\\`\']');
export const postFetchOverdueScheduledTicketsResponseDataItemSiteHouseNumberMin = 0;
export const postFetchOverdueScheduledTicketsResponseDataItemSiteHouseNumberExtensionRegExp = new RegExp('[^a-zA-Z0-9\\s\\-]');
export const postFetchOverdueScheduledTicketsResponseDataItemSitePostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');
export const postFetchOverdueScheduledTicketsResponseDataItemSiteCityRegExp = new RegExp('[^a-zA-Z\\s\'\\-]');
export const postFetchOverdueScheduledTicketsResponseDataItemSiteCountryRegExp = new RegExp('[^a-zA-Z\\s]');
export const postFetchOverdueScheduledTicketsResponseDataItemOrganisationNameMin = 3;

export const postFetchOverdueScheduledTicketsResponseDataItemOrganisationNameMax = 127;

export const postFetchOverdueScheduledTicketsResponseDataItemOrganisationNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchOverdueScheduledTicketsResponseDataItemChildrenItemTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchOverdueScheduledTicketsResponseDataItemParentTitleRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchOverdueScheduledTicketsResponseDataItemArticleAssociationsItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberMin = 5;

export const postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberMax = 15;

export const postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberMin = 5;

export const postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberMax = 15;

export const postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberMin = 5;

export const postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberMax = 15;

export const postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberMin = 5;

export const postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberMax = 15;

export const postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');


export const postFetchOverdueScheduledTicketsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'dynamic']).optional(),
  "title": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional(),
  "status_detail": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional(),
  "priority": zod.enum(['high', 'medium', 'lows']).nullish(),
  "expected_complete_date": zod.string().date().nullish(),
  "expected_duration": zod.object({
  "hours": zod.number().optional(),
  "minutes": zod.number().optional()
}).nullish(),
  "pinned": zod.boolean().optional(),
  "scheduled_date": zod.string().nullish(),
  "unit": zod.object({
  "name": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemUnitNameRegExp).optional(),
  "fleet_number": zod.number().min(postFetchOverdueScheduledTicketsResponseDataItemUnitFleetNumberMin).optional(),
  "serial_number": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemUnitSerialNumberRegExp).optional(),
  "license_plate_number": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemUnitLicensePlateNumberRegExp).nullish(),
  "manufacture_name": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemUnitManufactureNameRegExp).optional(),
  "category_name": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemUnitCategoryNameRegExp).optional()
}).nullish(),
  "assignee": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemAssigneeNameRegExp).optional(),
  "function": zod.enum(['mechanic']).optional(),
  "price_per_hour": zod.number().min(postFetchOverdueScheduledTicketsResponseDataItemAssigneePricePerHourMin).optional()
}).nullish(),
  "site": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().nullish(),
  "street": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemSiteStreetRegExp).nullish(),
  "house_number": zod.number().min(postFetchOverdueScheduledTicketsResponseDataItemSiteHouseNumberMin).nullish(),
  "house_number_extension": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemSiteHouseNumberExtensionRegExp).nullish(),
  "post_code": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemSitePostCodeRegExp).nullish(),
  "city": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemSiteCityRegExp).optional(),
  "country": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemSiteCountryRegExp).optional(),
  "description": zod.string().nullish()
}).nullish(),
  "organisation": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().min(postFetchOverdueScheduledTicketsResponseDataItemOrganisationNameMin).max(postFetchOverdueScheduledTicketsResponseDataItemOrganisationNameMax).regex(postFetchOverdueScheduledTicketsResponseDataItemOrganisationNameRegExp).optional()
}).optional(),
  "description": zod.string().nullish(),
  "assignments": zod.array(zod.object({
  "id": zod.string().optional(),
  "status": zod.enum(['open', 'closed']).optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "action": zod.string().optional(),
  "action_type": zod.enum(['action', 'recipe']).optional()
})).optional(),
  "children": zod.array(zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "title": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemChildrenItemTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
})).optional(),
  "parent": zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['fixed', 'variable']).optional(),
  "title": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemParentTitleRegExp).optional(),
  "number": zod.number().optional(),
  "status": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
}).nullish(),
  "comments": zod.array(zod.object({
  "id": zod.string().optional(),
  "access_level": zod.enum(['public', 'internal']).optional(),
  "content": zod.string().optional()
})).optional(),
  "created_at": zod.string().date().optional(),
  "article_associations": zod.array(zod.object({
  "id": zod.string().optional(),
  "article_id": zod.string().optional(),
  "name": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemArticleAssociationsItemNameRegExp).optional(),
  "quantity": zod.number().optional(),
  "ticket_id": zod.string().optional(),
  "price": zod.number().nullish(),
  "type": zod.enum(['fixed', 'variable']).optional()
})).optional(),
  "site_contact_persons": zod.array(zod.object({
  "id": zod.string().optional(),
  "reference": zod.enum(['site', 'organisation']).optional(),
  "first_name": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemFirstNameRegExp).nullish(),
  "middle_name": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemMiddleNameRegExp).nullish(),
  "last_name": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemLastNameRegExp).nullish(),
  "phone_number": zod.string().min(postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberMin).max(postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberMax).regex(postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemPhoneNumberRegExp).nullish(),
  "mobile_phone_number": zod.string().min(postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberMin).max(postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberMax).regex(postFetchOverdueScheduledTicketsResponseDataItemSiteContactPersonsItemMobilePhoneNumberRegExp).nullish(),
  "email": zod.string().nullish()
})).optional(),
  "organisation_contact_persons": zod.array(zod.object({
  "id": zod.string().optional(),
  "reference": zod.enum(['site', 'organisation']).optional(),
  "first_name": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemFirstNameRegExp).nullish(),
  "middle_name": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemMiddleNameRegExp).nullish(),
  "last_name": zod.string().regex(postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemLastNameRegExp).nullish(),
  "phone_number": zod.string().min(postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberMin).max(postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberMax).regex(postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemPhoneNumberRegExp).nullish(),
  "mobile_phone_number": zod.string().min(postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberMin).max(postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberMax).regex(postFetchOverdueScheduledTicketsResponseDataItemOrganisationContactPersonsItemMobilePhoneNumberRegExp).nullish(),
  "email": zod.string().nullish()
})).optional(),
  "files": zod.array(zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['image', 'signature']).optional()
})).optional(),
  "case": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).nullish(),
  "case_detail": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
}).optional()
})).optional()
})


/**
 * Fetch all tickets associated with a specific unit
 * @summary Get tickets by unit ID
 */
export const postFetchTicketsByUnitParams = zod.object({
  "id": zod.string()
})


export const postCreateTicketBodyTitleRegExp = new RegExp('^[a-zA-Z\\s]+$/, .*[a-zA-Z\\s]+');


export const postCreateTicketBody = zod.object({
  "title": zod.string().regex(postCreateTicketBodyTitleRegExp),
  "status_id": zod.string().uuid(),
  "type": zod.enum(['fixed', 'variable']).nullish(),
  "priority": zod.enum(['high', 'medium', 'lows']).nullish(),
  "expected_complete_date": zod.string().date().nullish(),
  "scheduled_date": zod.string().date().nullish(),
  "expected_duration": zod.array(zod.string()).nullish(),
  "unit_id": zod.string().nullish(),
  "assignee_id": zod.string().nullish(),
  "site_id": zod.string().nullish(),
  "description": zod.string().nullish(),
  "organisation_id": zod.string().nullish(),
  "parent_id": zod.string().nullish(),
  "site_contact_person_id": zod.string().nullish(),
  "organisation_contact_person_id": zod.string().nullish()
})


export const postUpdateTicketTitleParams = zod.object({
  "id": zod.string()
})

export const postUpdateTicketTitleBodyTitleRegExp = new RegExp('[a-zA-Z\\s]+$');


export const postUpdateTicketTitleBody = zod.object({
  "title": zod.string().regex(postUpdateTicketTitleBodyTitleRegExp).optional()
})


export const postUpdateTicketDescriptionParams = zod.object({
  "id": zod.string()
})

export const postUpdateTicketDescriptionBody = zod.object({
  "description": zod.string().optional()
})


export const postUpdateTicketPriorityParams = zod.object({
  "id": zod.string()
})

export const postUpdateTicketPriorityBody = zod.object({
  "priority": zod.enum(['high', 'medium', 'lows']).optional()
})


export const postScheduleDateParams = zod.object({
  "id": zod.string()
})

export const postScheduleDateBody = zod.object({
  "scheduled_date": zod.string().date().optional()
})


export const postUpdateTicketStatusParams = zod.object({
  "id": zod.string()
})

export const postUpdateTicketStatusBody = zod.object({
  "status_id": zod.string().uuid().optional(),
  "status_detail_id": zod.string().uuid().nullish()
})


export const postUpdateTicketAssigneeParams = zod.object({
  "id": zod.string()
})

export const postUpdateTicketAssigneeBody = zod.object({
  "assignee_id": zod.string().uuid().optional()
})


export const postUpdateTicketExpectedDurationParams = zod.object({
  "id": zod.string()
})

export const postUpdateTicketExpectedDurationBody = zod.object({
  "expected_duration": zod.object({
  "hours": zod.number().optional(),
  "minutes": zod.number().optional()
}).optional()
})


export const patchUpdateTicketOrganisationParams = zod.object({
  "id": zod.string()
})

export const patchUpdateTicketOrganisationBody = zod.object({
  "organisation_id": zod.string().uuid().optional()
})


/**
 * This endpoint sets the status of a ticket to closed
 * @summary Close a ticket
 */
export const postCloseTicketParams = zod.object({
  "id": zod.string()
})


export const postReadyForProcessingTicketParams = zod.object({
  "id": zod.string()
})


export const postAddSiteToTicketParams = zod.object({
  "id": zod.string(),
  "site_id": zod.string()
})


export const postAddAssigneeToTicketParams = zod.object({
  "id": zod.string()
})

export const postAddAssigneeToTicketBody = zod.object({
  "assignee_id": zod.string()
})


export const postAddUnitToTicketParams = zod.object({
  "id": zod.string(),
  "unit_id": zod.string()
})


export const postAddChildTicketToTicketParams = zod.object({
  "id": zod.string()
})

export const postAddChildTicketToTicketBody = zod.object({
  "children": zod.array(zod.string())
})


export const postAddAssignmentToTicketParams = zod.object({
  "id": zod.string()
})

export const postAddAssignmentToTicketBody = zod.object({
  "assignments": zod.array(zod.string())
})


export const postAddSiteContactPersonsToTicketParams = zod.object({
  "id": zod.string()
})

export const postAddSiteContactPersonsToTicketBody = zod.object({
  "contact_persons": zod.array(zod.string())
})


export const postAddOrganisationContactPersonsToTicketParams = zod.object({
  "id": zod.string()
})

export const postAddOrganisationContactPersonsToTicketBody = zod.object({
  "contact_persons": zod.array(zod.string())
})


export const postAddArticleToTicketParams = zod.object({
  "id": zod.string()
})

export const postAddArticleToTicketBody = zod.object({
  "articles": zod.array(zod.object({
  "article_id": zod.string().optional(),
  "quantity": zod.number().optional(),
  "price": zod.number().nullish(),
  "type": zod.enum(['fixed', 'variable']).optional()
}))
})


export const postAddAcknowledgementToTicketParams = zod.object({
  "id": zod.string()
})

export const postAddAcknowledgementToTicketBody = zod.object({
  "first_name": zod.string().optional(),
  "last_name": zod.string().optional(),
  "phone_number": zod.string().optional(),
  "email": zod.string().optional(),
  "signature_image": zod.string().optional(),
  "consent": zod.boolean().optional()
})


export const postAddCaseToTicketParams = zod.object({
  "id": zod.string()
})

export const postAddCaseToTicketBody = zod.object({
  "comment": zod.string().nullish(),
  "case_id": zod.string().uuid().optional(),
  "case_detail_id": zod.string().uuid().nullish()
})


export const postAddFileToTicketParams = zod.object({
  "id": zod.string()
})

export const postAddFileToTicketBody = zod.object({
  "files": zod.array(zod.string())
})


export const postAddSignatureToTicketParams = zod.object({
  "id": zod.string()
})

export const postAddSignatureToTicketBody = zod.object({
  "signature_id": zod.string().uuid()
})


export const getFetchSignatureParams = zod.object({
  "id": zod.string()
})

export const getFetchSignatureResponse = zod.object({
  "id": zod.string().optional()
})


export const getFetchFileParams = zod.object({
  "id": zod.string()
})

export const getFetchFileResponse = zod.object({
  "file": zod.string().optional()
})


/**
 * Fetch file in base64 format from ticket service
 * @summary Get file as base64 by ID
 */
export const getFetchFileBase64Params = zod.object({
  "id": zod.string().uuid()
})


export const getFetchUserParams = zod.object({
  "id": zod.string()
})

export const getFetchUserResponseFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchUserResponseMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const getFetchUserResponseLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchUserResponsePhoneNumberMin = 5;

export const getFetchUserResponsePhoneNumberMax = 15;

export const getFetchUserResponsePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchUserResponseAssigneePricePerHourMin = 0;


export const getFetchUserResponse = zod.object({
  "id": zod.string().optional(),
  "first_name": zod.string().regex(getFetchUserResponseFirstNameRegExp).optional(),
  "middle_name": zod.string().regex(getFetchUserResponseMiddleNameRegExp).nullish(),
  "last_name": zod.string().regex(getFetchUserResponseLastNameRegExp).optional(),
  "phone_number": zod.string().min(getFetchUserResponsePhoneNumberMin).max(getFetchUserResponsePhoneNumberMax).regex(getFetchUserResponsePhoneNumberRegExp).optional(),
  "email": zod.string().optional(),
  "status": zod.enum(['new', 'active', 'inactive', 'suspended']).optional(),
  "created_at": zod.string().date().optional(),
  "assignee": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "function": zod.enum(['mechanic']).optional(),
  "price_per_hour": zod.number().min(getFetchUserResponseAssigneePricePerHourMin).optional()
}).optional()
})


export const postFetchAllUsersQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllUsersBodyPhoneNumberMin = 5;

export const postFetchAllUsersBodyPhoneNumberMax = 15;

export const postFetchAllUsersBodyPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');


export const postFetchAllUsersBody = zod.object({
  "match_mode": zod.enum(['and', 'or']).optional(),
  "first_name": zod.string().nullish(),
  "last_name": zod.string().nullish(),
  "phone_number": zod.string().min(postFetchAllUsersBodyPhoneNumberMin).max(postFetchAllUsersBodyPhoneNumberMax).regex(postFetchAllUsersBodyPhoneNumberRegExp).nullish(),
  "email": zod.string().nullish(),
  "status": zod.enum(['new', 'active', 'inactive', 'suspended']).nullish()
})

export const postFetchAllUsersResponseDataItemFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllUsersResponseDataItemMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');
export const postFetchAllUsersResponseDataItemLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const postFetchAllUsersResponseDataItemPhoneNumberMin = 5;

export const postFetchAllUsersResponseDataItemPhoneNumberMax = 15;

export const postFetchAllUsersResponseDataItemPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllUsersResponseDataItemAssigneePricePerHourMin = 0;


export const postFetchAllUsersResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "first_name": zod.string().regex(postFetchAllUsersResponseDataItemFirstNameRegExp).optional(),
  "middle_name": zod.string().regex(postFetchAllUsersResponseDataItemMiddleNameRegExp).nullish(),
  "last_name": zod.string().regex(postFetchAllUsersResponseDataItemLastNameRegExp).optional(),
  "phone_number": zod.string().min(postFetchAllUsersResponseDataItemPhoneNumberMin).max(postFetchAllUsersResponseDataItemPhoneNumberMax).regex(postFetchAllUsersResponseDataItemPhoneNumberRegExp).optional(),
  "email": zod.string().optional(),
  "status": zod.enum(['new', 'active', 'inactive', 'suspended']).optional(),
  "created_at": zod.string().date().optional(),
  "assignee": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "function": zod.enum(['mechanic']).optional(),
  "price_per_hour": zod.number().min(postFetchAllUsersResponseDataItemAssigneePricePerHourMin).optional()
}).optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postCreateUserBodyFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$/, .*[a-zA-Z\\s]+');
export const postCreateUserBodyLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$/, .*[a-zA-Z\\s]+');
export const postCreateUserBodyPhoneNumberMin = 5;

export const postCreateUserBodyPhoneNumberMax = 15;

export const postCreateUserBodyPhoneNumberRegExp = new RegExp('^31[0-9]{9}$/, 31[0-9]{9}');
export const postCreateUserBodyMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$/, .*[a-zA-Z\\s\\.]+');


export const postCreateUserBody = zod.object({
  "first_name": zod.string().regex(postCreateUserBodyFirstNameRegExp),
  "last_name": zod.string().regex(postCreateUserBodyLastNameRegExp),
  "phone_number": zod.string().min(postCreateUserBodyPhoneNumberMin).max(postCreateUserBodyPhoneNumberMax).regex(postCreateUserBodyPhoneNumberRegExp),
  "email": zod.string(),
  "middle_name": zod.string().regex(postCreateUserBodyMiddleNameRegExp).nullish(),
  "assignee_id": zod.string().uuid().optional()
})


export const getFetchUserAssigneeParams = zod.object({
  "id": zod.string()
})

export const getFetchUserAssigneeResponseNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchUserAssigneeResponsePricePerHourMin = 0;
export const getFetchUserAssigneeResponseUserFirstNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchUserAssigneeResponseUserLastNameRegExp = new RegExp('^[a-zA-Z\\s]+$');
export const getFetchUserAssigneeResponseUserMiddleNameRegExp = new RegExp('^[a-zA-Z\\s\\.]+$');


export const getFetchUserAssigneeResponse = zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchUserAssigneeResponseNameRegExp).optional(),
  "function": zod.enum(['mechanic']).optional(),
  "price_per_hour": zod.number().min(getFetchUserAssigneeResponsePricePerHourMin).optional(),
  "created_at": zod.string().date().optional(),
  "user": zod.object({
  "id": zod.string().optional(),
  "first_name": zod.string().regex(getFetchUserAssigneeResponseUserFirstNameRegExp).optional(),
  "last_name": zod.string().regex(getFetchUserAssigneeResponseUserLastNameRegExp).optional(),
  "middle_name": zod.string().regex(getFetchUserAssigneeResponseUserMiddleNameRegExp).nullish()
}).optional()
})


export const postUpdateOrganisationContactPersonParams = zod.object({
  "id": zod.string()
})

export const postUpdateOrganisationContactPersonBody = zod.object({
  "organisation_contact_person_id": zod.string().uuid()
})


export const postUpdateSiteContactPersonParams = zod.object({
  "id": zod.string()
})

export const postUpdateSiteContactPersonBody = zod.object({
  "site_contact_person_id": zod.string().optional()
})


export const deleteRemoveActionLabourFromAssignmentParams = zod.object({
  "id": zod.string(),
  "action_labour_id": zod.string()
})


export const deleteRemoveAssigneeFromAssignmentParams = zod.object({
  "id": zod.string(),
  "assignee_id": zod.string()
})


export const deleteRemoveArticleAssociationFromTicketParams = zod.object({
  "id": zod.string(),
  "article_association_id": zod.string()
})


export const postFetchAllStatusesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "visible_on_board": zod.boolean().optional(),
  "label": zod.string().optional(),
  "business_identifier": zod.string().optional(),
  "created_at": zod.string().date().optional(),
  "status_details": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
})).optional(),
  "allowed_transitions": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
})).optional()
})).optional()
})


export const postCreateTicketStatusBody = zod.object({
  "name": zod.string(),
  "visible_on_board": zod.boolean(),
  "label": zod.string(),
  "business_identifier": zod.string().optional()
})


export const postUpdateArticleAssociationQuantityParams = zod.object({
  "id": zod.string()
})

export const postUpdateArticleAssociationQuantityBody = zod.object({
  "quantity": zod.number().optional()
})


export const postUpdateArticleAssociationPriceParams = zod.object({
  "id": zod.string()
})

export const postUpdateArticleAssociationPriceBodyPriceMin = 0;


export const postUpdateArticleAssociationPriceBody = zod.object({
  "price": zod.number().min(postUpdateArticleAssociationPriceBodyPriceMin)
})


export const postPinTicketParams = zod.object({
  "id": zod.string()
})


export const postUnpinTicketParams = zod.object({
  "id": zod.string()
})


export const putUpdateAssignmentActionParams = zod.object({
  "id": zod.string()
})

export const putUpdateAssignmentActionBody = zod.object({
  "action_id": zod.string().optional()
})


/**
 * @summary Fetch hours worked by a mechanic
 */
export const postFetchHoursWorkedByMechanicParams = zod.object({
  "id": zod.string()
})

export const postFetchHoursWorkedByMechanicQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchHoursWorkedByMechanicBody = zod.object({
  "start_date": zod.string().date().nullish(),
  "end_date": zod.string().date().nullish()
})

export const postFetchHoursWorkedByMechanicResponse = zod.object({
  "data": zod.array(zod.object({
  "date": zod.string().datetime().optional(),
  "number_of_hours": zod.number().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


/**
 * Fetch price of the ticket
 * @summary Get price of the ticket
 */
export const postPriceTicketParams = zod.object({
  "id": zod.string()
})


export const getFetchActionItemParams = zod.object({
  "id": zod.string()
})

export const getFetchActionItemResponsePriceMin = 0;
export const getFetchActionItemResponseQuantityMin = 0;
export const getFetchActionItemResponseRecipeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const getFetchActionItemResponse = zod.object({
  "id": zod.string().optional(),
  "price": zod.number().min(getFetchActionItemResponsePriceMin).optional(),
  "quantity": zod.number().min(getFetchActionItemResponseQuantityMin).optional(),
  "interval_in_months": zod.number().nullish(),
  "hourly_running_rate": zod.number().nullish(),
  "running_hours_per_year": zod.number().nullish(),
  "running_hour_bat_start": zod.number().nullish(),
  "recipe": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchActionItemResponseRecipeNameRegExp).optional(),
  "type": zod.enum(['safety inspection', 'part replacement']).optional()
}).optional(),
  "created_at": zod.string().date().optional()
})


export const putUpdateActionItemParams = zod.object({
  "id": zod.string()
})

export const putUpdateActionItemBody = zod.object({
  "price": zod.number(),
  "quantity": zod.number(),
  "recipe_id": zod.string().uuid(),
  "interval_in_months": zod.number().nullish(),
  "hourly_running_rate": zod.number().nullish(),
  "running_hours_per_year": zod.number().nullish(),
  "running_hour_bat_start": zod.number().nullish()
})


export const postFetchAllActionItemsQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllActionItemsBody = zod.object({
  "match_mode": zod.enum(['and', 'or']).optional(),
  "price": zod.number().nullish(),
  "quantity": zod.number().nullish()
})

export const postFetchAllActionItemsResponseDataItemPriceMin = 0;
export const postFetchAllActionItemsResponseDataItemQuantityMin = 0;
export const postFetchAllActionItemsResponseDataItemRecipeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const postFetchAllActionItemsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "price": zod.number().min(postFetchAllActionItemsResponseDataItemPriceMin).optional(),
  "quantity": zod.number().min(postFetchAllActionItemsResponseDataItemQuantityMin).optional(),
  "interval_in_months": zod.number().nullish(),
  "hourly_running_rate": zod.number().nullish(),
  "running_hours_per_year": zod.number().nullish(),
  "running_hour_bat_start": zod.number().nullish(),
  "recipe": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllActionItemsResponseDataItemRecipeNameRegExp).optional(),
  "type": zod.enum(['safety inspection', 'part replacement']).optional()
}).optional(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postCreateActionItemBodyPriceMin = 0;
export const postCreateActionItemBodyQuantityMin = 0;


export const postCreateActionItemBody = zod.object({
  "price": zod.number().min(postCreateActionItemBodyPriceMin),
  "quantity": zod.number().min(postCreateActionItemBodyQuantityMin),
  "recipe_id": zod.string(),
  "interval_in_months": zod.number().nullish(),
  "hourly_running_rate": zod.number().nullish(),
  "running_hours_per_year": zod.number().nullish(),
  "running_hour_bat_start": zod.number().nullish()
})


export const getFetchCategoryParams = zod.object({
  "id": zod.string()
})

export const getFetchCategoryResponseNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchCategoryResponsePropertiesItemValueRegExp = new RegExp('[^a-zA-Z0-9\\s\\-\\/\\.]');
export const getFetchCategoryResponsePropertiesItemAttributeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchCategoryResponsePropertyAttributesItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const getFetchCategoryResponse = zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchCategoryResponseNameRegExp).optional(),
  "properties": zod.array(zod.object({
  "id": zod.string().optional(),
  "value": zod.string().regex(getFetchCategoryResponsePropertiesItemValueRegExp).optional(),
  "attribute": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchCategoryResponsePropertiesItemAttributeNameRegExp).optional()
}).optional()
})).optional(),
  "property_attributes": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchCategoryResponsePropertyAttributesItemNameRegExp).optional()
})).optional(),
  "propertyproperty_attributes_validation": zod.array(zod.string()).optional(),
  "property_attributes_ui_schema": zod.array(zod.string()).optional(),
  "property_attributes_translations": zod.array(zod.string()).optional(),
  "created_at": zod.string().date().optional()
})


export const putUpdateCategoryParams = zod.object({
  "id": zod.string()
})

export const putUpdateCategoryBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');


export const putUpdateCategoryBody = zod.object({
  "name": zod.string().regex(putUpdateCategoryBodyNameRegExp),
  "property_attributes_validation": zod.array(zod.object({

})).optional(),
  "property_attributes_ui_schema": zod.array(zod.object({

})).optional(),
  "property_attributes_translations": zod.array(zod.object({

})).optional()
})


export const postFetchAllCategoriesQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllCategoriesBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');


export const postFetchAllCategoriesBody = zod.object({
  "name": zod.string().regex(postFetchAllCategoriesBodyNameRegExp).nullish()
})

export const postFetchAllCategoriesResponseDataItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllCategoriesResponseDataItemPropertiesItemValueRegExp = new RegExp('[^a-zA-Z0-9\\s\\-\\/\\.]');
export const postFetchAllCategoriesResponseDataItemPropertiesItemAttributeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllCategoriesResponseDataItemPropertyAttributesItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const postFetchAllCategoriesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllCategoriesResponseDataItemNameRegExp).optional(),
  "properties": zod.array(zod.object({
  "id": zod.string().optional(),
  "value": zod.string().regex(postFetchAllCategoriesResponseDataItemPropertiesItemValueRegExp).optional(),
  "attribute": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllCategoriesResponseDataItemPropertiesItemAttributeNameRegExp).optional()
}).optional()
})).optional(),
  "property_attributes": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllCategoriesResponseDataItemPropertyAttributesItemNameRegExp).optional()
})).optional(),
  "propertyproperty_attributes_validation": zod.array(zod.string()).optional(),
  "property_attributes_ui_schema": zod.array(zod.string()).optional(),
  "property_attributes_translations": zod.array(zod.string()).optional(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postCreateCategoryBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');


export const postCreateCategoryBody = zod.object({
  "name": zod.string().regex(postCreateCategoryBodyNameRegExp),
  "property_attributes_validation": zod.array(zod.object({

})).optional(),
  "property_attributes_ui_schema": zod.array(zod.object({

})).optional(),
  "property_attributes_translations": zod.array(zod.object({

})).optional()
})


export const postAddPropertyToCategoryParams = zod.object({
  "id": zod.string()
})

export const postAddPropertyToCategoryBody = zod.object({
  "properties": zod.array(zod.string())
})


export const postAddPropertyAttributeToCategoryParams = zod.object({
  "id": zod.string()
})

export const postAddPropertyAttributeToCategoryBody = zod.object({
  "property_atributes": zod.array(zod.string())
})


export const postCreateContractBodyPricePerHourMin = 0;
export const postCreateContractBodyMaxNumberOfHoursMin = 0;


export const postCreateContractBody = zod.object({
  "type": zod.enum(['care', 'full_care']),
  "start_date": zod.string().date().nullish(),
  "period": zod.enum(['24', '36', '48', '60', '72', '84', 'indefinite']),
  "annual_price_adjustment": zod.boolean().optional(),
  "unit_id": zod.string(),
  "contract_holder_id": zod.string(),
  "operator_id": zod.string(),
  "description": zod.string().nullish(),
  "price_per_hour": zod.number().min(postCreateContractBodyPricePerHourMin).nullish(),
  "max_number_of_hours": zod.number().min(postCreateContractBodyMaxNumberOfHoursMin).nullish(),
  "reference_number": zod.string().nullish(),
  "note": zod.string().nullish(),
  "contract_holder_contact_person_id": zod.string().nullish(),
  "operator_branch_id": zod.string().nullish()
})


export const getFetchContractParams = zod.object({
  "id": zod.string()
})

export const getFetchContractResponseNumberMin = 0;
export const getFetchContractResponseUnitNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchContractResponseUnitFleetNumberMin = 0;
export const getFetchContractResponseUnitSerialNumberRegExp = new RegExp('^[a-zA-Z0-9]+$');
export const getFetchContractResponseUnitManufactureNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchContractResponseUnitManufacturedYearMin = 1900;
export const getFetchContractResponseContractHolderOrganisationNameMin = 3;

export const getFetchContractResponseContractHolderOrganisationNameMax = 127;

export const getFetchContractResponseContractHolderOrganisationNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchContractResponseOperatorOrganisationNameMin = 3;

export const getFetchContractResponseOperatorOrganisationNameMax = 127;

export const getFetchContractResponseOperatorOrganisationNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchContractResponseActionItemsItemPriceMin = 0;
export const getFetchContractResponseActionItemsItemQuantityMin = 0;
export const getFetchContractResponsePricePerHourMin = 0;
export const getFetchContractResponseMaxNumberOfHoursMin = 0;
export const getFetchContractResponseContractHolderOrganisationDetailNumberMin = 0;
export const getFetchContractResponseContractHolderOrganisationDetailNameMin = 3;

export const getFetchContractResponseContractHolderOrganisationDetailNameMax = 127;

export const getFetchContractResponseContractHolderOrganisationDetailNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchContractResponseContractHolderOrganisationDetailVatNumberRegExp = new RegExp('[a-zA-Z0-9\\s]');
export const getFetchContractResponseContractHolderOrganisationDetailChamberOfCommerceNumberRegExp = new RegExp('^[0-9\\s]+$');
export const getFetchContractResponseContractHolderOrganisationDetailTransportRideAmountMin = 0;
export const getFetchContractResponseContractHolderOrganisationDetailAddressStreetRegExp = new RegExp('[^a-zA-Z\\s\\-\\`\']');
export const getFetchContractResponseContractHolderOrganisationDetailAddressHouseNumberMin = 0;
export const getFetchContractResponseContractHolderOrganisationDetailAddressPostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');
export const getFetchContractResponseContractHolderOrganisationDetailAddressCityRegExp = new RegExp('[^a-zA-Z\\s\'\\-]');
export const getFetchContractResponseContractHolderOrganisationDetailAddressCountryRegExp = new RegExp('[^a-zA-Z\\s]');
export const getFetchContractResponseContractHolderOrganisationDetailAddressHouseNumberExtensionRegExp = new RegExp('[^a-zA-Z0-9\\s\\-]');
export const getFetchContractResponseContractHolderOrganisationDetailAddressContactDetailPhoneNumberMin = 5;

export const getFetchContractResponseContractHolderOrganisationDetailAddressContactDetailPhoneNumberMax = 15;

export const getFetchContractResponseContractHolderOrganisationDetailAddressContactDetailPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchContractResponseContractHolderOrganisationDetailAddressContactDetailMobilePhoneNumberMin = 5;

export const getFetchContractResponseContractHolderOrganisationDetailAddressContactDetailMobilePhoneNumberMax = 15;

export const getFetchContractResponseContractHolderOrganisationDetailAddressContactDetailMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchContractResponseUnitDetailNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchContractResponseUnitDetailFleetNumberMin = 0;
export const getFetchContractResponseUnitDetailSerialNumberRegExp = new RegExp('^[a-zA-Z0-9]+$');
export const getFetchContractResponseUnitDetailManufactureNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchContractResponseUnitDetailManufacturedYearMin = 1900;
export const getFetchContractResponseUnitDetailCategoryNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchContractResponseUnitDetailLicensePlateNumberRegExp = new RegExp('^[A-Z0-9\\s\\-]');
export const getFetchContractResponseOperatorOrganisationDetailNumberMin = 0;
export const getFetchContractResponseOperatorOrganisationDetailNameMin = 3;

export const getFetchContractResponseOperatorOrganisationDetailNameMax = 127;

export const getFetchContractResponseOperatorOrganisationDetailNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchContractResponseOperatorOrganisationDetailVatNumberRegExp = new RegExp('[a-zA-Z0-9\\s]');
export const getFetchContractResponseOperatorOrganisationDetailChamberOfCommerceNumberRegExp = new RegExp('^[0-9\\s]+$');
export const getFetchContractResponseOperatorOrganisationDetailTransportRideAmountMin = 0;
export const getFetchContractResponseOperatorOrganisationDetailAddressStreetRegExp = new RegExp('[^a-zA-Z\\s\\-\\`\']');
export const getFetchContractResponseOperatorOrganisationDetailAddressHouseNumberMin = 0;
export const getFetchContractResponseOperatorOrganisationDetailAddressPostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');
export const getFetchContractResponseOperatorOrganisationDetailAddressCityRegExp = new RegExp('[^a-zA-Z\\s\'\\-]');
export const getFetchContractResponseOperatorOrganisationDetailAddressCountryRegExp = new RegExp('[^a-zA-Z\\s]');
export const getFetchContractResponseOperatorOrganisationDetailAddressHouseNumberExtensionRegExp = new RegExp('[^a-zA-Z0-9\\s\\-]');
export const getFetchContractResponseOperatorOrganisationDetailAddressContactDetailPhoneNumberMin = 5;

export const getFetchContractResponseOperatorOrganisationDetailAddressContactDetailPhoneNumberMax = 15;

export const getFetchContractResponseOperatorOrganisationDetailAddressContactDetailPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchContractResponseOperatorOrganisationDetailAddressContactDetailMobilePhoneNumberMin = 5;

export const getFetchContractResponseOperatorOrganisationDetailAddressContactDetailMobilePhoneNumberMax = 15;

export const getFetchContractResponseOperatorOrganisationDetailAddressContactDetailMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const getFetchContractResponseActionItemsDetailItemPriceMin = 0;
export const getFetchContractResponseActionItemsDetailItemQuantityMin = 0;
export const getFetchContractResponseActionItemsDetailItemRecipeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const getFetchContractResponse = zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['care', 'full_care']).optional(),
  "number": zod.number().min(getFetchContractResponseNumberMin).optional(),
  "status": zod.enum(['new', 'offer_sent', 'offer_expired', 'active', 'ended', 'cancelled']).optional(),
  "start_date": zod.string().date().nullish(),
  "period": zod.enum(['24 months', '36 months', '48 months', '60 months', '72 months', '84 months', 'indefinite']).optional(),
  "end_date": zod.string().date().nullish(),
  "annual_price_adjustment": zod.boolean().optional(),
  "unit": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchContractResponseUnitNameRegExp).optional(),
  "fleet_number": zod.number().min(getFetchContractResponseUnitFleetNumberMin).optional(),
  "serial_number": zod.string().regex(getFetchContractResponseUnitSerialNumberRegExp).optional(),
  "availability_date": zod.string().date().nullish(),
  "manufacture_name": zod.string().regex(getFetchContractResponseUnitManufactureNameRegExp).optional(),
  "manufactured_year": zod.number().min(getFetchContractResponseUnitManufacturedYearMin).optional(),
  "status": zod.enum(['active', 'inactive', 'deleted']).optional()
}).optional(),
  "contract_holder_organisation": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().min(getFetchContractResponseContractHolderOrganisationNameMin).max(getFetchContractResponseContractHolderOrganisationNameMax).regex(getFetchContractResponseContractHolderOrganisationNameRegExp).optional()
}).optional(),
  "operator_organisation": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().min(getFetchContractResponseOperatorOrganisationNameMin).max(getFetchContractResponseOperatorOrganisationNameMax).regex(getFetchContractResponseOperatorOrganisationNameRegExp).optional()
}).optional(),
  "action_items": zod.array(zod.object({
  "id": zod.string().optional(),
  "price": zod.number().min(getFetchContractResponseActionItemsItemPriceMin).optional(),
  "quantity": zod.number().min(getFetchContractResponseActionItemsItemQuantityMin).optional(),
  "recipe_name": zod.string().optional(),
  "recipe_type": zod.enum(['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service', 'inspection']).optional(),
  "interval_in_months": zod.number().nullish(),
  "hourly_running_rate": zod.number().nullish(),
  "running_hours_per_year": zod.number().nullish(),
  "running_hour_bat_start": zod.number().nullish()
})).optional(),
  "description": zod.string().nullish(),
  "price_per_hour": zod.number().min(getFetchContractResponsePricePerHourMin).nullish(),
  "max_number_of_hours": zod.number().min(getFetchContractResponseMaxNumberOfHoursMin).nullish(),
  "reference_number": zod.string().nullish(),
  "note": zod.string().nullish(),
  "created_at": zod.string().date().optional(),
  "files": zod.array(zod.object({
  "id": zod.string().optional(),
  "filename": zod.string().optional(),
  "type": zod.enum(['logo']).optional(),
  "uri": zod.string().optional()
})).optional(),
  "acknowledgement": zod.object({
  "id": zod.string().optional(),
  "first_name": zod.string().optional(),
  "last_name": zod.string().optional(),
  "phone_number": zod.string().optional(),
  "email": zod.string().optional(),
  "signature": zod.object({
  "id": zod.string().optional()
}).optional(),
  "ip_address": zod.string().optional(),
  "device_information": zod.string().optional(),
  "consent": zod.boolean().optional(),
  "created_at": zod.string().date().optional()
}).optional(),
  "contract_holder_organisation_detail": zod.object({
  "id": zod.string().optional(),
  "number": zod.number().min(getFetchContractResponseContractHolderOrganisationDetailNumberMin).optional(),
  "name": zod.string().min(getFetchContractResponseContractHolderOrganisationDetailNameMin).max(getFetchContractResponseContractHolderOrganisationDetailNameMax).regex(getFetchContractResponseContractHolderOrganisationDetailNameRegExp).optional(),
  "po_required": zod.boolean().optional(),
  "vat_number": zod.string().regex(getFetchContractResponseContractHolderOrganisationDetailVatNumberRegExp).optional(),
  "chamber_of_commerce_number": zod.string().regex(getFetchContractResponseContractHolderOrganisationDetailChamberOfCommerceNumberRegExp).optional(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "supplier": zod.boolean().optional(),
  "active": zod.boolean().optional(),
  "type": zod.enum(['customer', 'prospect']).optional(),
  "payment_method": zod.enum(['cash', 'account', 'sepa']).optional(),
  "payment_term": zod.enum(['SEPA', '14 days', '30 days', '60 days']).optional(),
  "transport_type": zod.enum(['per hour', 'per ride', 'self transport']).optional(),
  "transport_ride_amount": zod.number().min(getFetchContractResponseContractHolderOrganisationDetailTransportRideAmountMin).optional(),
  "address": zod.object({
  "id": zod.string().optional(),
  "street": zod.string().regex(getFetchContractResponseContractHolderOrganisationDetailAddressStreetRegExp).optional(),
  "house_number": zod.number().min(getFetchContractResponseContractHolderOrganisationDetailAddressHouseNumberMin).optional(),
  "post_code": zod.string().regex(getFetchContractResponseContractHolderOrganisationDetailAddressPostCodeRegExp).optional(),
  "city": zod.string().regex(getFetchContractResponseContractHolderOrganisationDetailAddressCityRegExp).optional(),
  "country": zod.string().regex(getFetchContractResponseContractHolderOrganisationDetailAddressCountryRegExp).optional(),
  "house_number_extension": zod.string().regex(getFetchContractResponseContractHolderOrganisationDetailAddressHouseNumberExtensionRegExp).nullish(),
  "description": zod.string().nullish(),
  "contact_detail": zod.object({
  "id": zod.string().optional(),
  "phone_number": zod.string().min(getFetchContractResponseContractHolderOrganisationDetailAddressContactDetailPhoneNumberMin).max(getFetchContractResponseContractHolderOrganisationDetailAddressContactDetailPhoneNumberMax).regex(getFetchContractResponseContractHolderOrganisationDetailAddressContactDetailPhoneNumberRegExp).optional(),
  "mobile_phone_number": zod.string().min(getFetchContractResponseContractHolderOrganisationDetailAddressContactDetailMobilePhoneNumberMin).max(getFetchContractResponseContractHolderOrganisationDetailAddressContactDetailMobilePhoneNumberMax).regex(getFetchContractResponseContractHolderOrganisationDetailAddressContactDetailMobilePhoneNumberRegExp).optional(),
  "email": zod.string().optional()
}).optional()
}).optional()
}).nullish(),
  "unit_detail": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchContractResponseUnitDetailNameRegExp).optional(),
  "fleet_number": zod.number().min(getFetchContractResponseUnitDetailFleetNumberMin).optional(),
  "serial_number": zod.string().regex(getFetchContractResponseUnitDetailSerialNumberRegExp).optional(),
  "availability_date": zod.string().date().nullish(),
  "manufacture_name": zod.string().regex(getFetchContractResponseUnitDetailManufactureNameRegExp).optional(),
  "manufactured_year": zod.number().min(getFetchContractResponseUnitDetailManufacturedYearMin).optional(),
  "status": zod.enum(['active', 'inactive', 'deleted']).optional(),
  "organisation_id": zod.string().optional(),
  "category": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchContractResponseUnitDetailCategoryNameRegExp).optional()
}).optional(),
  "license_plate_number": zod.string().regex(getFetchContractResponseUnitDetailLicensePlateNumberRegExp).nullish(),
  "description": zod.string().nullish()
}).nullish(),
  "operator_organisation_detail": zod.object({
  "id": zod.string().optional(),
  "number": zod.number().min(getFetchContractResponseOperatorOrganisationDetailNumberMin).optional(),
  "name": zod.string().min(getFetchContractResponseOperatorOrganisationDetailNameMin).max(getFetchContractResponseOperatorOrganisationDetailNameMax).regex(getFetchContractResponseOperatorOrganisationDetailNameRegExp).optional(),
  "po_required": zod.boolean().optional(),
  "vat_number": zod.string().regex(getFetchContractResponseOperatorOrganisationDetailVatNumberRegExp).optional(),
  "chamber_of_commerce_number": zod.string().regex(getFetchContractResponseOperatorOrganisationDetailChamberOfCommerceNumberRegExp).optional(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "supplier": zod.boolean().optional(),
  "active": zod.boolean().optional(),
  "type": zod.enum(['customer', 'prospect']).optional(),
  "payment_method": zod.enum(['cash', 'account', 'sepa']).optional(),
  "payment_term": zod.enum(['SEPA', '14 days', '30 days', '60 days']).optional(),
  "transport_type": zod.enum(['per hour', 'per ride', 'self transport']).optional(),
  "transport_ride_amount": zod.number().min(getFetchContractResponseOperatorOrganisationDetailTransportRideAmountMin).optional(),
  "address": zod.object({
  "id": zod.string().optional(),
  "street": zod.string().regex(getFetchContractResponseOperatorOrganisationDetailAddressStreetRegExp).optional(),
  "house_number": zod.number().min(getFetchContractResponseOperatorOrganisationDetailAddressHouseNumberMin).optional(),
  "post_code": zod.string().regex(getFetchContractResponseOperatorOrganisationDetailAddressPostCodeRegExp).optional(),
  "city": zod.string().regex(getFetchContractResponseOperatorOrganisationDetailAddressCityRegExp).optional(),
  "country": zod.string().regex(getFetchContractResponseOperatorOrganisationDetailAddressCountryRegExp).optional(),
  "house_number_extension": zod.string().regex(getFetchContractResponseOperatorOrganisationDetailAddressHouseNumberExtensionRegExp).nullish(),
  "description": zod.string().nullish(),
  "contact_detail": zod.object({
  "id": zod.string().optional(),
  "phone_number": zod.string().min(getFetchContractResponseOperatorOrganisationDetailAddressContactDetailPhoneNumberMin).max(getFetchContractResponseOperatorOrganisationDetailAddressContactDetailPhoneNumberMax).regex(getFetchContractResponseOperatorOrganisationDetailAddressContactDetailPhoneNumberRegExp).optional(),
  "mobile_phone_number": zod.string().min(getFetchContractResponseOperatorOrganisationDetailAddressContactDetailMobilePhoneNumberMin).max(getFetchContractResponseOperatorOrganisationDetailAddressContactDetailMobilePhoneNumberMax).regex(getFetchContractResponseOperatorOrganisationDetailAddressContactDetailMobilePhoneNumberRegExp).optional(),
  "email": zod.string().optional()
}).optional()
}).optional()
}).nullish(),
  "action_items_detail": zod.array(zod.object({
  "id": zod.string().optional(),
  "price": zod.number().min(getFetchContractResponseActionItemsDetailItemPriceMin).optional(),
  "quantity": zod.number().min(getFetchContractResponseActionItemsDetailItemQuantityMin).optional(),
  "recipe": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchContractResponseActionItemsDetailItemRecipeNameRegExp).optional(),
  "type": zod.enum(['safety inspection', 'part replacement']).optional()
}).optional()
})).optional(),
  "contract_holder_contact_person_id": zod.string().nullish(),
  "operator_branch_id": zod.string().nullish()
})


export const putUpdateContractParams = zod.object({
  "id": zod.string()
})

export const putUpdateContractBodyPricePerHourMin = 0;
export const putUpdateContractBodyMaxNumberOfHoursMin = 0;


export const putUpdateContractBody = zod.object({
  "type": zod.enum(['care', 'full_care']),
  "period": zod.enum(['24', '36', '48', '60', '72', '84', 'indefinite']).optional(),
  "price_per_hour": zod.number().min(putUpdateContractBodyPricePerHourMin),
  "max_number_of_hours": zod.number().min(putUpdateContractBodyMaxNumberOfHoursMin),
  "annual_price_adjustment": zod.boolean().optional(),
  "unit_id": zod.string(),
  "contract_holder_id": zod.string(),
  "operator_id": zod.string(),
  "description": zod.string().nullish(),
  "note": zod.string().nullish(),
  "start_date": zod.string().date().nullish(),
  "reference_number": zod.string().nullish(),
  "contract_holder_contact_person_id": zod.string().nullish(),
  "operator_branch_id": zod.string().nullish()
})


export const patchPatchContractParams = zod.object({
  "id": zod.string()
})

export const patchPatchContractBodyPricePerHourMin = 0;
export const patchPatchContractBodyMaxNumberOfHoursMin = 0;


export const patchPatchContractBody = zod.object({
  "type": zod.enum(['care', 'full_care']).nullish(),
  "period": zod.enum(['24', '36', '48', '60', '72', '84', 'indefinite']).nullish(),
  "price_per_hour": zod.number().min(patchPatchContractBodyPricePerHourMin).nullish(),
  "max_number_of_hours": zod.number().min(patchPatchContractBodyMaxNumberOfHoursMin).nullish(),
  "annual_price_adjustment": zod.boolean().nullish(),
  "description": zod.string().nullish(),
  "note": zod.string().optional(),
  "start_date": zod.string().date().nullish(),
  "reference_number": zod.string().nullish(),
  "contract_holder_contact_person_id": zod.string().nullish(),
  "operator_branch_id": zod.string().nullish(),
  "unit_id": zod.string().nullish(),
  "contract_holder_id": zod.string().nullish()
})


export const postFetchAllContractsQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllContractsBody = zod.object({
  "expiring_soon": zod.boolean().optional()
})

export const postFetchAllContractsResponseDataItemNumberMin = 0;
export const postFetchAllContractsResponseDataItemUnitNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllContractsResponseDataItemUnitFleetNumberMin = 0;
export const postFetchAllContractsResponseDataItemUnitSerialNumberRegExp = new RegExp('^[a-zA-Z0-9]+$');
export const postFetchAllContractsResponseDataItemUnitManufactureNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllContractsResponseDataItemUnitManufacturedYearMin = 1900;
export const postFetchAllContractsResponseDataItemContractHolderOrganisationNameMin = 3;

export const postFetchAllContractsResponseDataItemContractHolderOrganisationNameMax = 127;

export const postFetchAllContractsResponseDataItemContractHolderOrganisationNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllContractsResponseDataItemOperatorOrganisationNameMin = 3;

export const postFetchAllContractsResponseDataItemOperatorOrganisationNameMax = 127;

export const postFetchAllContractsResponseDataItemOperatorOrganisationNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllContractsResponseDataItemActionItemsItemPriceMin = 0;
export const postFetchAllContractsResponseDataItemActionItemsItemQuantityMin = 0;
export const postFetchAllContractsResponseDataItemPricePerHourMin = 0;
export const postFetchAllContractsResponseDataItemMaxNumberOfHoursMin = 0;
export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailNumberMin = 0;
export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailNameMin = 3;

export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailNameMax = 127;

export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailVatNumberRegExp = new RegExp('[a-zA-Z0-9\\s]');
export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailChamberOfCommerceNumberRegExp = new RegExp('^[0-9\\s]+$');
export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailTransportRideAmountMin = 0;
export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressStreetRegExp = new RegExp('[^a-zA-Z\\s\\-\\`\']');
export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressHouseNumberMin = 0;
export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressPostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');
export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressCityRegExp = new RegExp('[^a-zA-Z\\s\'\\-]');
export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressCountryRegExp = new RegExp('[^a-zA-Z\\s]');
export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressHouseNumberExtensionRegExp = new RegExp('[^a-zA-Z0-9\\s\\-]');
export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressContactDetailPhoneNumberMin = 5;

export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressContactDetailPhoneNumberMax = 15;

export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressContactDetailPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressContactDetailMobilePhoneNumberMin = 5;

export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressContactDetailMobilePhoneNumberMax = 15;

export const postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressContactDetailMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllContractsResponseDataItemUnitDetailNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllContractsResponseDataItemUnitDetailFleetNumberMin = 0;
export const postFetchAllContractsResponseDataItemUnitDetailSerialNumberRegExp = new RegExp('^[a-zA-Z0-9]+$');
export const postFetchAllContractsResponseDataItemUnitDetailManufactureNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllContractsResponseDataItemUnitDetailManufacturedYearMin = 1900;
export const postFetchAllContractsResponseDataItemUnitDetailCategoryNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllContractsResponseDataItemUnitDetailLicensePlateNumberRegExp = new RegExp('^[A-Z0-9\\s\\-]');
export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailNumberMin = 0;
export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailNameMin = 3;

export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailNameMax = 127;

export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailVatNumberRegExp = new RegExp('[a-zA-Z0-9\\s]');
export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailChamberOfCommerceNumberRegExp = new RegExp('^[0-9\\s]+$');
export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailTransportRideAmountMin = 0;
export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressStreetRegExp = new RegExp('[^a-zA-Z\\s\\-\\`\']');
export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressHouseNumberMin = 0;
export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressPostCodeRegExp = new RegExp('^[1-9][0-9]{3}?[A-Z]{2}$/i');
export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressCityRegExp = new RegExp('[^a-zA-Z\\s\'\\-]');
export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressCountryRegExp = new RegExp('[^a-zA-Z\\s]');
export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressHouseNumberExtensionRegExp = new RegExp('[^a-zA-Z0-9\\s\\-]');
export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressContactDetailPhoneNumberMin = 5;

export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressContactDetailPhoneNumberMax = 15;

export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressContactDetailPhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressContactDetailMobilePhoneNumberMin = 5;

export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressContactDetailMobilePhoneNumberMax = 15;

export const postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressContactDetailMobilePhoneNumberRegExp = new RegExp('^31[0-9]{9}$');
export const postFetchAllContractsResponseDataItemActionItemsDetailItemPriceMin = 0;
export const postFetchAllContractsResponseDataItemActionItemsDetailItemQuantityMin = 0;
export const postFetchAllContractsResponseDataItemActionItemsDetailItemRecipeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const postFetchAllContractsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['care', 'full_care']).optional(),
  "number": zod.number().min(postFetchAllContractsResponseDataItemNumberMin).optional(),
  "status": zod.enum(['new', 'offer_sent', 'offer_expired', 'active', 'ended', 'cancelled']).optional(),
  "start_date": zod.string().date().nullish(),
  "period": zod.enum(['24 months', '36 months', '48 months', '60 months', '72 months', '84 months', 'indefinite']).optional(),
  "end_date": zod.string().date().nullish(),
  "annual_price_adjustment": zod.boolean().optional(),
  "unit": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllContractsResponseDataItemUnitNameRegExp).optional(),
  "fleet_number": zod.number().min(postFetchAllContractsResponseDataItemUnitFleetNumberMin).optional(),
  "serial_number": zod.string().regex(postFetchAllContractsResponseDataItemUnitSerialNumberRegExp).optional(),
  "availability_date": zod.string().date().nullish(),
  "manufacture_name": zod.string().regex(postFetchAllContractsResponseDataItemUnitManufactureNameRegExp).optional(),
  "manufactured_year": zod.number().min(postFetchAllContractsResponseDataItemUnitManufacturedYearMin).optional(),
  "status": zod.enum(['active', 'inactive', 'deleted']).optional()
}).optional(),
  "contract_holder_organisation": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().min(postFetchAllContractsResponseDataItemContractHolderOrganisationNameMin).max(postFetchAllContractsResponseDataItemContractHolderOrganisationNameMax).regex(postFetchAllContractsResponseDataItemContractHolderOrganisationNameRegExp).optional()
}).optional(),
  "operator_organisation": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().min(postFetchAllContractsResponseDataItemOperatorOrganisationNameMin).max(postFetchAllContractsResponseDataItemOperatorOrganisationNameMax).regex(postFetchAllContractsResponseDataItemOperatorOrganisationNameRegExp).optional()
}).optional(),
  "action_items": zod.array(zod.object({
  "id": zod.string().optional(),
  "price": zod.number().min(postFetchAllContractsResponseDataItemActionItemsItemPriceMin).optional(),
  "quantity": zod.number().min(postFetchAllContractsResponseDataItemActionItemsItemQuantityMin).optional(),
  "recipe_name": zod.string().optional(),
  "recipe_type": zod.enum(['deliver', 'repair', 'carry', 'change_oil', 'clean_filtration_system', 'cleaning', 'cleaning_of_the_turbocharger', 'service', 'inspection']).optional(),
  "interval_in_months": zod.number().nullish(),
  "hourly_running_rate": zod.number().nullish(),
  "running_hours_per_year": zod.number().nullish(),
  "running_hour_bat_start": zod.number().nullish()
})).optional(),
  "description": zod.string().nullish(),
  "price_per_hour": zod.number().min(postFetchAllContractsResponseDataItemPricePerHourMin).nullish(),
  "max_number_of_hours": zod.number().min(postFetchAllContractsResponseDataItemMaxNumberOfHoursMin).nullish(),
  "reference_number": zod.string().nullish(),
  "note": zod.string().nullish(),
  "created_at": zod.string().date().optional(),
  "files": zod.array(zod.object({
  "id": zod.string().optional(),
  "filename": zod.string().optional(),
  "type": zod.enum(['logo']).optional(),
  "uri": zod.string().optional()
})).optional(),
  "acknowledgement": zod.object({
  "id": zod.string().optional(),
  "first_name": zod.string().optional(),
  "last_name": zod.string().optional(),
  "phone_number": zod.string().optional(),
  "email": zod.string().optional(),
  "signature": zod.object({
  "id": zod.string().optional()
}).optional(),
  "ip_address": zod.string().optional(),
  "device_information": zod.string().optional(),
  "consent": zod.boolean().optional(),
  "created_at": zod.string().date().optional()
}).optional(),
  "contract_holder_organisation_detail": zod.object({
  "id": zod.string().optional(),
  "number": zod.number().min(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailNumberMin).optional(),
  "name": zod.string().min(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailNameMin).max(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailNameMax).regex(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailNameRegExp).optional(),
  "po_required": zod.boolean().optional(),
  "vat_number": zod.string().regex(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailVatNumberRegExp).optional(),
  "chamber_of_commerce_number": zod.string().regex(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailChamberOfCommerceNumberRegExp).optional(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "supplier": zod.boolean().optional(),
  "active": zod.boolean().optional(),
  "type": zod.enum(['customer', 'prospect']).optional(),
  "payment_method": zod.enum(['cash', 'account', 'sepa']).optional(),
  "payment_term": zod.enum(['SEPA', '14 days', '30 days', '60 days']).optional(),
  "transport_type": zod.enum(['per hour', 'per ride', 'self transport']).optional(),
  "transport_ride_amount": zod.number().min(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailTransportRideAmountMin).optional(),
  "address": zod.object({
  "id": zod.string().optional(),
  "street": zod.string().regex(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressStreetRegExp).optional(),
  "house_number": zod.number().min(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressHouseNumberMin).optional(),
  "post_code": zod.string().regex(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressPostCodeRegExp).optional(),
  "city": zod.string().regex(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressCityRegExp).optional(),
  "country": zod.string().regex(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressCountryRegExp).optional(),
  "house_number_extension": zod.string().regex(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressHouseNumberExtensionRegExp).nullish(),
  "description": zod.string().nullish(),
  "contact_detail": zod.object({
  "id": zod.string().optional(),
  "phone_number": zod.string().min(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressContactDetailPhoneNumberMin).max(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressContactDetailPhoneNumberMax).regex(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressContactDetailPhoneNumberRegExp).optional(),
  "mobile_phone_number": zod.string().min(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressContactDetailMobilePhoneNumberMin).max(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressContactDetailMobilePhoneNumberMax).regex(postFetchAllContractsResponseDataItemContractHolderOrganisationDetailAddressContactDetailMobilePhoneNumberRegExp).optional(),
  "email": zod.string().optional()
}).optional()
}).optional()
}).nullish(),
  "unit_detail": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllContractsResponseDataItemUnitDetailNameRegExp).optional(),
  "fleet_number": zod.number().min(postFetchAllContractsResponseDataItemUnitDetailFleetNumberMin).optional(),
  "serial_number": zod.string().regex(postFetchAllContractsResponseDataItemUnitDetailSerialNumberRegExp).optional(),
  "availability_date": zod.string().date().nullish(),
  "manufacture_name": zod.string().regex(postFetchAllContractsResponseDataItemUnitDetailManufactureNameRegExp).optional(),
  "manufactured_year": zod.number().min(postFetchAllContractsResponseDataItemUnitDetailManufacturedYearMin).optional(),
  "status": zod.enum(['active', 'inactive', 'deleted']).optional(),
  "organisation_id": zod.string().optional(),
  "category": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllContractsResponseDataItemUnitDetailCategoryNameRegExp).optional()
}).optional(),
  "license_plate_number": zod.string().regex(postFetchAllContractsResponseDataItemUnitDetailLicensePlateNumberRegExp).nullish(),
  "description": zod.string().nullish()
}).nullish(),
  "operator_organisation_detail": zod.object({
  "id": zod.string().optional(),
  "number": zod.number().min(postFetchAllContractsResponseDataItemOperatorOrganisationDetailNumberMin).optional(),
  "name": zod.string().min(postFetchAllContractsResponseDataItemOperatorOrganisationDetailNameMin).max(postFetchAllContractsResponseDataItemOperatorOrganisationDetailNameMax).regex(postFetchAllContractsResponseDataItemOperatorOrganisationDetailNameRegExp).optional(),
  "po_required": zod.boolean().optional(),
  "vat_number": zod.string().regex(postFetchAllContractsResponseDataItemOperatorOrganisationDetailVatNumberRegExp).optional(),
  "chamber_of_commerce_number": zod.string().regex(postFetchAllContractsResponseDataItemOperatorOrganisationDetailChamberOfCommerceNumberRegExp).optional(),
  "status": zod.enum(['active', 'inactive']).optional(),
  "supplier": zod.boolean().optional(),
  "active": zod.boolean().optional(),
  "type": zod.enum(['customer', 'prospect']).optional(),
  "payment_method": zod.enum(['cash', 'account', 'sepa']).optional(),
  "payment_term": zod.enum(['SEPA', '14 days', '30 days', '60 days']).optional(),
  "transport_type": zod.enum(['per hour', 'per ride', 'self transport']).optional(),
  "transport_ride_amount": zod.number().min(postFetchAllContractsResponseDataItemOperatorOrganisationDetailTransportRideAmountMin).optional(),
  "address": zod.object({
  "id": zod.string().optional(),
  "street": zod.string().regex(postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressStreetRegExp).optional(),
  "house_number": zod.number().min(postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressHouseNumberMin).optional(),
  "post_code": zod.string().regex(postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressPostCodeRegExp).optional(),
  "city": zod.string().regex(postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressCityRegExp).optional(),
  "country": zod.string().regex(postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressCountryRegExp).optional(),
  "house_number_extension": zod.string().regex(postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressHouseNumberExtensionRegExp).nullish(),
  "description": zod.string().nullish(),
  "contact_detail": zod.object({
  "id": zod.string().optional(),
  "phone_number": zod.string().min(postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressContactDetailPhoneNumberMin).max(postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressContactDetailPhoneNumberMax).regex(postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressContactDetailPhoneNumberRegExp).optional(),
  "mobile_phone_number": zod.string().min(postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressContactDetailMobilePhoneNumberMin).max(postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressContactDetailMobilePhoneNumberMax).regex(postFetchAllContractsResponseDataItemOperatorOrganisationDetailAddressContactDetailMobilePhoneNumberRegExp).optional(),
  "email": zod.string().optional()
}).optional()
}).optional()
}).nullish(),
  "action_items_detail": zod.array(zod.object({
  "id": zod.string().optional(),
  "price": zod.number().min(postFetchAllContractsResponseDataItemActionItemsDetailItemPriceMin).optional(),
  "quantity": zod.number().min(postFetchAllContractsResponseDataItemActionItemsDetailItemQuantityMin).optional(),
  "recipe": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllContractsResponseDataItemActionItemsDetailItemRecipeNameRegExp).optional(),
  "type": zod.enum(['safety inspection', 'part replacement']).optional()
}).optional()
})).optional(),
  "contract_holder_contact_person_id": zod.string().nullish(),
  "operator_branch_id": zod.string().nullish()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postUpdateContractStatusParams = zod.object({
  "id": zod.string()
})

export const postUpdateContractStatusBody = zod.object({
  "status": zod.enum(['new', 'offer_sent', 'offer_expired', 'active', 'ended', 'cancelled'])
})


export const postAddActionItemToContractParams = zod.object({
  "id": zod.string()
})

export const postAddActionItemToContractBody = zod.object({
  "action_items": zod.array(zod.string())
})


export const postAddNoteToContractParams = zod.object({
  "id": zod.string()
})

export const postAddNoteToContractBody = zod.object({
  "note": zod.string()
})


export const postUpdateNoteToContractParams = zod.object({
  "id": zod.string()
})

export const postUpdateNoteToContractBody = zod.object({
  "note": zod.string()
})


export const postAddAcknowledgementToContractParams = zod.object({
  "id": zod.string()
})

export const postAddAcknowledgementToContractBody = zod.object({
  "first_name": zod.string().optional(),
  "last_name": zod.string().optional(),
  "phone_number": zod.string().nullish(),
  "email": zod.string().nullish(),
  "signature_image": zod.string().optional(),
  "consent": zod.boolean().optional()
})


export const postCreateServiceHistoryBody = zod.object({
  "unit_id": zod.string(),
  "ticket_id": zod.string(),
  "type": zod.enum(['annual inspection', 'safety inspection', 'general', 'maintenance']),
  "service_date": zod.string().date(),
  "next_service_date": zod.string().date().optional(),
  "description": zod.string().optional()
})


export const getFetchServiceHistoryParams = zod.object({
  "id": zod.string()
})

export const getFetchServiceHistoryResponseUnitNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchServiceHistoryResponseUnitFleetNumberMin = 0;
export const getFetchServiceHistoryResponseUnitSerialNumberRegExp = new RegExp('^[a-zA-Z0-9]+$');
export const getFetchServiceHistoryResponseUnitManufactureNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchServiceHistoryResponseUnitManufacturedYearMin = 1900;
export const getFetchServiceHistoryResponsePropertiesItemValueRegExp = new RegExp('[^a-zA-Z0-9\\s\\-\\/\\.]');
export const getFetchServiceHistoryResponsePropertiesItemAttributeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const getFetchServiceHistoryResponse = zod.object({
  "id": zod.string().optional(),
  "unit": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchServiceHistoryResponseUnitNameRegExp).optional(),
  "fleet_number": zod.number().min(getFetchServiceHistoryResponseUnitFleetNumberMin).optional(),
  "serial_number": zod.string().regex(getFetchServiceHistoryResponseUnitSerialNumberRegExp).optional(),
  "availability_date": zod.string().date().nullish(),
  "manufacture_name": zod.string().regex(getFetchServiceHistoryResponseUnitManufactureNameRegExp).optional(),
  "manufactured_year": zod.number().min(getFetchServiceHistoryResponseUnitManufacturedYearMin).optional(),
  "status": zod.enum(['active', 'inactive', 'deleted']).optional()
}).optional(),
  "ticket_id": zod.string().optional(),
  "type": zod.enum(['safety inspection', 'part replacement']).optional(),
  "service_date": zod.string().date().optional(),
  "next_service_date": zod.string().date().nullish(),
  "properties": zod.array(zod.object({
  "id": zod.string().optional(),
  "value": zod.string().regex(getFetchServiceHistoryResponsePropertiesItemValueRegExp).optional(),
  "attribute": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchServiceHistoryResponsePropertiesItemAttributeNameRegExp).optional(),
  "data_type": zod.enum(['string', 'integer', 'double', 'boolean']).optional(),
  "validation": zod.array(zod.string()).optional(),
  "values": zod.array(zod.string()).optional()
}).optional()
})).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})


export const putUpdateServiceHistoryParams = zod.object({
  "id": zod.string()
})

export const putUpdateServiceHistoryBody = zod.object({
  "unit_id": zod.string(),
  "ticket_id": zod.string(),
  "type": zod.enum(['safety inspection', 'general', 'maintenance']),
  "service_date": zod.string().date(),
  "next_service_date": zod.string().date().nullish(),
  "description": zod.string().nullish()
})


export const postFetchAllServiceHistoriesQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllServiceHistoriesResponseDataItemUnitNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllServiceHistoriesResponseDataItemUnitFleetNumberMin = 0;
export const postFetchAllServiceHistoriesResponseDataItemUnitSerialNumberRegExp = new RegExp('^[a-zA-Z0-9]+$');
export const postFetchAllServiceHistoriesResponseDataItemUnitManufactureNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllServiceHistoriesResponseDataItemUnitManufacturedYearMin = 1900;
export const postFetchAllServiceHistoriesResponseDataItemPropertiesItemValueRegExp = new RegExp('[^a-zA-Z0-9\\s\\-\\/\\.]');
export const postFetchAllServiceHistoriesResponseDataItemPropertiesItemAttributeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const postFetchAllServiceHistoriesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "unit": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllServiceHistoriesResponseDataItemUnitNameRegExp).optional(),
  "fleet_number": zod.number().min(postFetchAllServiceHistoriesResponseDataItemUnitFleetNumberMin).optional(),
  "serial_number": zod.string().regex(postFetchAllServiceHistoriesResponseDataItemUnitSerialNumberRegExp).optional(),
  "availability_date": zod.string().date().nullish(),
  "manufacture_name": zod.string().regex(postFetchAllServiceHistoriesResponseDataItemUnitManufactureNameRegExp).optional(),
  "manufactured_year": zod.number().min(postFetchAllServiceHistoriesResponseDataItemUnitManufacturedYearMin).optional(),
  "status": zod.enum(['active', 'inactive', 'deleted']).optional()
}).optional(),
  "ticket_id": zod.string().optional(),
  "type": zod.enum(['safety inspection', 'part replacement']).optional(),
  "service_date": zod.string().date().optional(),
  "next_service_date": zod.string().date().nullish(),
  "properties": zod.array(zod.object({
  "id": zod.string().optional(),
  "value": zod.string().regex(postFetchAllServiceHistoriesResponseDataItemPropertiesItemValueRegExp).optional(),
  "attribute": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllServiceHistoriesResponseDataItemPropertiesItemAttributeNameRegExp).optional(),
  "data_type": zod.enum(['string', 'integer', 'double', 'boolean']).optional(),
  "validation": zod.array(zod.string()).optional(),
  "values": zod.array(zod.string()).optional()
}).optional()
})).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postAddPropertyToServiceHistoryParams = zod.object({
  "id": zod.string()
})

export const postAddPropertyToServiceHistoryBody = zod.object({
  "properties": zod.array(zod.string())
})


export const postAddPropertiesWithAttributesToServiceHistoryParams = zod.object({
  "id": zod.string()
})

export const postAddPropertiesWithAttributesToServiceHistoryBody = zod.object({
  "data": zod.array(zod.object({
  "attribute_name": zod.string(),
  "value": zod.string()
}))
})


export const postCreateMaintenancePackageBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');


export const postCreateMaintenancePackageBody = zod.object({
  "name": zod.string().regex(postCreateMaintenancePackageBodyNameRegExp),
  "recipes": zod.array(zod.string())
})


export const getFetchMaintenancePackageParams = zod.object({
  "id": zod.string()
})

export const getFetchMaintenancePackageResponseNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchMaintenancePackageResponseRecipesItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const getFetchMaintenancePackageResponse = zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchMaintenancePackageResponseNameRegExp).optional(),
  "recipes": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchMaintenancePackageResponseRecipesItemNameRegExp).optional(),
  "type": zod.enum(['safety inspection', 'part replacement']).optional()
})).optional(),
  "created_at": zod.string().date().optional()
})


export const putUpdateMaintenancePackageParams = zod.object({
  "id": zod.string()
})

export const putUpdateMaintenancePackageBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');


export const putUpdateMaintenancePackageBody = zod.object({
  "name": zod.string().regex(putUpdateMaintenancePackageBodyNameRegExp)
})


export const postFetchAllMaintenancePackagesQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllMaintenancePackagesResponseDataItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllMaintenancePackagesResponseDataItemRecipesItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const postFetchAllMaintenancePackagesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllMaintenancePackagesResponseDataItemNameRegExp).optional(),
  "recipes": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllMaintenancePackagesResponseDataItemRecipesItemNameRegExp).optional(),
  "type": zod.enum(['safety inspection', 'part replacement']).optional()
})).optional(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postAddRecipeToMaintenancePackageParams = zod.object({
  "id": zod.string()
})

export const postAddRecipeToMaintenancePackageBody = zod.object({
  "recipes": zod.array(zod.string())
})


export const postCreateUnitBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const postCreateUnitBodyFleetNumberMin = 0;
export const postCreateUnitBodySerialNumberRegExp = new RegExp('^[a-zA-Z0-9]+$/, .*[a-zA-Z0-9]+');
export const postCreateUnitBodyManufactureNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const postCreateUnitBodyManufacturedYearMin = 1900;
export const postCreateUnitBodyLicensePlateNumberRegExp = new RegExp('.*[A-Z0-9\\s\\-].*');


export const postCreateUnitBody = zod.object({
  "name": zod.string().regex(postCreateUnitBodyNameRegExp),
  "fleet_number": zod.number().min(postCreateUnitBodyFleetNumberMin),
  "serial_number": zod.string().regex(postCreateUnitBodySerialNumberRegExp),
  "organisation_id": zod.string(),
  "availability_date": zod.string().date().nullish(),
  "manufacture_name": zod.string().regex(postCreateUnitBodyManufactureNameRegExp),
  "manufactured_year": zod.number().min(postCreateUnitBodyManufacturedYearMin),
  "status": zod.enum(['active', 'inactive', 'deleted']),
  "category_id": zod.string(),
  "license_plate_number": zod.string().regex(postCreateUnitBodyLicensePlateNumberRegExp).nullish(),
  "description": zod.string().nullish()
})


export const getFetchUnitParams = zod.object({
  "id": zod.string()
})

export const getFetchUnitResponseNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchUnitResponseFleetNumberMin = 0;
export const getFetchUnitResponseSerialNumberRegExp = new RegExp('^[a-zA-Z0-9]+$');
export const getFetchUnitResponseLicensePlateNumberRegExp = new RegExp('^[A-Z0-9\\s\\-]');
export const getFetchUnitResponseOrganisationNameMin = 3;

export const getFetchUnitResponseOrganisationNameMax = 127;

export const getFetchUnitResponseOrganisationNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchUnitResponseManufactureNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchUnitResponseManufacturedYearMin = 1900;
export const getFetchUnitResponseCategoryNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchUnitResponsePropertiesItemValueRegExp = new RegExp('[^a-zA-Z0-9\\s\\-\\/\\.]');
export const getFetchUnitResponsePropertiesItemAttributeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchUnitResponseServicePropertiesItemValueRegExp = new RegExp('[^a-zA-Z0-9\\s\\-\\/\\.]');
export const getFetchUnitResponseServicePropertiesItemAttributeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchUnitResponseContractsItemNumberMin = 0;
export const getFetchUnitResponseContractsItemPricePerHourMin = 0;
export const getFetchUnitResponseContractsItemMaxNumberOfHoursMin = 0;


export const getFetchUnitResponse = zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchUnitResponseNameRegExp).optional(),
  "fleet_number": zod.number().min(getFetchUnitResponseFleetNumberMin).optional(),
  "serial_number": zod.string().regex(getFetchUnitResponseSerialNumberRegExp).optional(),
  "license_plate_number": zod.string().regex(getFetchUnitResponseLicensePlateNumberRegExp).nullish(),
  "organisation": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().min(getFetchUnitResponseOrganisationNameMin).max(getFetchUnitResponseOrganisationNameMax).regex(getFetchUnitResponseOrganisationNameRegExp).optional()
}).optional(),
  "availability_date": zod.string().date().nullish(),
  "manufacture_name": zod.string().regex(getFetchUnitResponseManufactureNameRegExp).optional(),
  "manufactured_year": zod.number().min(getFetchUnitResponseManufacturedYearMin).optional(),
  "status": zod.enum(['active', 'inactive', 'deleted']).optional(),
  "category": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchUnitResponseCategoryNameRegExp).optional()
}).optional(),
  "properties": zod.array(zod.object({
  "id": zod.string().optional(),
  "value": zod.string().regex(getFetchUnitResponsePropertiesItemValueRegExp).optional(),
  "attribute": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchUnitResponsePropertiesItemAttributeNameRegExp).optional()
}).optional()
})).optional(),
  "service_properties": zod.array(zod.object({
  "id": zod.string().optional(),
  "value": zod.string().regex(getFetchUnitResponseServicePropertiesItemValueRegExp).optional(),
  "attribute": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchUnitResponseServicePropertiesItemAttributeNameRegExp).optional()
}).optional()
})).optional(),
  "service_histories": zod.array(zod.object({
  "id": zod.string().optional(),
  "ticket_id": zod.string().optional(),
  "type": zod.enum(['annual inspection', 'safety inspection', 'general', 'maintenance']).optional(),
  "service_date": zod.string().date().optional(),
  "next_service_date": zod.string().date().nullish()
})).optional(),
  "contracts": zod.array(zod.object({
  "id": zod.string().optional(),
  "type": zod.enum(['care', 'full_care']).optional(),
  "number": zod.number().min(getFetchUnitResponseContractsItemNumberMin).optional(),
  "status": zod.enum(['new', 'offer_sent', 'offer_expired', 'active', 'ended', 'cancelled']).optional(),
  "start_date": zod.string().date().nullish(),
  "period": zod.enum(['24', '36', '48', '60', '72', '84', 'indefinite']).optional(),
  "end_date": zod.string().date().nullish(),
  "annual_price_adjustment": zod.boolean().optional(),
  "description": zod.string().nullish(),
  "price_per_hour": zod.number().min(getFetchUnitResponseContractsItemPricePerHourMin).nullish(),
  "max_number_of_hours": zod.number().min(getFetchUnitResponseContractsItemMaxNumberOfHoursMin).nullish(),
  "contract_holder_contact_person_id": zod.string().nullish(),
  "operator_branch_id": zod.string().nullish()
})).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional(),
  "tickets": zod.array(zod.string()).optional()
})


export const putUpdateUnitParams = zod.object({
  "id": zod.string()
})

export const putUpdateUnitBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const putUpdateUnitBodyFleetNumberMin = 0;
export const putUpdateUnitBodySerialNumberRegExp = new RegExp('^[a-zA-Z0-9]+$/, .*[a-zA-Z0-9]+');
export const putUpdateUnitBodyLicensePlateNumberRegExp = new RegExp('.*[A-Z0-9\\s\\-].*');


export const putUpdateUnitBody = zod.object({
  "name": zod.string().regex(putUpdateUnitBodyNameRegExp),
  "fleet_number": zod.number().min(putUpdateUnitBodyFleetNumberMin),
  "serial_number": zod.string().regex(putUpdateUnitBodySerialNumberRegExp),
  "availability_date": zod.string().date().nullish(),
  "status": zod.enum(['active', 'inactive', 'deleted']),
  "license_plate_number": zod.string().regex(putUpdateUnitBodyLicensePlateNumberRegExp).nullish(),
  "description": zod.string().nullish()
})


export const patchPatchUnitParams = zod.object({
  "id": zod.string()
})

export const patchPatchUnitBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const patchPatchUnitBodyFleetNumberMin = 0;
export const patchPatchUnitBodySerialNumberRegExp = new RegExp('^[a-zA-Z0-9]+$/, .*[a-zA-Z0-9]+');
export const patchPatchUnitBodyLicensePlateNumberRegExp = new RegExp('.*[A-Z0-9\\s\\-].*');


export const patchPatchUnitBody = zod.object({
  "name": zod.string().regex(patchPatchUnitBodyNameRegExp).nullish(),
  "fleet_number": zod.number().min(patchPatchUnitBodyFleetNumberMin).nullish(),
  "serial_number": zod.string().regex(patchPatchUnitBodySerialNumberRegExp).nullish(),
  "availability_date": zod.string().date().nullish(),
  "status": zod.enum(['active', 'inactive', 'deleted']).nullish(),
  "license_plate_number": zod.string().regex(patchPatchUnitBodyLicensePlateNumberRegExp).nullish(),
  "description": zod.string().nullish()
})


export const postFetchAllUnitsQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllUnitsBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const postFetchAllUnitsBodyFleetNumberMin = 0;
export const postFetchAllUnitsBodySerialNumberRegExp = new RegExp('^[a-zA-Z0-9]+$');
export const postFetchAllUnitsBodyManufactureNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');
export const postFetchAllUnitsBodyManufacturedYearMin = 1900;
export const postFetchAllUnitsBodyLicensePlateNumberRegExp = new RegExp('.*[A-Z0-9\\-\\s\\—].*');


export const postFetchAllUnitsBody = zod.object({
  "match_mode": zod.enum(['and', 'or']).optional(),
  "name": zod.string().regex(postFetchAllUnitsBodyNameRegExp).nullish(),
  "fleet_number": zod.number().min(postFetchAllUnitsBodyFleetNumberMin).nullish(),
  "serial_number": zod.string().regex(postFetchAllUnitsBodySerialNumberRegExp).nullish(),
  "availability_date": zod.string().date().nullish(),
  "manufacture_name": zod.string().regex(postFetchAllUnitsBodyManufactureNameRegExp).nullish(),
  "manufactured_year": zod.number().min(postFetchAllUnitsBodyManufacturedYearMin).nullish(),
  "status": zod.enum(['active', 'inactive', 'deleted']).nullish(),
  "license_plate_number": zod.string().regex(postFetchAllUnitsBodyLicensePlateNumberRegExp).nullish(),
  "description": zod.string().nullish(),
  "order_by": zod.enum(['fleetNumber', 'name', 'serialNumber', 'availabilityDate', 'manufactureName', 'manufacturedYear', 'status', 'licensePlateNumber']).nullish()
})

export const postFetchAllUnitsResponseDataItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllUnitsResponseDataItemFleetNumberMin = 0;
export const postFetchAllUnitsResponseDataItemSerialNumberRegExp = new RegExp('^[a-zA-Z0-9]+$');
export const postFetchAllUnitsResponseDataItemLicensePlateNumberRegExp = new RegExp('^[A-Z0-9\\s\\-]');
export const postFetchAllUnitsResponseDataItemOrganisationNameMin = 3;

export const postFetchAllUnitsResponseDataItemOrganisationNameMax = 127;

export const postFetchAllUnitsResponseDataItemOrganisationNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllUnitsResponseDataItemManufactureNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const postFetchAllUnitsResponseDataItemManufacturedYearMin = 1900;
export const postFetchAllUnitsResponseDataItemCategoryNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const postFetchAllUnitsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllUnitsResponseDataItemNameRegExp).optional(),
  "fleet_number": zod.number().min(postFetchAllUnitsResponseDataItemFleetNumberMin).optional(),
  "serial_number": zod.string().regex(postFetchAllUnitsResponseDataItemSerialNumberRegExp).optional(),
  "license_plate_number": zod.string().regex(postFetchAllUnitsResponseDataItemLicensePlateNumberRegExp).nullish(),
  "organisation": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().min(postFetchAllUnitsResponseDataItemOrganisationNameMin).max(postFetchAllUnitsResponseDataItemOrganisationNameMax).regex(postFetchAllUnitsResponseDataItemOrganisationNameRegExp).optional()
}).optional(),
  "availability_date": zod.string().date().nullish(),
  "manufacture_name": zod.string().regex(postFetchAllUnitsResponseDataItemManufactureNameRegExp).optional(),
  "manufactured_year": zod.number().min(postFetchAllUnitsResponseDataItemManufacturedYearMin).optional(),
  "status": zod.enum(['active', 'inactive', 'deleted']).optional(),
  "category": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllUnitsResponseDataItemCategoryNameRegExp).optional()
}).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postAddPropertyToUnitParams = zod.object({
  "id": zod.string()
})

export const postAddPropertyToUnitBody = zod.object({
  "properties": zod.array(zod.string())
})


export const postAddServicePropertyToUnitParams = zod.object({
  "id": zod.string()
})

export const postAddServicePropertyToUnitBody = zod.object({
  "service_properties": zod.array(zod.string())
})


export const postAddServiceHistoryToUnitParams = zod.object({
  "id": zod.string()
})

export const postAddServiceHistoryToUnitBody = zod.object({
  "service_histories": zod.array(zod.string())
})


export const getFetchUnitsByOrganisationParams = zod.object({
  "id": zod.string()
})

export const getFetchUnitsByOrganisationResponseNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchUnitsByOrganisationResponseFleetNumberMin = 0;
export const getFetchUnitsByOrganisationResponseSerialNumberRegExp = new RegExp('^[a-zA-Z0-9]+$');
export const getFetchUnitsByOrganisationResponseLicensePlateNumberRegExp = new RegExp('^[A-Z0-9\\s\\-]');
export const getFetchUnitsByOrganisationResponseOrganisationNameMin = 3;

export const getFetchUnitsByOrganisationResponseOrganisationNameMax = 127;

export const getFetchUnitsByOrganisationResponseOrganisationNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchUnitsByOrganisationResponseManufactureNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');
export const getFetchUnitsByOrganisationResponseManufacturedYearMin = 1900;
export const getFetchUnitsByOrganisationResponseCategoryNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const getFetchUnitsByOrganisationResponseItem = zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchUnitsByOrganisationResponseNameRegExp).optional(),
  "fleet_number": zod.number().min(getFetchUnitsByOrganisationResponseFleetNumberMin).optional(),
  "serial_number": zod.string().regex(getFetchUnitsByOrganisationResponseSerialNumberRegExp).optional(),
  "license_plate_number": zod.string().regex(getFetchUnitsByOrganisationResponseLicensePlateNumberRegExp).nullish(),
  "organisation": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().min(getFetchUnitsByOrganisationResponseOrganisationNameMin).max(getFetchUnitsByOrganisationResponseOrganisationNameMax).regex(getFetchUnitsByOrganisationResponseOrganisationNameRegExp).optional()
}).optional(),
  "availability_date": zod.string().date().nullish(),
  "manufacture_name": zod.string().regex(getFetchUnitsByOrganisationResponseManufactureNameRegExp).optional(),
  "manufactured_year": zod.number().min(getFetchUnitsByOrganisationResponseManufacturedYearMin).optional(),
  "status": zod.enum(['active', 'inactive', 'deleted']).optional(),
  "category": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchUnitsByOrganisationResponseCategoryNameRegExp).optional()
}).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})
export const getFetchUnitsByOrganisationResponse = zod.array(getFetchUnitsByOrganisationResponseItem)


export const postCreatePropertyBodyValueRegExp = new RegExp('.*[a-zA-Z0-9\\s\\-/\\.].*');


export const postCreatePropertyBody = zod.object({
  "value": zod.string().regex(postCreatePropertyBodyValueRegExp),
  "attribute_id": zod.string()
})


export const getFetchPropertyParams = zod.object({
  "id": zod.string()
})

export const getFetchPropertyResponseValueRegExp = new RegExp('[^a-zA-Z0-9\\s\\-\\/\\.]');
export const getFetchPropertyResponseAttributeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const getFetchPropertyResponse = zod.object({
  "id": zod.string().optional(),
  "value": zod.string().regex(getFetchPropertyResponseValueRegExp).optional(),
  "attribute": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchPropertyResponseAttributeNameRegExp).optional()
}).optional(),
  "created_at": zod.string().date().optional()
})


export const putUpdatePropertyParams = zod.object({
  "id": zod.string()
})

export const putUpdatePropertyBodyValueRegExp = new RegExp('.*[a-zA-Z0-9\\s\\-/\\.].*');


export const putUpdatePropertyBody = zod.object({
  "value": zod.string().regex(putUpdatePropertyBodyValueRegExp),
  "attribute_id": zod.string()
})


export const postFetchAllPropertiesQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllPropertiesResponseDataItemValueRegExp = new RegExp('[^a-zA-Z0-9\\s\\-\\/\\.]');
export const postFetchAllPropertiesResponseDataItemAttributeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const postFetchAllPropertiesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "value": zod.string().regex(postFetchAllPropertiesResponseDataItemValueRegExp).optional(),
  "attribute": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllPropertiesResponseDataItemAttributeNameRegExp).optional()
}).optional(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postCreatePropertyAttributeBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');


export const postCreatePropertyAttributeBody = zod.object({
  "name": zod.string().regex(postCreatePropertyAttributeBodyNameRegExp),
  "data_type": zod.enum(['string', 'integer', 'double', 'boolean', 'json'])
})


export const postFetchAllPropertyAttributesQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllPropertyAttributesBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');


export const postFetchAllPropertyAttributesBody = zod.object({
  "match_mode": zod.enum(['and', 'or']).optional(),
  "name": zod.string().regex(postFetchAllPropertyAttributesBodyNameRegExp).nullish(),
  "data_type": zod.enum(['string', 'integer', 'double', 'boolean']).nullish()
})

export const postFetchAllPropertyAttributesResponseDataItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const postFetchAllPropertyAttributesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllPropertyAttributesResponseDataItemNameRegExp).optional(),
  "data_type": zod.enum(['string', 'integer', 'double', 'boolean']).optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const getFetchServicePropertyParams = zod.object({
  "id": zod.string()
})

export const getFetchServicePropertyResponseValueRegExp = new RegExp('[^a-zA-Z0-9\\s\\-\\/\\.]');
export const getFetchServicePropertyResponseAttributeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const getFetchServicePropertyResponse = zod.object({
  "id": zod.string().optional(),
  "value": zod.string().regex(getFetchServicePropertyResponseValueRegExp).optional(),
  "attribute": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchServicePropertyResponseAttributeNameRegExp).optional()
}).optional(),
  "created_at": zod.string().date().optional()
})


export const putUpdateServicePropertyParams = zod.object({
  "id": zod.string()
})

export const putUpdateServicePropertyBodyValueRegExp = new RegExp('.*[a-zA-Z0-9\\s\\-/\\.].*');


export const putUpdateServicePropertyBody = zod.object({
  "value": zod.string().regex(putUpdateServicePropertyBodyValueRegExp),
  "attribute_id": zod.string()
})


export const postFetchAllServicePropertiesQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllServicePropertiesResponseDataItemValueRegExp = new RegExp('[^a-zA-Z0-9\\s\\-\\/\\.]');
export const postFetchAllServicePropertiesResponseDataItemAttributeNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const postFetchAllServicePropertiesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "value": zod.string().regex(postFetchAllServicePropertiesResponseDataItemValueRegExp).optional(),
  "attribute": zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllServicePropertiesResponseDataItemAttributeNameRegExp).optional()
}).optional(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postCreateServicePropertyBodyValueRegExp = new RegExp('.*[a-zA-Z0-9\\s\\-/\\.].*');


export const postCreateServicePropertyBody = zod.object({
  "value": zod.string().regex(postCreateServicePropertyBodyValueRegExp),
  "attribute_id": zod.string()
})


export const getFetchServicePropertyAttributeParams = zod.object({
  "id": zod.string()
})

export const getFetchServicePropertyAttributeResponseNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const getFetchServicePropertyAttributeResponse = zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(getFetchServicePropertyAttributeResponseNameRegExp).optional(),
  "data_type": zod.enum(['string', 'integer', 'double', 'boolean']).optional(),
  "validation": zod.array(zod.string()).optional(),
  "values": zod.array(zod.string()).optional()
})


export const postFetchAllServicePropertyAttributesQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAllServicePropertyAttributesBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');


export const postFetchAllServicePropertyAttributesBody = zod.object({
  "match_mode": zod.enum(['and', 'or']).optional(),
  "name": zod.string().regex(postFetchAllServicePropertyAttributesBodyNameRegExp).nullish(),
  "data_type": zod.enum(['string', 'integer', 'double', 'boolean']).nullish()
})

export const postFetchAllServicePropertyAttributesResponseDataItemNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const postFetchAllServicePropertyAttributesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllServicePropertyAttributesResponseDataItemNameRegExp).optional(),
  "data_type": zod.enum(['string', 'integer', 'double', 'boolean']).optional(),
  "validation": zod.array(zod.string()).optional(),
  "values": zod.array(zod.string()).optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postCreateServicePropertyAttributeBodyNameRegExp = new RegExp('.*[a-zA-Z0-9\\-/\'\\\\.,`_&()+\\s]+');


export const postCreateServicePropertyAttributeBody = zod.object({
  "name": zod.string().regex(postCreateServicePropertyAttributeBodyNameRegExp),
  "data_type": zod.enum(['string', 'integer', 'double', 'boolean', 'json']),
  "validation": zod.array(zod.string()).optional(),
  "values": zod.array(zod.string()).optional()
})


export const postFetchAllCategoryPropertyAttributesParams = zod.object({
  "id": zod.string()
})

export const postFetchAllCategoryPropertyAttributesResponseNameRegExp = new RegExp('^[a-zA-Z0-9\\-\\/\'\\\\.,`_&()+\\s]+$');


export const postFetchAllCategoryPropertyAttributesResponseItem = zod.object({
  "id": zod.string().optional(),
  "name": zod.string().regex(postFetchAllCategoryPropertyAttributesResponseNameRegExp).optional(),
  "data_type": zod.enum(['string', 'integer', 'double', 'boolean']).optional()
})
export const postFetchAllCategoryPropertyAttributesResponse = zod.array(postFetchAllCategoryPropertyAttributesResponseItem)


export const postFetchAllCasesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional(),
  "case_details": zod.array(zod.object({
  "id": zod.string().optional(),
  "name": zod.string().optional(),
  "business_identifier": zod.string().optional()
})).optional()
})).optional()
})


export const postUpdateUnitStatusParams = zod.object({
  "id": zod.string()
})

export const postUpdateUnitStatusBody = zod.object({
  "status": zod.enum(['active', 'inactive', 'deleted'])
})


export const postAddFileToContractParams = zod.object({
  "id": zod.string()
})

export const postAddFileToContractBody = zod.object({
  "signature_id": zod.string().uuid()
})


export const postAddSignatureToContractParams = zod.object({
  "id": zod.string()
})

export const postAddSignatureToContractBody = zod.object({
  "signature_id": zod.string().uuid()
})


export const getFetchAdjustmentParams = zod.object({
  "id": zod.string()
})

export const getFetchAdjustmentResponsePriceMin = 0;


export const getFetchAdjustmentResponse = zod.object({
  "id": zod.string().optional(),
  "price": zod.number().min(getFetchAdjustmentResponsePriceMin).optional(),
  "category": zod.enum(['percentage', 'amount']).optional(),
  "type": zod.enum(['discount', 'surcharge']).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})


export const postFetchAdjustmentsQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})

export const postFetchAdjustmentsResponseDataItemPriceMin = 0;


export const postFetchAdjustmentsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.string().optional(),
  "price": zod.number().min(postFetchAdjustmentsResponseDataItemPriceMin).optional(),
  "category": zod.enum(['percentage', 'amount']).optional(),
  "type": zod.enum(['discount', 'surcharge']).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})).optional(),
  "page": zod.number().optional(),
  "limit": zod.number().optional(),
  "total_pages": zod.number().optional()
})


export const postCreateAdjustmentBodyPriceMin = 0;


export const postCreateAdjustmentBody = zod.object({
  "price": zod.number().min(postCreateAdjustmentBodyPriceMin),
  "category": zod.enum(['percentage', 'amount']),
  "type": zod.enum(['discount', 'surcharge']),
  "description": zod.string().nullish()
})


export const postFetchAllAdjustmentsByTicketIdParams = zod.object({
  "id": zod.string()
})

export const postFetchAllAdjustmentsByTicketIdResponsePriceMin = 0;


export const postFetchAllAdjustmentsByTicketIdResponseItem = zod.object({
  "id": zod.string().optional(),
  "price": zod.number().min(postFetchAllAdjustmentsByTicketIdResponsePriceMin).optional(),
  "category": zod.enum(['percentage', 'amount']).optional(),
  "type": zod.enum(['discount', 'surcharge']).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})
export const postFetchAllAdjustmentsByTicketIdResponse = zod.array(postFetchAllAdjustmentsByTicketIdResponseItem)


export const postFetchAllAdjustmentsByUnitIdParams = zod.object({
  "id": zod.string()
})

export const postFetchAllAdjustmentsByUnitIdResponsePriceMin = 0;


export const postFetchAllAdjustmentsByUnitIdResponseItem = zod.object({
  "id": zod.string().optional(),
  "price": zod.number().min(postFetchAllAdjustmentsByUnitIdResponsePriceMin).optional(),
  "category": zod.enum(['percentage', 'amount']).optional(),
  "type": zod.enum(['discount', 'surcharge']).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})
export const postFetchAllAdjustmentsByUnitIdResponse = zod.array(postFetchAllAdjustmentsByUnitIdResponseItem)


export const postFetchAllAdjustmentsByOrganisationIdParams = zod.object({
  "id": zod.string()
})

export const postFetchAllAdjustmentsByOrganisationIdResponsePriceMin = 0;


export const postFetchAllAdjustmentsByOrganisationIdResponseItem = zod.object({
  "id": zod.string().optional(),
  "price": zod.number().min(postFetchAllAdjustmentsByOrganisationIdResponsePriceMin).optional(),
  "category": zod.enum(['percentage', 'amount']).optional(),
  "type": zod.enum(['discount', 'surcharge']).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})
export const postFetchAllAdjustmentsByOrganisationIdResponse = zod.array(postFetchAllAdjustmentsByOrganisationIdResponseItem)


export const postFetchAllAdjustmentsByContractIdParams = zod.object({
  "id": zod.string()
})

export const postFetchAllAdjustmentsByContractIdResponsePriceMin = 0;


export const postFetchAllAdjustmentsByContractIdResponseItem = zod.object({
  "id": zod.string().optional(),
  "price": zod.number().min(postFetchAllAdjustmentsByContractIdResponsePriceMin).optional(),
  "category": zod.enum(['percentage', 'amount']).optional(),
  "type": zod.enum(['discount', 'surcharge']).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})
export const postFetchAllAdjustmentsByContractIdResponse = zod.array(postFetchAllAdjustmentsByContractIdResponseItem)


export const postFetchAllAdjustmentsByArticleIdParams = zod.object({
  "id": zod.string()
})

export const postFetchAllAdjustmentsByArticleIdResponsePriceMin = 0;


export const postFetchAllAdjustmentsByArticleIdResponseItem = zod.object({
  "id": zod.string().optional(),
  "price": zod.number().min(postFetchAllAdjustmentsByArticleIdResponsePriceMin).optional(),
  "category": zod.enum(['percentage', 'amount']).optional(),
  "type": zod.enum(['discount', 'surcharge']).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})
export const postFetchAllAdjustmentsByArticleIdResponse = zod.array(postFetchAllAdjustmentsByArticleIdResponseItem)


export const postFetchAllAdjustmentsByAbstractActionIdParams = zod.object({
  "id": zod.string()
})

export const postFetchAllAdjustmentsByAbstractActionIdResponsePriceMin = 0;


export const postFetchAllAdjustmentsByAbstractActionIdResponseItem = zod.object({
  "id": zod.string().optional(),
  "price": zod.number().min(postFetchAllAdjustmentsByAbstractActionIdResponsePriceMin).optional(),
  "category": zod.enum(['percentage', 'amount']).optional(),
  "type": zod.enum(['discount', 'surcharge']).optional(),
  "description": zod.string().nullish(),
  "created_at": zod.string().date().optional()
})
export const postFetchAllAdjustmentsByAbstractActionIdResponse = zod.array(postFetchAllAdjustmentsByAbstractActionIdResponseItem)


export const postAddAdjustmentToUnitParams = zod.object({
  "id": zod.string(),
  "unit_id": zod.string()
})


export const postAddAdjustmentToTicketParams = zod.object({
  "id": zod.string(),
  "ticket_id": zod.string()
})


export const postAddAdjustmentToOrganisationParams = zod.object({
  "id": zod.string(),
  "organisation_id": zod.string()
})


export const postAddAdjustmentToContractParams = zod.object({
  "id": zod.string(),
  "contract_id": zod.string()
})


export const postAddAdjustmentToArticleParams = zod.object({
  "id": zod.string(),
  "article_id": zod.string()
})


export const postAddAdjustmentToActionParams = zod.object({
  "id": zod.string(),
  "action_id": zod.string()
})


export const postAddAdjustmentToRecipeParams = zod.object({
  "id": zod.string(),
  "recipe_id": zod.string()
})


/**
 * Export invoice data
 */
export const postExportInvoiceResponseItem = zod.object({

})
export const postExportInvoiceResponse = zod.array(postExportInvoiceResponseItem)


/**
 * Fetch a template by ID
 * @summary Get template by ID
 */
export const getFetchTemplateParams = zod.object({
  "id": zod.string().uuid()
})


/**
 * Update an existing template
 * @summary Update template
 */
export const putUpdateTemplateParams = zod.object({
  "id": zod.string().uuid()
})

export const putUpdateTemplateBody = zod.object({
  "date": zod.string().datetime().optional(),
  "content": zod.array(zod.object({

})).optional(),
  "draft": zod.boolean().optional(),
  "stylesheet_id": zod.string().uuid().nullish()
})


/**
 * Create a new template
 * @summary Create template
 */
export const postCreateTemplateBody = zod.object({
  "layout_id": zod.string().uuid(),
  "type": zod.enum(['handlebars']).optional(),
  "version": zod.string().optional(),
  "date": zod.string().datetime().optional(),
  "content": zod.array(zod.object({

})).optional(),
  "draft": zod.boolean().optional(),
  "components": zod.array(zod.object({

})).optional(),
  "theme_id": zod.string().uuid().nullish(),
  "stylesheet_id": zod.string().uuid().nullish()
})


export const postExecuteTemplateBody = zod.object({
  "ticket_id": zod.string().uuid().nullish(),
  "contract_id": zod.string().uuid().nullish(),
  "type": zod.enum(['contract', 'receipt', 'invoice', 'report']).optional(),
  "output": zod.enum(['pdf', 'mail', 'img']).optional()
})


/**
 * Generate a PDF from template
 * @summary Generate PDF from template
 */
export const postGenerateTemplatePdfBody = zod.object({

})


/**
 * Add a new version to an existing template
 * @summary Add new template version
 */
export const postAddNewVersionBody = zod.object({
  "template_id": zod.string().uuid(),
  "layout_id": zod.string().uuid(),
  "date": zod.string().datetime().optional(),
  "content": zod.array(zod.object({

})).optional(),
  "draft": zod.boolean().optional()
})


/**
 * Aggregates ticket data and sends to template service
 * @summary Fetch content for ticket template
 */
export const postFetchTemplateContentBody = zod.object({
  "ticket_id": zod.string().uuid(),
  "project": zod.string(),
  "layout": zod.string(),
  "version_date": zod.string().datetime().optional(),
  "theme": zod.string().nullish()
})


/**
 * Preview template with provided configuration
 * @summary Preview template
 */
export const postPreviewTemplateBody = zod.object({
  "type": zod.string(),
  "attributes": zod.array(zod.object({

})).optional(),
  "layout": zod.array(zod.object({

})).optional(),
  "theme": zod.array(zod.object({

})).nullish(),
  "stylesheet": zod.array(zod.object({

})).nullish(),
  "components": zod.array(zod.object({

})).optional(),
  "plugins": zod.array(zod.object({

})).optional(),
  "config": zod.array(zod.object({

})).nullish()
})


/**
 * Add a component to a template
 * @summary Add component to template
 */
export const putAddComponentToTemplateParams = zod.object({
  "id": zod.string().uuid()
})

export const putAddComponentToTemplateBody = zod.object({
  "component_id": zod.string().uuid()
})


/**
 * Fetch a component by ID
 * @summary Get component by ID
 */
export const getFetchComponentParams = zod.object({
  "id": zod.string().uuid()
})


/**
 * Update an existing component
 * @summary Update component
 */
export const putUpdateComponentParams = zod.object({
  "id": zod.string().uuid()
})

export const putUpdateComponentBody = zod.object({
  "name": zod.string(),
  "content": zod.array(zod.object({

})).optional()
})


/**
 * Fetch all components
 * @summary Get all components
 */
export const postFetchAllComponentsQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})


/**
 * Create a new component
 * @summary Create component
 */
export const postCreateComponentBody = zod.object({
  "name": zod.string(),
  "content": zod.array(zod.object({

}))
})


/**
 * Fetch a layout by ID
 * @summary Get layout by ID
 */
export const getFetchLayoutParams = zod.object({
  "id": zod.string().uuid()
})


/**
 * Update an existing layout
 * @summary Update layout
 */
export const putUpdateLayoutParams = zod.object({
  "id": zod.string().uuid()
})

export const putUpdateLayoutBody = zod.object({
  "name": zod.string()
})


/**
 * Fetch all layouts
 * @summary Get all layouts
 */
export const postFetchAllLayoutsQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})


/**
 * Create a new layout
 * @summary Create layout
 */
export const postCreateLayoutBody = zod.object({
  "name": zod.string(),
  "project_id": zod.string().uuid()
})


/**
 * Add a template to a layout
 * @summary Associate template with layout
 */
export const postAddTemplateToLayoutParams = zod.object({
  "id": zod.string().uuid()
})

export const postAddTemplateToLayoutBody = zod.object({
  "template_id": zod.string().uuid()
})


/**
 * Fetch a stylesheet by ID
 * @summary Get stylesheet by ID
 */
export const getFetchStylesheetParams = zod.object({
  "id": zod.string().uuid()
})


/**
 * Update an existing stylesheet
 * @summary Update stylesheet
 */
export const putUpdateStylesheetParams = zod.object({
  "id": zod.string().uuid()
})

export const putUpdateStylesheetBody = zod.object({
  "name": zod.string(),
  "content": zod.array(zod.object({

})).optional()
})


/**
 * Fetch all stylesheets
 * @summary Get all stylesheets
 */
export const postFetchAllStylesheetsQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})


/**
 * Create a new stylesheet
 * @summary Create stylesheet
 */
export const postCreateStylesheetBody = zod.object({
  "name": zod.string(),
  "content": zod.array(zod.object({

}))
})


/**
 * Add a template to a stylesheet
 * @summary Associate template with stylesheet
 */
export const postAddTemplateToStylesheetParams = zod.object({
  "id": zod.string().uuid()
})

export const postAddTemplateToStylesheetBody = zod.object({
  "template_id": zod.string().uuid()
})


/**
 * Fetch all themes
 * @summary Get all themes
 */
export const postFetchAllThemesQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})


/**
 * Create a new theme
 * @summary Create theme
 */
export const postCreateThemeBody = zod.object({
  "name": zod.string(),
  "content": zod.array(zod.object({

}))
})


/**
 * Update an existing theme
 * @summary Update theme
 */
export const putUpdateThemeParams = zod.object({
  "id": zod.string().uuid()
})

export const putUpdateThemeBody = zod.object({
  "name": zod.string(),
  "content": zod.array(zod.object({

})).optional()
})


/**
 * Add a template to a theme
 * @summary Associate template with theme
 */
export const postAddTemplateToThemeParams = zod.object({
  "id": zod.string().uuid()
})

export const postAddTemplateToThemeBody = zod.object({
  "template_id": zod.string().uuid()
})


/**
 * Fetch a project by ID
 * @summary Get project by ID
 */
export const getFetchProjectParams = zod.object({
  "id": zod.string().uuid()
})


/**
 * Update an existing project
 * @summary Update project
 */
export const putUpdateProjectParams = zod.object({
  "id": zod.string().uuid()
})

export const putUpdateProjectBody = zod.object({
  "name": zod.string()
})


/**
 * Fetch all projects
 * @summary Get all projects
 */
export const postFetchAllProjectsQueryParams = zod.object({
  "page": zod.number().nullish(),
  "limit": zod.number().nullish()
})


/**
 * Create a new project
 * @summary Create project
 */
export const postCreateProjectBody = zod.object({
  "name": zod.string()
})


/**
 * This endpoint sends an payment request
 * @summary Send an payment request
 */
export const postSendPaymentRequestBody = zod.object({
  "ticket_id": zod.string(),
  "project": zod.string(),
  "layout": zod.string(),
  "version_date": zod.string().nullish(),
  "theme": zod.string().nullish()
})


export const postCompareOfferAndTicketParams = zod.object({
  "id": zod.string()
})


export const postInvoiceTicketParams = zod.object({
  "id": zod.string()
})

export const postInvoiceTicketBody = zod.any()


/**
 * This endpoint sends a contract
 * @summary Send a contract
 */
export const postSendContractBody = zod.object({
  "contract_id": zod.string(),
  "project": zod.string(),
  "layout": zod.string(),
  "theme": zod.string().nullish(),
  "version_date": zod.string()
})


/**
 * This endpoint sends a receipt
 * @summary Send a receipt
 */
export const postSendReceiptBody = zod.object({
  "ticket_id": zod.string(),
  "project": zod.string(),
  "layout": zod.string(),
  "version_date": zod.string().nullish(),
  "theme": zod.string().nullish()
})


/**
 * This endpoint sends a damage specification
 * @summary Send a damage specification
 */
export const postSendDamageSpecificationBody = zod.object({
  "ticket_id": zod.string(),
  "project": zod.string(),
  "layout": zod.string(),
  "version_date": zod.string().nullish(),
  "theme": zod.string().nullish()
})


/**
 * This endpoint sends a rental damage report
 * @summary Send a rental damage report
 */
export const postSendRentalDamageReportBody = zod.object({
  "ticket_id": zod.string(),
  "project": zod.string(),
  "layout": zod.string(),
  "version_date": zod.string().nullish(),
  "theme": zod.string().nullish()
})


/**
 * This endpoint sends an offer
 * @summary Send an offer
 */
export const postSendOfferBody = zod.object({
  "ticket_id": zod.string(),
  "project": zod.string(),
  "layout": zod.string(),
  "version_date": zod.string().nullish(),
  "theme": zod.string().nullish()
})


/**
 * This endpoint sends a service report
 * @summary Send a service report
 */
export const postSendServiceReportBody = zod.object({
  "ticket_id": zod.string(),
  "project": zod.string(),
  "layout": zod.string(),
  "version_date": zod.string().nullish(),
  "theme": zod.string().nullish()
})


